import { DatePipe } from '@angular/common';
import {
    AfterContentChecked,
    AfterViewInit, Component, ElementRef,
    EventEmitter, Input,
    OnDestroy, OnInit,
    Output, TemplateRef, ViewChild
} from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { orderBy, sortBy } from 'lodash';
import * as moment from 'moment';
import { FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import { ModalOptions } from 'ngx-bootstrap';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal/bs-modal.service';
import { CookieService } from 'ngx-cookie-service';
import { MaskPipe } from 'ngx-mask';
import { Modal } from 'ngx-modal';
import { NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs/Subscription';
import { error } from 'util';
import { environment } from '../../../environments/environment';
import { ContactTypeConstants } from '../../common/constants/contact-type.constants';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { AccountRestrictionStatus } from '../../common/enums/account-restricted.enum';
import { ContactTypeValue } from '../../common/enums/contact-type.value.enum';
import { MemberPreferenceType } from '../../common/enums/member-preference.enum';
import { Permission } from '../../common/enums/permission.enum';
import { PreferenceValues } from '../../common/enums/preference-value.enum';
import { AuthorizationPipe } from '../../common/pipes/authorization.pipe';
import { DistributorIdFormatPipe } from '../../common/pipes/distributor-id-format.pipe';
import { TranslateKey } from '../../common/pipes/translate-key.pipe';
import { MemberActivityLogType, RowStatus } from '../../shared/common/enumerations';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CommonConstant } from '../../shared/constants/common.constants';
import { AddressVisibility } from '../../shared/interface/address-visibility';
import { Country } from '../../shared/interface/country.interface';
import { StoreConfig } from '../../shared/interface/StoreConfig.interface';
import { UserInfo } from '../../shared/interface/user-info.interface';
import { WholesaleQualifiedResponse } from '../../shared/interface/wholesaleQualifiedResponse.interface';
import { FboInfoModel } from '../../shared/models/fbo-info-model';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { DataShareService } from '../../shared/services/data.service';
import { MessageService } from '../../shared/services/message.service';
import { CustomValidators } from '../../shared/Utils/custom-validator';
import { DuplicateGovernmentIdValidator } from '../../shared/Utils/duplicate-government-id-validator';
import { Utils } from '../../shared/Utils/utils';
import { EncryptionService } from '../../sso/encryption.service';
import { AllowDivElement, AllowIDAttribute } from '../ckeditor5/src/CustomCKEditor';
import { CommonMessage } from '../common/common-messages';
import { BusinessEntityType, Constants, DefaultProfileImage, GovernmentIDType, IsoCodeThree,PCSponsorConstants, MemberNoteType, MemberOrderType, MemberType, UserTitleType } from '../common/constants';
import { BusinessEntityIdType, MemberLevel, MemberStatusId } from '../common/enumerations';
import { ComposeEmailTicketConstants } from '../constants/compose-email.constants';
import { DateConstants } from '../constants/date.constants';
import { Flp360StatusConstants } from '../constants/flp360-status.constants';
import { IdentificationTypeConstant } from '../constants/identification-type.constant';
import { ImpersonateUserConstants } from '../constants/impersonate-user.constants';
import { PersonalInfoFormConstants } from '../constants/personal-info-form-property.constants';
import { ResponseStatus } from '../constants/response-status-constants';
import { StatusConstants } from '../constants/status.constants';
import { PhoneUpdateMessageConstants } from '../constants/update-phone-message.contants';
import { EcheckPhoneNumberValidation } from '../directive/echeck-phone-validation';
import { OperatingCountryEnums } from '../enums/countries.enums';
import { Department } from '../enums/department-type.enum';
import { DisplaySectionId, DocumentLibraryMemberId, Portal } from '../enums/document-library-member-id.enum';
import { Flp360Status } from '../enums/flp360-status.enum';
import { GovernmentIdentificationType } from '../enums/government-identification-type.enum';
import { MemberActivity } from '../enums/member-activity-type.enum';
import { MemberStatus } from '../enums/member-status.enum';
import { MemberTitleExtEnums } from '../enums/member-title.enum';
import { MemberTypeEnum } from '../enums/member-type.enum';
import { SubscriptionStatusEnum } from '../enums/subscription-status.enum';
import { NotificationType } from '../enums/notification-types.enum';
import { AddressType, PaymentType } from '../enums/order-source-type';
import { RetailSubscriptionErrorMessages, RetailSubscriptionMessages, StoreRetailSubscriptionEnum } from '../enums/retail-subscription.enum';
import { SelectEnum } from '../enums/selection.enum';
import { SponsorChangeType, SponsorType } from '../enums/sponsor-change-type.enum';
import { SponsorSearchOption } from '../enums/sponsor-search-option.enum';
import { Status } from '../enums/ticket-status.enum';
import { Priority, SourceType } from '../enums/ticket-type.enum';
import { VatPayerOption } from '../enums/vat_payer_option.enum';
import { AccountNotification } from '../interface/accountNotification';
import { AccountNotificationRequest } from '../interface/accountNotificationRequest';
import { PersonalAch } from '../interface/ach-payment/payment-achrequest.interface';
import { ActivityLogKey } from '../interface/activityLogKey';
import { Address } from '../interface/address';
import { AddressInformation } from '../interface/address-detail-info';
import { AppCountryConfig } from '../interface/app-config';
import { Autoship } from '../interface/autoship';
import { AutoshipMemberInfo } from '../interface/autoship-memberinfo';
import { CCSnapshot } from '../interface/cc-snapshot';
import { CheckoutConfig } from '../interface/checkout-config.interface';
import { ComposeEmail } from '../interface/compose-email.interface';
import { CountryLevelValidations } from '../interface/country-level-validations.response';
import { DiscountPercentageResponse } from '../interface/discount-percentage.response.interface';
import { DocumentLibrary } from '../interface/enrollment/document-library.interface';
import { PersonalInfoFormFields } from '../interface/enrollment/personal-info-form-fields.interface';
import { SponsorDetails } from '../interface/enrollment/sponsor-details.interface';
import { SponsorInformation as SponsorInfo } from '../interface/enrollment/sponsor-information.interface';
import { SponsorSearchRequest } from '../interface/enrollment/sponsor-search-request.interface';
import { SponsorSearchResponse } from '../interface/enrollment/sponsor-search-response.interface';
import { FBOBusinessEntity } from '../interface/fbo-business-entity';
import { GovernmentIDentifcation } from '../interface/goverment-id-update';
import { IdentificationType } from '../interface/identification-types.interface';
import { MemebrCCOverrideModel } from '../interface/member-cc-override-request.interface';
import { MemebrCCOverrideResponse } from '../interface/member-ccoverride-response.interface';
import { MemberLevelInfo } from '../interface/member-level-info';
import { MemberBasicInfo } from '../interface/memberbasicinfo';
import { MemberPrefernceModel } from '../interface/memberpreference-model';
import { PersonalInfoConfig } from '../interface/personal-info-config.interface';
import { ProfileInformation } from '../interface/profile-info';
import { SnapPayload, SnapshotDetails } from '../interface/snapshot-details';
import { SponsorChangeRequest } from '../interface/sponsor-change-request';
import { SponsorInformation } from '../interface/sponsor-information';
import { TagInputValue } from '../interface/tag-input-value.interface';
import { DistributorInfo } from '../interface/ticketingsystem/distributor-info';
import { VerifyAccountModel } from '../interface/verify-account-exits-model';
import { AccountModel } from '../models/account-model';
import { DeleteModal } from '../models/delete-modal';
import { MemberLevelModel } from '../models/member-level-model';
import { memberWholesaleQualifiedRequestModel } from '../models/memberTypeorLevel-model';
import { PaymentComponentSettings } from '../models/payments/payment.model';
import { UnLockInfoModel } from '../models/unLock-info-model';
import { UnLockRequest } from '../models/unLock-Request';
import { AchService } from '../services/ach.service';
import { AppConfigService } from '../services/app-config.service';
import { CheckoutConfigService } from '../services/checkout-config.service';
import { ConfigurationService } from '../services/configuration.service';
import { CustomerService } from '../services/customer.service';
import { DepartmentService } from '../services/department.service';
import { DocumentService } from '../services/document.service';
import { EnrollService } from '../services/enrollment.service';
import { OrderService } from '../services/order.service';
import { RetailSubscriptionService } from '../services/retail-subscription.service';
import { SponsorService } from '../services/sponsor.service';
import { BonusInfo } from './../interface/bonus-info.interface';
import { PersonalInfoConfigService } from './../services/personal-info-config.service';
import { PersonalMessageService } from './../services/personal-schema-form.service';
import { OpCoRetailSubscriptionEnum } from '../enums/op-co-retail-subscription.enum';
import { RetailSubscription } from '../interface/retail-subscription';
import { MemberRetailSubscriptionDetail } from '../interface/member-retail-subscription-detail';
import { flattenStyles } from '@angular/platform-browser/src/dom/dom_renderer';
import { MemberRetailProgramSubscriptionModel } from '../interface/member-retail-program-subscription-model';
import { Map, isThisTypeNode } from 'typescript';
import { BusinessEntityAddress, RetailSubscriptionHistoryList } from '../interface/retail-subscription-history.interface';
import { CurrencyTransformPipe } from '../../common/pipes/currency-format.pipe';
import { MemberMetaData } from '../interface/enrollment/member-metadata.interface';
import { BondedWarehouseProjectValue } from '../../common/enums/bonded-warehouse-project.enum';
import { MemberMetaDataEnum } from '../enums/member-meta-data.enum';
import { FBOProfileUpdateEnum } from '../../common/enums/fboprofile-update-enum';
import { catchError } from 'rxjs/operators/catchError';
import { of } from 'rxjs/observable/of';
import { MapType } from '@angular/compiler/src/output/output_ast';
import { SSO } from '../../sso/sso.constants';
import { CountryCodeConstant } from '../common/constants';

declare var Chargebee: any;


declare var ClassicEditor: any;
@Component({
    selector: 'fboprofile',
    templateUrl: '../templates/template1/views/fboprofile.component.html',
    styleUrls: [
        '../templates/template1/themes/default/css/profile-info.less','../templates/template1/themes/default/less/print-preview.less'
    ],
    providers: [AuthorizationPipe, CustomerService, DatePipe, DistributorIdFormatPipe]
})


export class FBOProfileComponent implements OnInit, AfterContentChecked, AfterViewInit, OnDestroy {
    @ViewChild('createNotesInput') createNotesInput: ElementRef;
    @Input() fboid: string;
    @Input() memberType: string;
    @Input() orderType: string;
    @Input() fboProfileDetail: ProfileInformation;
    _id: string; // stores fbo id
    sortColumn: String;
    isDesc = false;
    ccSnapshot: CCSnapshot;
    isCCSnapshot = false;   // to check whether we are sorting ccSnapshot or autoship table
    isLoading = false;
    valueZero = 0;
    languageId: number;
    memberStatus;
    isSuspendedStatus = false;
    memberAllowedCountries: any;
    @Output() changeTab = new EventEmitter<number>();
    @Output() paymentMethodTab = new EventEmitter<number>();
    @Output() customerReportTab = new EventEmitter<number>();
    @Output() distributorInfo: EventEmitter<any> = new EventEmitter();
    @Output() autoshipTabInfo: EventEmitter<any> = new EventEmitter();
    @Output() homeCountryInfo = new EventEmitter<string>();
    @Output() operatingCountryInfo = new EventEmitter<string>();
    FBODetailPermissions: any[] = [Permission.FBO_PROFILE_VIEW, Permission.FBO_ORDER_HISTORY_VIEW,
    Permission.FBO_AUTOSHIP_DETAILS_VIEW, Permission.FBO_PAYMENT_METHODS_VIEW,
    Permission.FBO_DOWNLINE_VIEW, Permission.FBO_REPORTS_VIEW, Permission.MANAGE_TICKETS_VIEW,
    Permission.RESET_PASSWORD, Permission.Unlock_Account,
    Permission.CHANGE_OPERATING_COMPANY_ALLOW, Permission.CHANGE_REGISTERED_ADDRESS_ALLOW,
    Permission.FBO_CHANGE_SPONSER, Permission.FBO_MEMBER_TYPE, Permission.FBO_OVERRIDE_MAXIMUM_CC_FBO,
    Permission.FBO_CHANGE_GOVERNMENT_ID, Permission.STORE_BUSINESS_ENTITY_MANAGE,
    Permission.STORE_BUSINESS_ENTITY_VIEW, Permission.MEMBER_STATUS_EDIT, Permission.MEMBER_STATUS_VIEW,
    Permission.MANAGE_FBO_DOB_CREATE, Permission.MANAGE_ACCOUNT_NOTIFICATION, Permission.UPDATE_EMAIL_ADDRESS, Permission.MANAGE_MEMBER_PREFERENCES,
    Permission.GENERAL_SPONSOR_CHANGE, Permission.FBO_VIEW_GOVERNMENT_ID, Permission.FBO_MANAGE_GOVERNMENT_ID];
    accountRestrictionPermission: any[] = [Permission.ACCOUNT_RESTRICTED_VIEW, Permission.ACCOUNT_RESTRICTED_MANAGE];
    bondedWarehouseProjectPermission: any[] = [Permission.Bonded_Warehouse_Project_VIEW, Permission.Bonded_Warehouse_Project_MANAGE];

    public reviewModel: MemberLevelModel;
    distributorInfoObj: DistributorInfo;
    autoshipMemberInfo: AutoshipMemberInfo;
    personalInfoFormValidations: PersonalInfoFormFields;
    userId: number;
    deleteModal: DeleteModal;
    cookieService: CookieService = new CookieService(document);
    activeAutoShipInfo: any[] = [];
    memberDiscountPercentage: DiscountPercentageResponse;
    inactiveAutoShipInfo: any[] = [];
    impersonationPermission: any[] = [Permission.IMPERSONATION];
    fboInfo: FboInfoModel[] = [];
    distributorDefaultCardPaymentInfo: any[] = [];
    distributorDefaultECheckPaymentInfo: any[] = [];
    memberLevels: any;
    memberTypeEnum = MemberTypeEnum;
    subscriptionStatusEnum = SubscriptionStatusEnum;
    homeCountry: string;
    operatingCountry: string;
    selectedCountry: string;
    isTitanEnabled = false;
    isGuestMemberType = false;
    memberOptinCheck: boolean;
    dateNow: Date;
    minDate: Date;
    autoshipPermission: boolean;
    fboPaymentPermission: boolean;
    fboDownlinePermission: boolean;
    resetPasswordPermission: boolean;
    allowResetAccountPermission: boolean;
    isfirstPurchaseDateEmpty: boolean;
    unlockPermission: boolean;
    homeCountryPermission: boolean;
    allowFullNamePermission: boolean;
    memberTypePermission: boolean;
    monthlyCCLimitPermission: boolean;
    govermentIdentificationPattern: any[];
    businessEditEntityPermission: boolean;
    businessViewEntityPermission: boolean;
    statusEditPermission: boolean;
    changeOperatingCountry: boolean;
    viewMemberLevelAllowed: boolean;
    countries: Country[];
    states: any[];
    statesModal: any[];
    memberGovernmentIdentifiations: any[];
    unlockRequest: any;
    userInfo: UserInfo;
    attachmentsLength: number;
    uploader: any;
    unlockForm: FormGroup;
    changeMemberNameForm: FormGroup;
    changeSponsorForm: FormGroup;
    changeMemberTypeandLevelForm: FormGroup;
    overrideMonthlyCCLimitForm: FormGroup;
    changeGovtIDForm: FormGroup;
    updateGovIDForm: FormGroup;
    businessEntityForm: FormGroup;
    statusForm: FormGroup;
    emailForm: FormGroup;
    retailSubscriptionForm: FormGroup;
    isSubmitted = false;
    isRetailFormSubmitted: boolean = false;
    isUnLockSubmitted = false;
    isEditGovId = false;
    unlockInfo: any;
    memberWholesaleQualifiedRequest: any;
    isAccountLocked = false;
    ssn: any;
    editEcheckInfo: any;
    identificationTypes: IdentificationType[];
    governmentIdentificationTypes: IdentificationType[];
    @Input('autofocus') isFocused: boolean;
    uploadResponse: any = [];
    isUpdateButtonClicked = false;
    isCancelButtonClicked = false;
    storeId: number;
    tempPassword: string;
    isDisplaySearchAddressSection = false;
    sponsorDetails: SponsorDetails[] = [];
    hasAllowEcheckPermission = false;
    ManagePersonalCheckPermission: any[] = [
        Permission.MANAGE_PERSONAL_CHECK
    ];
    isBetaEnabled = false;
    enableSponsorChange = environment.enableSponsorChange;
    isEditEcheck: boolean;
    editBlxBonusInfo: boolean = false;
    isCreditAssessmentEnabled: boolean = true;
    isDirectDebitEnabled: boolean = false;
    isSingleDebitEnabled: boolean = false;
    languagecode: string;
    displayIBANAckError: boolean = false;
    disableBonusInfoChecks: boolean = false;
    signatureValue: any;
    emailSignatureResponse = [];
    creditAssessmentApproved: boolean = true;
    AmazonSubscriptionEnabledOperatingCountries = CommonConstant.AmazonSubscriptionEnabledOperatingCountries && CommonConstant.AmazonSubscriptionEnabledOperatingCountries.length > 0
        ? CommonConstant.AmazonSubscriptionEnabledOperatingCountries : [];
    enableAmazonSubscriptionFlag: boolean = false;
    monthAndYear = [
        { monthName: "January", value: 1 }, { monthName: "February", value: 2 }, { monthName: "March", value: 3 },
        { monthName: "April", value: 4 }, { monthName: "May", value: 5 }, { monthName: "June", value: 6 },
        { monthName: "July", value: 7 }, { monthName: "August", value: 8 }, { monthName: "September", value: 9 },
        { monthName: "October", value: 10 }, { monthName: "November", value: 11 }, { monthName: "December", value: 12 }
      ];
      commonConstants = CommonConstant;
    memberDetails: any;
    accountRestriction: boolean = false;
    updateHomeCountryVat: boolean = false;
    deleteHomeCountryVat: boolean = false;
    updateBusinessEntity: boolean = false;
    @ViewChild('resetPassword') resetPasswordPopup: Modal;
    @ViewChild('resetFlp360Password') flp360ResetPasswordPopup: Modal;
    @ViewChild('unlock') unlockPopup: Modal;
    @ViewChild('changeSponsor') changeSponsorPopup: Modal;
    @ViewChild('changeStatus') changeStatusPopup: Modal;
    @ViewChild('changeMemberTypeandLevel') changeMemberTypeandLevelPopup: Modal;
    @ViewChild('overrideMonthlyCCLimit') overrideMonthlyCCLimitPopup: Modal;
    @ViewChild('changeGovtID') changeGovtIDPopup: Modal;
    @ViewChild('changeBusinessEntity') changeBusinessEntityPopup: Modal;
    @ViewChild('changeDOB') changeDOBPopup: Modal;
    @ViewChild('accountNotificationChange') accountNotificationChangePopup: Modal;
    @ViewChild('updateEmail') changeEmailPopup: Modal;
    @ViewChild('updatePhoneNumber') updatePhoneNumberPopup: Modal;
    @ViewChild('updateMemberName') updateMemberNamePopup: Modal;
    @ViewChild('changeMemberPreference') changeMemberPreference: Modal;
    @ViewChild('showMoreInformation') showMoreInformationPopup: Modal;
    @ViewChild('govIdRemoveConfirmation') govIdRemoveConfirmationPopup: Modal;
    @ViewChild('achPaymentPopup') achPaymentPopup: Modal;
    @ViewChild('paymentFormBtn') paymentFormBtn: ElementRef;
    @ViewChild('bonusInformationModal') bonusInformationPopup: Modal;
    @ViewChild('blxBonusInformationModal') blxBonusInformationModalPopup: Modal;
    @ViewChild('deleteBonusInfoConfirmationPopup') deleteBonusInfoConfirmationPopup: Modal;
    @ViewChild('composeEmail') composeEmailPopup: Modal;
    @ViewChild('singleAndDirectDebitPaymentModal') singleAndDirectDebitPaymentModal: Modal;
    @ViewChild('retailSubscriptionModal') retailSubscriptionPopup: Modal;
    @ViewChild('cancelRenewalModal') cancelRenewalPopup: Modal;
    @ViewChild('cancelSubscriptionModal') cancelSubscriptionPopup: Modal;
    @ViewChild('viewSubscriptionHistoryModal') viewSubscriptionHistoryPopup: Modal;
    @ViewChild('updatePCSponsorStatus') updatePCSponsorStatusPopup: Modal;
    isEnrollmentDateExists = false;
    unLockData: any[] = [];
    countriesList: any;
    stateId: any;
    countryId: any;
    enableHomeCountry: Boolean = true;
    errorCodes: any;
    addressDetailId: number;
    memberAddressDetailId: number;
    memberRankLevels: any[];
    enableMemberTypeOrLevel = true;
    memberTypeName: Array<MemberTypeData> = [];
    memberLevelList: Array<MemberLevelData> = [];
    memberLevelDisable: boolean;
    showCCSnapshotSection: boolean;
    authorizedCountries: any;
    governmentIdentification: any;
    message: string;
    isDistributor = false;
    enableChangeStatus = false;
    enableChangeHomeCountry: boolean;
    enableGovernmentID: boolean;
    fboBusinessEntity: FBOBusinessEntity = new FBOBusinessEntity();
    businessEntityState;
    businessEntityCountry;
    businessFormSubmitButton = false;
    duplicateCheck = false;
    momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;
    externalMemberStatus;
    statusDropdownItems;
    PCSponsorshipStatus = ['Yes','No'];
    addressFirstLine: string;
    addressSecondLine: string;
    changeDOBForm: FormGroup;
    fboProfileCountry: string;
    accountNotificationForm: FormGroup;
    enableChangeDOB = false;
    updateDOBPermission = false;
    accountNotificationPermission = false;
    changeEmailPermission = false;
    emailMismatch = false;
    isNewEmail = false;
    resetPasswordForm: FormGroup;
    selectEnum = SelectEnum;
    phoneNumberFormat: string;
    accountNotification: AccountNotificationRequest;
    showNewCCBlock: boolean;
    titanEnabledCountries: Country[];
    storeInfo: StoreConfig;
    memberCCOverrideResponse: MemebrCCOverrideResponse;
    memberCCMinDate: Date;
    enableMemberCCOverride: boolean;
    showMemberLevel: boolean;
    isFlp360Enabled = false;
    isFlp360Enrolled = 'No';
    flp360Status: any;
    flp360EnrollmentDate: Date;
    flp360AccountAvailable = false;
    flp360TitanWebsiteEnabled: boolean = environment.flp360TitanWebsiteEnabled;
    flp360ImpersonationPermission: any[] = [Permission.FLP360_IMPERSONATION];
    flp360ResetPasswordPermission: any[] = [Permission.FLP360_RESET_PASSWORD];
    updatePhoneNumberPermission: boolean;
    updatePhoneNumberForm: FormGroup;
    contactTypes = ContactTypeConstants.phoneTypes;
    basicInfo: MemberBasicInfo;
    showUpdatePhoneModal: boolean;
    isMemberRecordExistInTitan = false;
    nameUpdate: boolean;
    shoppingCartCount = 0;
    viewShoppingBagPermission: boolean;
    flp360ResetPasswordForm: FormGroup;
    customerServiceAccessLevelId: number = AccessLevel.Customer_Service;
    flp360Statuses: any[] = [];
    changeMemberPreferencesPermission = false;
    myMemberPreferences: MemberPrefernceModel[] = [];
    appConfig: AppCountryConfig;
    disableBusinessEntityForFbo = false;
    phoneNumbers = [];
    ccSnapshot4CCActive: SnapshotDetails = new SnapshotDetails();
    ccSnapshotLevel: SnapshotDetails = new SnapshotDetails();
    enableFBOLogin = true;
    isDisplayMemberTitle = false;
    mailingSchemaUrl: string;
    checkoutConfig: CheckoutConfig;
    bsModalRef: BsModalRef;
    corporateSiteUrl = environment.corporateSiteUrl;
    corporateSiteName = this.corporateSiteUrl.replace("https://", "");
    deleteGovId: any = null;
    governmentIdValidationInProgress: boolean = false;
    governmentIdValueEditIndexes: any = [];
    duplicateGovIdErrorMessage: any = '';
    paymentAchForm: FormGroup;
    addNewAchCard: boolean;
    selectedAchInfo: PersonalAch;
    billingAddressInfo: any;
    paymentComponentSettings: PaymentComponentSettings = new PaymentComponentSettings();
    achPaymentInfo: any;
    achToken: string;
    showPayByAccountCheck: boolean;
    changeGeneralSponsorPermission = false;
    isAgentAllowedToChangeSponsor = false;
    sponsorChangeSuccess = false;
    sponsorChangeError = false;
    sponsorPollCount = 0;
    sponsorMaxPollCount: number = environment.longPollCount;
    newSponsor: SponsorInfo;
    sponsorNotFoundError = false;
    statusActive = StatusConstants.ACTIVE;
    governmentIdViewPermission = false;
    governmentIdManagePermission = false;
    composeEmailPermission: boolean;
    composeEmailForm: FormGroup;
    public emailValidators = [this.must_be_email.bind(this)];
    public errorMessages = ComposeEmailTicketConstants.ERROR_MESSAGE;
    subjectMaxLength: any = { maxLength: 500 };
    showToAddressValidation = true;
    showMaxFileSizeValidation = false;
    composeEmailattachmentMaxSize: number = environment.draftEmailAttachmentsSize;
    statuses: any[] = [];
    showEmailErrorMessage: boolean;
    bodyStr: string;
    departments;
    uploadedImageUrlArr: any = [];
    uploadedImageLength: number = 0;
    composeEmailRequest: ComposeEmail;
    submitCompleted = false;
    sourceTypesEnum: any = SourceType;
    showErrorMsg = false;
    isSendingEmail = false;
    ticketTypes: any[];
    subTypes: any[];
    businessEntities: any;
    operatingCountries: any;
    hasFboBonusInfoViewPermission: boolean = false;
    hasFboBonusInfoDeletePermission: boolean = false;
    hasFboBonusInfoManagePermission: boolean = false;
    memberBonusInfo: BonusInfo = null;
    bonusInfoSchemaUrl: string = null;
    editBonusInfo: boolean = false;
    personalInfoSettings: PersonalInfoConfig;
    bonusInfoBankCode: string;
    liveBonusinformation: BonusInfo;
    bonusInfoFormValidated: boolean;
    isDeleteBonusInfo: boolean = false;
    homeStoreId: any;
    preloadMemberBonusInfo: BonusInfo;
    customSelectSubscription: Subscription;
    showSingleAndDirectDebitMenu: boolean = false;
    agreeTAndC: boolean = false;
    bonusInfoAgreements: DocumentLibrary[] = [];
    showSingleDebit: boolean = false;
    showDirectDebit: boolean = false;
    updateOnlyBonusInfoPaymentMethods: boolean;
    bonusInfoChanged: boolean;
    validBonusInfo: boolean;
    validIbanInfoSubscription: Subscription;
    invalidIban: boolean;
    validBonusInfoSubscription: Subscription;
    singleAndDirectDebitManagePermission: boolean;
    singleAndDirectDebitViewPermission: boolean;
    editSingleAndDirectDebitPayment: boolean;
    vatPayerOption = VatPayerOption;
    hasRetailSubscriptionAccess: boolean = false;
    isStoreRetailSubscriptionEnabled: boolean = false;
    isRetailSubscriptionLogin: boolean = false;
    memberRetailSubscriptionId: number;
    chargeBeePlan: any;
    languages: any = [];
    memberRetailSubscriptionDetails: MemberRetailSubscriptionDetail[] = [];
    memberRetailSubscriptionDetail: MemberRetailSubscriptionDetail = new MemberRetailSubscriptionDetail();
    vatId: string;
    retailLanguage: string;
    configId: number | string;
    retailSubscriptionLanguageId: number;
    languageLocale: string;
    isMemberTypeDistributor: boolean = false;
    confirmationClass: string;
    confirmationMessage: string;
    showConfirmationMessage: boolean = false;
    homeCountryId: number;
    showBillingHistoryLink: boolean = false;
    showSubscriptionHistoryLink: boolean = false;
    isResubscribe: boolean = false;
    retailSubscriptionHistoryResponse: RetailSubscriptionHistoryList[] = [];
    loadRetailSubscriptionHistory: RetailSubscriptionHistoryList[] = [];
    skipCount = 5;
    statusChanged: boolean = false;
    @ViewChild('accountRestrictionModal') accountRestrictionModal: Modal;
    accountStatus: any;
    isAccountChecked: boolean = false;
    accountViewPermission: boolean;
    accountManagePermission: boolean;
    bondedWarehouseProjectViewPermission: boolean;
    bondedWarehouseProjectManagePermission: boolean;
    hideBusinessEntityName: boolean = false;
    isSubscriptionCreatedInChargebee :boolean = false;
    isPrefferedCustomer: boolean = false;
    isFpcEligibleForPcSponsor: boolean = false;
    isBonusInfo: boolean;
    @ViewChild('bondedWarehouseProjectModal') bondedWarehouseProjectModal: Modal;
    prevBondedWarehouseProjectSelected: boolean;
    disableBondedWarehouseProject: boolean;
    @ViewChild('bwpConfirmationModal') bwpConfirmationModal: Modal;
    bondedWarehouseProjectSelected: boolean;
    businessEntityBWP: boolean;
    vatIdBWP: boolean;
    bwpDisableMessage: boolean;
    selectedStatus: string;
    updateAccessToTitanCounty: any = false;
    pcSponsorEligibleStatus: string;
    showUpdatePCSponsor: boolean;
    updatedStatus: boolean;
    pCSponsorshipParticipationType: any;
    enableUpdatePCSponsor: any;
    businessEntityInfo: any;
    profileImage: string;
    enableSubmit: boolean = false;
    isUserCreatedInKeycloak: boolean = false;
    enableFLP360ImpersonationForFPC: boolean = environment.enableFLP360ImpersonationForFPC;
    notification: AccountNotification;
    displayNotification: boolean;
    disableStatusButton: boolean = true;
    disableNameButton: boolean = false;
    disableEmailButton:boolean = true;
    disableBonusButton:boolean = true;
    disableBusinessEntityButton:boolean = false;
    addressDetail :AddressInformation;
    constructor(private _customerservice: CustomerService
        , private _commonService: CommonService
        , private _customerService: CustomerService
        , private _cacheService: CacheService
        , private _dataServcie: DataShareService
        , private _translatePipe: TranslateService
        , private _translateKey: TranslateKey
        , private _datePipe: DatePipe
        , private _maskPipe: MaskPipe
        , private ngProgress: NgProgress,
        private _enrollService: EnrollService,
        private _formbuilder: FormBuilder,
        private _checkoutConfigService: CheckoutConfigService,
        private messageService: MessageService,
        private _appConfigService: AppConfigService,
        private _notificationService: NotificationsService,
        private _modalService: BsModalService,
        private _configurationService: ConfigurationService,
        private _achService: AchService,
        private distributorFormatPipe: DistributorIdFormatPipe,
        private _sponsorService: SponsorService,
        private _departmentService: DepartmentService,
        private _personalMessageService: PersonalMessageService,
        private _personalInfoConfigService: PersonalInfoConfigService,
        private _messageService: MessageService,
        private _documentService: DocumentService,
        private _orderService: OrderService,
        private _retailSubscriptionService: RetailSubscriptionService,
        private _currencyPipe: CurrencyTransformPipe
    ) {
        this.reviewModel = new MemberLevelModel();
        this.updateGovIDForm = _formbuilder.group({ govermentIdentification: _formbuilder.array([]) });
    }

    private must_be_email(control: FormControl) {
        const EMAIL_REGEXP = ComposeEmailTicketConstants.EMAIL_REGEXP;
        if (control.value && control.value.length !== '' && !EMAIL_REGEXP.test(control.value)) {
            return { 'must_be_email': true };
        }
        return null;
    }


    public _editor = ClassicEditor;
    public _config = {
        extraPlugins: [AllowDivElement, AllowIDAttribute],
        removePlugins: ['MediaEmbed', 'Title', 'ImageCaption'],
        toolbar: {
            items: [
                'heading',
                '|',
                'bold',
                'italic',
                'link',
                '|',
                'undo',
                'redo',
                '|',
                'imageUpload'
            ]
        },
        image: {
            toolbar: ['imageStyle:alignLeft'],
            styles: [
                'alignLeft'
            ]
        }
    };



    ngOnInit(): void {
        this.attachmentsLength = 0;
        this.uploader = this._customerservice.getFileUploader();
        this.uploader.onErrorItem =
            (item: any, response: any, status: any, headers: any) => this.onErrorItem(item, response, status, headers);
        this.uploader.onSuccessItem =
            (item: any, response: any, status: any, headers: any) => this.onSuccessItem(item, response, status, headers);

        if (environment.dataLayer && environment.dataLayer.length > 0) {
            environment.dataLayer[0].pageCategory = 'fbo-detail-page';
        }
        this.dateNow = new Date();
        this.minDate = new Date(this.dateNow.getFullYear(), this.dateNow.getMonth(), 1);
        this.memberCCMinDate = new Date(this.dateNow.getFullYear(), this.dateNow.getMonth(), this.dateNow.getDate() + 1, 0, 0, 0);
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this._id = this.fboid;
        this.getAllCountriesInfo();
        this.getValidIbanInfoSubscription();
        this.getFlp360Status();
        this.getIdentificationTypes();
        this.getGovermentIdentificationPatterns();
        this.memberWholesaleQualifiedRequest = new memberWholesaleQualifiedRequestModel();
        this.unlockInfo = new UnLockInfoModel();
        this.unlockRequest = new UnLockRequest();
        this.fboProfileDetail = new ProfileInformation();
        this.fboProfileDetail.address = new AddressInformation();
        this.fboProfileDetail.autoShipItems = new Array<Autoship>();
        this.ccSnapshot = new CCSnapshot();
        this.fboProfileDetail.sponsorDetails = new SponsorInformation();
        this.fboProfileDetail.firstActiveUplineManager = new SponsorInformation();
        this.fboProfileDetail.retailSubscriptionModel = new RetailSubscription();
        this.fboProfileDetail.storeEligibility = '';
        this.userId = this._cacheService.get(CacheKey.UserId);
        this.getMemberLevels();
        this.distributorInfoObj = new DistributorInfo();
        this.autoshipMemberInfo = new AutoshipMemberInfo();
        this.viewMemberLevelAllowed = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.FBO_LEVEL_HISTORY + ']'), AccessLevel.Customer_Service);
        this.changeOperatingCountry = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.CHANGE_OPERATING_COMPANY_ALLOW + ']'), AccessLevel.Customer_Service);
        this.autoshipPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[2] + ']'), AccessLevel.Customer_Service);
        this.fboPaymentPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[3] + ']'), AccessLevel.Customer_Service);
        this.fboDownlinePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[4] + ']'), AccessLevel.Customer_Service);
        this.resetPasswordPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[7] + ']'), AccessLevel.Customer_Service);
        this.unlockPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[8] + ']'), AccessLevel.Customer_Service);
        this.homeCountryPermission = this._commonService.checkPermissionByAccessLevel([Permission.CHANGE_OPERATING_COMPANY_ALLOW, Permission.CHANGE_REGISTERED_ADDRESS_ALLOW], AccessLevel.Customer_Service);
        this.allowFullNamePermission = this._commonService.checkPermissionByAccessLevel([Permission.UPDATE_FULL_NAME_ALLOW], AccessLevel.Customer_Service);
        this.memberTypePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[12] + ']'), AccessLevel.Customer_Service);
        this.monthlyCCLimitPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[13] + ']'), AccessLevel.Customer_Service);
        this.statusEditPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[17] + ']'), AccessLevel.Customer_Service);
        this.updateDOBPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[19] + ']'), AccessLevel.Customer_Service);
        this.accountNotificationPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[20] + ']'), AccessLevel.Customer_Service);
        this.changeEmailPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[21] + ']'), AccessLevel.Customer_Service);
        this.changeMemberPreferencesPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[22] + ']'), AccessLevel.Customer_Service);
        this.updatePhoneNumberPermission = this._commonService
            .checkPermissionByAccessLevel(JSON.parse('[' + Permission.FBO_UPDATE_PHONE_NUMBER + ']'), AccessLevel.Customer_Service);
        this.viewShoppingBagPermission = this._commonService
            .checkPermissionByAccessLevel(JSON.parse('[' + Permission.VIEW_SHOPPING_BAG + ']'), AccessLevel.Customer_Service);
        this.changeGeneralSponsorPermission = this._commonService
            .checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[23] + ']'), AccessLevel.Customer_Service);
        this.governmentIdViewPermission = this._commonService
            .checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[24] + ']'), AccessLevel.Customer_Service);
        this.governmentIdManagePermission = this._commonService
            .checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[25] + ']'), AccessLevel.Customer_Service);
        this.hasAllowEcheckPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ManagePersonalCheckPermission[0] + "]"), AccessLevel.Customer_Service);
        this.composeEmailPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_COMPOSE_EMAIL + ']'), AccessLevel.Customer_Service);
        this.hasRetailSubscriptionAccess = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_RETAIL_SUBSCRIPTION + ']'), AccessLevel.Customer_Service);
        this.accountViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.accountRestrictionPermission[0] + ']'), AccessLevel.Customer_Service);
        this.accountManagePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.accountRestrictionPermission[1] + ']'), AccessLevel.Customer_Service);
        this.getCustomBankTypeSelectOption();
        this.buildChangeMemberTypeandLevelForm();
        this.buildResetPasswordForm();
        this.getFlpAccessDetails();
        this.getFlpUserDetails();
        this.buildFlp360ResetPasswordForm();
        this.addressDetail = new AddressInformation();

        this.contactTypes.forEach(types => {
            if (types.value === ContactTypeValue.PHONE) {
                types.name = 'Home';
            }
        });
        this.getEmailSignature();
        this.getChargeBeeLanguages();
    }

    ngAfterContentChecked() {
        this.checkValidationForEndDate();
    }
    ngAfterViewInit() {
        window.scrollTo(0, 0);
    }

    buildResetPasswordForm() {
        this.resetPasswordForm = this._formbuilder.group({
            resetPassword: [this.selectEnum.firstOption.toString()],
        });
    }

    buildFlp360ResetPasswordForm() {
        this.flp360ResetPasswordForm = this._formbuilder.group({
            flp360ResetPassword: [this.selectEnum.firstOption.toString()],
        });
    }

    getMemberBonusInfo() {
        if (this.personalInfoSettings && this.personalInfoSettings.enableSingleAndDirectDebit) {
            if (this.fboProfileDetail && this.fboProfileDetail.memberId) {
                    const operatingCompany = this.storeInfo && this.storeInfo.homeIsocodeThree ? this.storeInfo.homeIsocodeThree : null;
                    const storeId = this.storeInfo && this.storeInfo.id ? this.storeInfo.id : null;
                this._customerService.getMemberBankDetails(this.fboProfileDetail.memberId, storeId, operatingCompany).subscribe(
                    (response) => {
                        if (response) {
                            this.memberBonusInfo = response;
                            this.creditAssessmentApproved = this.memberBonusInfo.creditAssessmentEnabled;
                            this._personalMessageService.setPreviousBonusInfo(this.memberBonusInfo);
                            this.isBonusInfo =  this.memberBonusInfo ? true : false;
                            this.preloadMemberBonusInfo = this.memberBonusInfo;
                            // this.bonusInfoBankCode = this.memberBonusInfo.bankCode;
                            this.bonusInfoAgreements.forEach((agreement: any) => agreement.isSelected = true);
                            this.isCreditAssessmentEnabled = this.memberBonusInfo.creditAssessmentEnabled;
                            this.isSingleDebitEnabled = this.memberBonusInfo.singleDebitEnabled;
                            this.isDirectDebitEnabled = this.memberBonusInfo.directDebitEnabled;
                            if (this.appConfig.enableAccountNumberFormat && this.memberBonusInfo && this.memberBonusInfo.accountNumber) {
                                this.memberBonusInfo.accountNumber = this.memberBonusInfo.accountNumber.replace(/\s/g, '');
                            }
                        }
                    }
                );
            }
        }
    }

    private getWholsesaleQualifiedDetails(fboId: string, memberHomeCountry: string) {
        this._commonService.getWholsesaleQualifiedDetails(fboId, memberHomeCountry)
            .subscribe((res: WholesaleQualifiedResponse) => {
                try {
                    if (res && res.wholesaleQualified != null) {
                        this.fboProfileDetail.wholesaleQualifiedCheck = res.wholesaleQualified;
                        this.fboProfileDetail.memberOptin = res.optIn;
                        this.getDiscountPersentage(this.fboProfileDetail.wholesaleQualifiedCheck, this.fboProfileDetail.memberOptin);
                    }
                } catch (error) {
                    // this.getMemberDiscountPercentages(storeInfo);
                    // this.wholesaleCheckErrorNotifications();
                }
            }, error => {
                // this.getMemberDiscountPercentages(storeInfo);
                // this.wholesaleCheckErrorNotifications();
            });
    }
    getDiscountPersentage(wholeSaleQualified: boolean, optin: boolean) {

        const memberTitleID = this.fboProfileDetail ? this._orderService.getMemberTitleId(this.fboProfileDetail) : MemberLevel.RETAIL;
        this._messageService.getStoreID().subscribe((res)=>{
            this.storeInfo.id =res
            if(this.storeInfo.id){
                this._commonService.getDiscountPercentages(wholeSaleQualified, optin, memberTitleID, this.storeInfo.id).
                    subscribe(response => {
                        this.memberDiscountPercentage = response;
                    });
                }
            });

    }

    prepareBonusInfoSchemaForm() {
        const bankCode =(this.memberBonusInfo &&  this.memberBonusInfo.bankCode )? this.memberBonusInfo.bankCode : this.bonusInfoBankCode ? this.bonusInfoBankCode : null;
        if (this.personalInfoSettings && this.personalInfoSettings.enableSingleAndDirectDebit) {
            if (this.fboProfileDetail.homeCountryCode) {
                if (this.personalInfoSettings.countryCode.toLowerCase() === IsoCodeThree.SWE.toLowerCase() || this.personalInfoSettings.countryCode.toLowerCase() === IsoCodeThree.DEU.toLowerCase() || this.personalInfoSettings.countryCode.toLowerCase() === IsoCodeThree.AUT.toLowerCase()) {
                    if (bankCode) {
                        this.bonusInfoSchemaUrl = this.homeCountry.toLowerCase() + '-' + bankCode.toLowerCase() + '-bonus-info.json?templateVersion= '
                            + environment.templateVersion;
                    } else {
                        this.bonusInfoSchemaUrl = this.homeCountry.toLowerCase() + '-bankgiro-bonus-info.json?templateVersion= '
                            + environment.templateVersion;
                    }
                } else {
                    this.bonusInfoSchemaUrl = this.fboProfileDetail.homeCountryCode.toLowerCase() + '-bonus-info.json?templateVersion= '
                        + environment.templateVersion;
                }
                this._configurationService.setBonusInfoSchemaUrl(this.bonusInfoSchemaUrl);
                this._personalMessageService.setRebindBonusinfoForm(true);
                setTimeout(() => {
                    this._personalMessageService.setDisableBonusInfoForm(true);
                    this.disableBonusInfoChecks = true;
                }, 1500);
            }
        }
    }
    getFlpAccessDetails() {
        if (this.fboid) {
            this._customerService.getFlp360AccessDetails(this.fboid)
                .subscribe(response => {
                    if (response) {
                        this.messageService.setFlp360AccessDetails(response);
                        if (response.userAvailable && response.flp360StatusId && response.flp360StatusId !== Flp360Status.NO_SUBSCRIPTION
                            && response.memberStatusId && response.memberStatusId === MemberStatusId.ACTIVE) {
                            this.flp360AccountAvailable = true;
                            this.isFlp360Enabled = true;
                        }
                        // check for the variable flp360Subscirbed flag. inside if condition only
                        //set the details over here for FLP360 meber about enrolment date and is flp360 enabled
                    }
                });
        }
    }

    impersonateFlp360User() {
        if (this.fboid) {
            //Log FLP360 impersonation activity
            const activityLogKeys: ActivityLogKey[] = [{
                key: MemberActivityLogType.Flp360_Impersonation_Started,
                value: this.fboProfileDetail.fboId
            }];
            this._commonService.saveMemberActivity(this.fboProfileDetail.id, activityLogKeys).subscribe();

            this._customerService.getAdminToken().subscribe(response => {
                if (response && response.adminToken) {
                    debugger
                    this._customerService.impersonateFlp360User(response.adminToken, this.fboid, null).subscribe(res => {
                        res.success = true;
                        debugger
                        if (res && res.success) {
                            localStorage.setItem('appadmin.FLP360_SESSION_STATE', res.sessionState);
                            window.open(environment.flp360LoginUrl, '_blank');
                        } else {
                            this._commonService.createNotification('', 'Cannot Impersonate Flp360 User', NotificationType.ERROR);
                        }
                    }, error => this.handleError());
                }
            }, error => this.handleError());
        }
    }

    impersonateFlp360WebsiteUser() {
        if (this.fboid) {
            //Log FLP360 impersonation activity
            const activityLogKeys: ActivityLogKey[] = [{
                key: MemberActivityLogType.Flp360_Impersonation_Started,
                value: this.fboProfileDetail.fboId
            }];
            this._commonService.saveMemberActivity(this.fboProfileDetail.id, activityLogKeys).subscribe();

            this._customerService.getAdminToken(this.fboid, "FLP360").subscribe(response => {
                if (response && response.adminToken) {

                    this.cookieService.set(SSO.AuthorizedUser_UAT,environment.disableVpnPin === true ? "true" : "false",null, environment.cookiePath, environment.cookieDomain);

                    this._customerService.impersonateFlp360User(response.adminToken, this.fboid, null).subscribe(res => {
                        res.success = true;

                        if (res && res.success) {
                            localStorage.setItem('appadmin.FLP360_SESSION_STATE', res.sessionState);
                            window.open(environment.flp360TitanWebsiteUrl + '&timestamp=' + Date.now(), '_blank');
                        } else {
                            this._commonService.createNotification('', 'Cannot Impersonate Flp360 User', NotificationType.ERROR);
                        }
                    }, error => this.handleError());
                }
            }, error => this.handleError());
        }
    }



    getFlpUserDetails() {
        if (this.fboid) {
            this.messageService.getFlp360AccessDetails()
                .subscribe(response => {
                    if (response && response.fboId) {
                        this.isFlp360Enrolled = 'Yes';
                        this.flp360Status = this.flp360Statuses.find(status =>
                            status.value === response.flp360StatusId).name;
                        this.flp360EnrollmentDate = response.enrollmentDate;
                    }
                });
        }
    }

    /**
   * This method used for getting flp360 status types
   * getFlp360Status()
   */
    getFlp360Status(): void {
        this.flp360Statuses = Flp360StatusConstants.statusConstants;
    }

    /** *  ************************* */
    /**
     * Navigating to autoship tab
     */
    autoShipTab() {
        // emit the event for autoship tab
        this.changeTab.emit(3);
    }

    buildUnlockForm() {
        this.unlockForm = this._formbuilder.group({
            unlockAccountMessage: ['', [Validators.required]]
        });
    }


    openUnlockModal(deafultfocus) {
        this.getAccountLockInfo();
        this.buildUnlockForm();
        this.unlockRequest.typeId = MemberActivity.AccountUnLock;
        this._customerservice.getUnLockInfo(this.fboProfileDetail.id, this.unlockRequest)
            .subscribe(response => {
                if (response && response.content.length > 0) {
                    this.unLockData = response.content;
                    this.unLockData.forEach(item => {
                        if (item.createdDate != 'null') {
                            item.createdDate = item.createdDate.replace(' ', 'T');
                        }
                    });
                }
            });
        this.unlockPopup.open();
        setTimeout(function () {
            const element = document.getElementById('createNotesInput');
            if (element) {
                element.focus();
            }
        }, 200);
    }

    saveUnLockInfo() {
        this.isUnLockSubmitted = true;
        if (this.unlockForm.valid && this.unlockForm.value.unlockAccountMessage.trim().length > 0) {
            this.unlockInfo.message = this.unlockForm.value.unlockAccountMessage;
            this.unlockInfo.userId = this.userInfo.userId;
            this.unlockInfo.userName = this.userInfo.userName;
            this._customerservice.saveUnLockInfo(this.fboProfileDetail.fboId, this.unlockInfo)
                .subscribe(response => {
                    if (response && response.isSuccess) {
                        const activityLogKeys: ActivityLogKey[] = [{
                            key: MemberActivityLogType.Unlock_Account,
                            value: this.fboProfileDetail.fboId
                        }];
                        this._commonService.saveMemberActivity(this.fboProfileDetail.id, activityLogKeys).subscribe();
                        this._commonService.createNotification('', 'Member Account has been unlocked Successfully', NotificationType.SUCCESS);
                        this.closePopUp();
                        this.isUnLockSubmitted = false;
                    }
                });
        } else {
            this._commonService.createNotification('', 'Please enter valid notes to Unlock', NotificationType.ERROR);
            this.isUnLockSubmitted = true;
        }
    }
    getAccountLockInfo() {
        this._customerservice.AccountLockInfo(this.fboProfileDetail.fboId).subscribe(response => {
            if (response) {
                this.isAccountLocked = response.lock;
            }
        });
    }

    /**
     * @date 2020-09-23
     * @memberof FBOProfileComponent
     */
    async openChangeHomeCountryModal(template: TemplateRef<BsModalRef>) {
        this.addressDetail = this.fboProfileDetail.address;
        if (this.storeInfo && this.storeInfo.enableTransliteration) {
            let language = this.storeInfo && this.storeInfo.enableTransliteration && this.storeInfo.languages ? this.storeInfo.languages.find(x => x.default) : null;
            let response: any = await this._customerService.getMemberBasicInfoById(this.fboProfileDetail.memberId, language ? language.languageId : 0).toPromise();
            if (response && response.isSuccess && response.address) {
                this.addressDetail.addressLine1 = response.address.addressLine1;
                this.addressDetail.addressLine2 = response.address.addressLine2;
                this.addressDetail.addressLine3 = response.address.addressLine3;
                this.addressDetail.addressLine4 = response.address.addressLine4;
                this.addressDetail.city = response.address.city;
            }
        }
        if (this.addressDetail) {
            const selectedCountry = this.countries.find(country => +country.countryId === this.addressDetail.countryId);
            this.selectedCountry = this.checkoutConfig.loadParticipatingCountries ? (selectedCountry ? selectedCountry.isocodeThree : 'gbl') : this.homeCountry;
            this.mailingSchemaUrl = this.selectedCountry.toLowerCase() +
                '-mailing-schema-form.json?templateVersion=' + environment.templateVersion;
        }
        this.isDisplaySearchAddressSection = this.checkoutConfig ? this.checkoutConfig.displaySearchAddressSection : false;
        const config: ModalOptions = {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'change-address-modal'
        };
        this.bsModalRef = this._modalService.show(template, config);
    }

    openChangeSponsorModal() {
        this.changeSponsorForm = this._formbuilder.group({
            newSponsorId: ['', Validators.required],
            sponsorType: [0]
        });
        this.getSponsorDetails(this.fboProfileDetail.id);
        this.changeSponsorPopup.open();
        setTimeout(function () {
            const newSponsorElement = document.getElementById('newSponsorId');
            if (newSponsorElement) {
                newSponsorElement.focus();
            }
        }, 0);
    }
    /**
     * build Change member type form onload
     */
    buildChangeMemberTypeandLevelForm() {
        this.changeMemberTypeandLevelForm = this._formbuilder.group({
            memberTypeModal: [''],
            memberLevel: [''],
            enableStatus: [''],
            triggerNotification: ['']
        });
    }
    openChangeMemberTypeandLevelModal() {
        this.GetMemberTypeList();
        this.GetMemberLevelList();
        this.changeMemberTypeandLevelForm.patchValue({
            memberTypeModal: this.fboProfileDetail.memberTypeId,
            memberLevel: this.fboProfileDetail.memberTitleId,
            enableStatus: this.fboProfileDetail.wholesaleQualified,
            triggerNotification: false
        });
        this.changeMemberTypeandLevelForm.controls['triggerNotification'].disable();

        this.memberLevelDisable = true; // need to be removed when full functionality is in place

        if (this.fboProfileDetail.wholesaleQualified) {
            this.changeMemberTypeandLevelForm.controls['enableStatus'].disable();
        }
        if (+this.changeMemberTypeandLevelForm.controls['memberTypeModal'].value === this.memberTypeEnum.DISTRIBUTOR) {
            this.changeMemberTypeandLevelForm.controls['triggerNotification'].setValue(true);
        }
        this.changeMemberTypeandLevelPopup.open();

        // setTimeout(function(){
        //     document.getElementById("memberTypeModal").focus();
        //  }, 200);
    }

    memberTypeChange() {
        if (+this.changeMemberTypeandLevelForm.controls['memberTypeModal'].value === this.memberTypeEnum.DISTRIBUTOR) {
            this.changeMemberTypeandLevelForm.controls['triggerNotification'].setValue(true);
            this.memberLevelDisable = false;
            this.changeMemberTypeandLevelForm.controls['memberLevel'].setValidators([Validators.required]);
            this.changeMemberTypeandLevelForm.controls['memberLevel'].updateValueAndValidity();
            this.changeMemberTypeandLevelForm.controls['enableStatus'].disable();
        }
        if (+this.changeMemberTypeandLevelForm.controls['memberTypeModal'].value != this.memberTypeEnum.DISTRIBUTOR) {
            this.changeMemberTypeandLevelForm.controls['triggerNotification'].setValue(false);
            this.changeMemberTypeandLevelForm.controls['memberLevel'].setValidators([]);
            this.changeMemberTypeandLevelForm.controls['memberLevel'].updateValueAndValidity();
            this.memberLevelDisable = true;
            this.changeMemberTypeandLevelForm.controls['enableStatus'].enable();
        }
    }

    /**
     * @description Open Member cc override modal
     * @date 2019-07-11
     * @memberof FBOProfileComponent
    */
    openOverrideMonthlyCCLimitModal() {
        this.createMemberCCOverrideForm();
        if (this.titanEnabledCountries && this.titanEnabledCountries.length) {
            const homeCountry = this.titanEnabledCountries.find(item => item.countryId === this.storeId) || this.titanEnabledCountries[0];
            if (homeCountry && homeCountry.isocodeThree) {
                this.overrideMonthlyCCLimitForm.controls['homeCountry'].setValue(homeCountry);
                this.getStoreInfoBasedOnCountry(homeCountry.isocodeThree.toUpperCase(), true);
            }
        }
    }

    /**
     * @description Create member cc override form
     * @date 2019-07-11
     * @memberof FBOProfileComponent
    */
    createMemberCCOverrideForm(): void {
        this.overrideMonthlyCCLimitForm = this._formbuilder.group({
            homeCountry: ['', Validators.required],
            applyOverride: [false],
            newCCLimit: [''],
            endDate: [''],
        });
    }

    /**
     * @description pre populate member cc override
     * @date 2019-07-11
     * @memberof FBOProfileComponent
    */
    prepopulateMemberCCOverride(): void {
        const value = this.getDate();
        if (this.memberCCOverrideResponse && this.memberCCOverrideResponse.id) {
            this.overrideMonthlyCCLimitForm.patchValue({
                applyOverride: this.memberCCOverrideResponse.overrideFlag,
                newCCLimit: this.memberCCOverrideResponse.cVLimit,
                endDate: moment(value, 'DD-MM-YYYY')
            });
        }
    }

    /**
     * @description get date only from effective end date
     * @date 2019-07-26
     * @memberof FBOProfileComponent
    */
    getDate(): string {
        return moment(this.memberCCOverrideResponse.effectiveEndDate.split('T')[0]).format('DD-MM-YYYY');
    }

    /**
     * @description On check of apply override checkbox
     * @date 2019-07-11
     * @memberof FBOProfileComponent
     */
    OnCheckApplyCCOverride(): void {
        const isChecked = this.overrideMonthlyCCLimitForm.controls['applyOverride'].value;
        this.overrideMonthlyCCLimitForm.controls['newCCLimit'].clearValidators();
        this.overrideMonthlyCCLimitForm.controls['endDate'].clearValidators();
        if (isChecked) {
            if (this.memberCCOverrideResponse && this.memberCCOverrideResponse.id) {
                const value = this.getDate();
                this.overrideMonthlyCCLimitForm.patchValue({
                    newCCLimit: this.memberCCOverrideResponse.cVLimit,
                    endDate: moment(value, 'DD-MM-YYYY')
                });
            }
            this.showNewCCBlock = true;
            this.overrideMonthlyCCLimitForm.controls['newCCLimit'].setValidators([Validators.required, Validators.min(1)]);
            this.overrideMonthlyCCLimitForm.controls['newCCLimit'].updateValueAndValidity();
            this.overrideMonthlyCCLimitForm.controls['endDate'].setValidators([Validators.required,
            Validators.min(this.memberCCMinDate.getTime()), Utils.validateFutureDate]);
            this.overrideMonthlyCCLimitForm.controls['endDate'].updateValueAndValidity();
        } else {
            this.showNewCCBlock = false;
            this.overrideMonthlyCCLimitForm.controls['newCCLimit'].clearValidators();
            this.overrideMonthlyCCLimitForm.controls['endDate'].clearValidators();
        }
    }

    /**
   * @description On submitting cc limit override
   * @date 2019-07-11
   * @memberof FBOProfileComponent
   */
    onSubmitCCLimitOverride(isValid: boolean): void {
        if (isValid) {
            if (this.memberCCOverrideResponse && this.memberCCOverrideResponse.id) {
                const memberCCRequestModel = this.prepareMemberCCOverrideRequest();
                memberCCRequestModel.effectiveStartDate =
                    this._datePipe.transform(this.memberCCOverrideResponse.effectiveStartDate, 'yyyy-MM-dd');
                this.updateMemberCCOverride(memberCCRequestModel);
            } else if (this.overrideMonthlyCCLimitForm.controls['applyOverride'].value) {
                const memberCCRequestModel = this.prepareMemberCCOverrideRequest();
                this.createMemberCCOverride(memberCCRequestModel);
            }
        }
    }

    /**
     * @description Update Member cc limit override
     * @date 2019-07-11
     * @memberof FBOProfileComponent
    */
    updateMemberCCOverride(memberCCRequestModel: MemebrCCOverrideModel): void {
        const store = this.overrideMonthlyCCLimitForm.controls['homeCountry'].value;
        this._customerservice.updateMemberCCOverride(this.storeInfo.id,
            this.fboProfileDetail.memberId, memberCCRequestModel, this.memberCCOverrideResponse.id).subscribe(response => {
                if (response && response.isSuccess) {
                    this.saveMemberCCOverrideActivityLog(this.memberCCOverrideResponse.cVLimit,
                        this.overrideMonthlyCCLimitForm.controls['newCCLimit'].value, store.isocodeThree);
                    const notification: any = this._translatePipe.get('customer-service.CC Limit Override Updated Successfully');
                    this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                    this.overrideMonthlyCCLimitPopup.close();
                }
            }, (err: any) => {
            });
    }

    /**
     * @description Update Member cc limit override
     * @date 2019-07-11
     * @memberof FBOProfileComponent
   */
    createMemberCCOverride(memberCCRequestModel: MemebrCCOverrideModel): void {
        const store = this.overrideMonthlyCCLimitForm.controls['homeCountry'].value;
        this._customerservice.saveMemberCCOverride(this.storeInfo.id,
            this.fboProfileDetail.memberId, memberCCRequestModel).subscribe(response => {
                if (response && response.isSuccess) {
                    this.saveMemberCCOverrideActivityLog(0, this.overrideMonthlyCCLimitForm.controls['newCCLimit'].value,
                        store.isocodeThree);
                    const notification: any = this._translatePipe.get('customer-service.CC Limit Override Updated Successfully');
                    this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                    this.overrideMonthlyCCLimitPopup.close();
                }
            }, (err: any) => { });
    }

    /**
     * @description save member activity log while updating/creating member cc limit override
     * @date 2019-07-11
     * @memberof FBOProfileComponent
   */
    saveMemberCCOverrideActivityLog(oldCCLimit: number, newCCLimit: number, countryCode): void {
        let value = '';
        let key;
        if (this.overrideMonthlyCCLimitForm.controls['applyOverride'].value) {
            const endDate = moment(this.overrideMonthlyCCLimitForm.controls['endDate'].value, 'DD-MMM-YYYY')
                .format(DateConstants.DateFormat);
            value = 'Store = ' + countryCode + ', Old Limit = ' + oldCCLimit
                + ', New Limit =  ' + newCCLimit + ' End Date = ' + endDate;
            key = MemberActivityLogType.Member_CC_Limit_Override_Updated;
        } else {
            value = countryCode ? countryCode.toUpperCase() : '';
            key = MemberActivityLogType.Member_CC_Limit_Override_Disabled;
        }
        const activityLogKeys: ActivityLogKey[] = [{
            key: key,
            value: value
        }];
        this._commonService.saveMemberActivity(this.fboProfileDetail.id, activityLogKeys).subscribe();
    }

    /**
   * @description preparing member cc override request data
   * @date 2019-07-11
   * @memberof FBOProfileComponent
   */
    prepareMemberCCOverrideRequest(): MemebrCCOverrideModel {
        const endDate = this._datePipe.transform(this.overrideMonthlyCCLimitForm.controls['endDate'].value, 'yyyy-MM-dd');
        return {
            memberId: this.fboProfileDetail.memberId,
            storeId: this.storeInfo.id,
            effectiveEndDate: endDate,
            cVLimit: this.overrideMonthlyCCLimitForm.controls['newCCLimit'].value,
            overrideFlag: this.overrideMonthlyCCLimitForm.controls['applyOverride'].value
        };
    }

    /**
     * @description On submitting cc limit override
     * @date 2019-07-11
     * @memberof FBOProfileComponent
    */
    OnCountryChange(): void {
        if (this.overrideMonthlyCCLimitForm.controls['homeCountry'].value) {
            const country = this.overrideMonthlyCCLimitForm.controls['homeCountry'].value;
            if (country && country.isocodeThree) {
                this.getStoreInfoBasedOnCountry(country.isocodeThree.toUpperCase());
            }
        }
    }

    /**
     * Get Store Info
     * @param countryCode
     */
    getStoreInfoBasedOnCountry(countryCode: String, isOpenModal?: boolean) {
        if (countryCode) {
            this._customerservice.getStoreInfoFromConfig(countryCode)
                .subscribe(response => {
                    if (response) {
                        this.storeInfo = response;
                        if (this.storeInfo && this.storeInfo.id && this.fboProfileDetail && this.fboProfileDetail.memberId) {
                            this.getMemberCCOverrides(this.storeInfo.id, isOpenModal);
                        }
                    }
                });
        }
    }

    /**
     * Get member cc overrides
     * @param storeId
     */
    getMemberCCOverrides(storeId: number, isOpenModal?: boolean): void {
        this._customerservice.getMemberCCOverride(storeId, this.fboProfileDetail.memberId)
            .subscribe(response => {
                if (response && response.length) {
                    this.memberCCOverrideResponse = response[0];
                    this.prepopulateMemberCCOverride();
                    this.OnCheckApplyCCOverride();
                } else {
                    this.clearMemberCCOverrideData();
                }
                if (isOpenModal) {
                    this.overrideMonthlyCCLimitPopup.open();
                }
            }, (err: any) => {

            });
    }

    /**
     * @description Clear form data when getting no data
     * @date 2019-07-11
     * @memberof FBOProfileComponent
    */
    clearMemberCCOverrideData(): void {
        this.memberCCOverrideResponse = null;
        this.showNewCCBlock = false;
        this.overrideMonthlyCCLimitForm.controls['newCCLimit'].setValue('');
        this.overrideMonthlyCCLimitForm.controls['applyOverride'].setValue(false);
        this.overrideMonthlyCCLimitForm.controls['endDate'].setValue('');
    }

    /**
     * @description convert to Date Format
     * @date 2019-07-16
     * @param {string} date
     * @memberof FBOProfileComponent
     */
    convertMemberCCDateFormat(date: string): void {
        const dateMomentObj = Utils.convertToSpecificDateFormat(date, DateConstants.DOBConvertFormat);
        if (dateMomentObj) {
            this.overrideMonthlyCCLimitForm.controls['endDate'].setValue(moment(dateMomentObj, 'DD-MM-YYYY'));
        }
    }

    /**
   * @description
   * @date 2019-08-01
   * @memberof FBOProfileComponent
   */
    openChangeNameModal() {
        this.errorCodes = [];
        let language = this.storeInfo && this.storeInfo.enableTransliteration && this.storeInfo.languages ? this.storeInfo.languages.find(x => x.default) : null;
        this._customerService.getMemberBasicInfoById(+this.fboProfileDetail.memberId,language? language.languageId:0).subscribe((basicInfo: MemberBasicInfo) => {
            if (basicInfo) {
                this.basicInfo = basicInfo;
                this.buildNameForm();
                this.updateMemberNamePopup.open();
            }
        }, errorRes => {
            const addedNotification = this._translatePipe.get('errorcodes.Unable to Update Name. Please try again later')['value'];
            this._commonService.createNotification('', addedNotification, NotificationType.ERROR);
        });
    }
    /**
     * @description
     * @date 2019-08-01
     * @memberof FBOProfileComponent
     */
    buildNameForm() {
        this.changeMemberNameForm = this._formbuilder.group({
            firstName: ['', [Validators.required, Utils.noEmptyString]],
            lastName: ['', [Validators.required, Utils.noEmptyString]],
            middleName: ['', [Utils.noEmptyString]]
        });
        this.changeMemberNameForm.setValue({
            middleName: this.storeInfo && this.storeInfo.enableTransliteration ? this.basicInfo.middleName : (this.fboProfileDetail.middleName ? this.fboProfileDetail.middleName : ''),
            firstName: this.storeInfo && this.storeInfo.enableTransliteration ? this.basicInfo.firstName : this.fboProfileDetail.firstName,
            lastName: this.storeInfo && this.storeInfo.enableTransliteration ? this.basicInfo.lastName : this.fboProfileDetail.lastName
        });
        this.setValidationForMemberNameForm();
    }

    setValidationForMemberNameForm() {
        if (this.personalInfoFormValidations) {
            if (this.personalInfoFormValidations.firstName && this.personalInfoFormValidations.firstName.pattern) {
                this.changeMemberNameForm.get('firstName').setValidators([Validators.required, Utils.noEmptyString, Validators.pattern(this.personalInfoFormValidations.firstName.pattern)])
            }
            if (this.personalInfoFormValidations.lastName && this.personalInfoFormValidations.lastName.pattern) {
                this.changeMemberNameForm.get('lastName').setValidators([Validators.required, Utils.noEmptyString, Validators.pattern(this.personalInfoFormValidations.lastName.pattern)])
            }
            if (this.personalInfoFormValidations.middleName && this.personalInfoFormValidations.middleName.pattern && !this.personalInfoFormValidations.middleName.required) {
                this.changeMemberNameForm.get('middleName').setValidators([Utils.noEmptyString, Validators.pattern(this.personalInfoFormValidations.middleName.pattern)])
            }
            else if (this.personalInfoFormValidations.middleName && this.personalInfoFormValidations.middleName.pattern && this.personalInfoFormValidations.middleName.required) {
                this.changeMemberNameForm.get('middleName').setValidators([Validators.required,Utils.noEmptyString, Validators.pattern(this.personalInfoFormValidations.middleName.pattern)])
            }
        }
    }

    buildRetailSubscritionForm() {
     const entityObj =  this.ValidateBusinessEntity();

        this.retailSubscriptionForm = this._formbuilder.group({
            firstName: ['', [Validators.required]],
            lastName: ['', [Validators.required]],
            fboId: ['', [Validators.required]],
            email: ['', [Validators.required, Utils.emailValidationRule]],
            homeCountryStore: ['', [Validators.required]],
            language: ['', [Validators.required]],
            taxId: [''],
            chargeBeeRetailPlanId: ['', [Validators.required]],
            annualSubscriptionFee: ['', [Validators.required]],
            subscriptionStatus: ['', [Validators.required]],
            businessEntityId:[''],
            addressId:[''],
            businessEntityName:[''],
            address:this._formbuilder.group({
                line1:[''],
                line2:[''],
                line3:[''],
                line4:[''],
                city:[''],
                state:[''],
                postalCode:[''],
                Country:['']
            })

        });
        this.retailSubscriptionForm.get('address').patchValue(entityObj && entityObj.address?entityObj.address:'');
        const obj = {
            firstName: this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.firstName,
            lastName: this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.lastName,
            fboId: this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.distributorId,
            email: this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.emailAddress,
            homeCountryStore: this.storeInfo && this.storeInfo.countryId ? this.getCountryById(+this.storeInfo.countryId) : "",
            language: this.retailSubscriptionLanguageId || '',
            taxId: entityObj && entityObj.vatId ? entityObj.vatId : '',
            chargeBeeRetailPlanId: this.chargeBeePlan ? this.chargeBeePlan.code : '',
            annualSubscriptionFee: this.prepareChargebeePlanPrice(),
            subscriptionStatus: SubscriptionStatusEnum[this.memberRetailSubscriptionDetail.subscriptionStatus],
            businessEntityName: entityObj && entityObj.name ? entityObj.name : '',
            businessEntityId: entityObj && entityObj.entityId ? (+entityObj.entityId) : '',
            addressId: entityObj && entityObj.address && entityObj.address.id ? (+entityObj.address.id) : ''
        };
        this.retailSubscriptionForm.patchValue(obj);
        this.setChargeBeeDetails();
        this.retailSubscriptionPopup.open();
    }

    /**
     * To Prepare Chargebee Plan Price
     */
     prepareChargebeePlanPrice(){
        let priceValue = '';
        let price: number = this.chargeBeePlan && this.chargeBeePlan.price ? this.chargeBeePlan.price.toFixed(Math.max(0, ~~2)) : '';
        if(price){
            const currencyCode = this.chargeBeePlan && this.chargeBeePlan.currencyCode ? this.chargeBeePlan.currencyCode : '';
            if(currencyCode) priceValue = price + " " +currencyCode;
        }
        return priceValue;
    }

    ValidateBusinessEntity() {
        if (this.appConfig && !this.appConfig.disableBusinessEntityForFbo) {
            const isBusinessEntityExists = this.fboProfileDetail && this.fboProfileDetail.businessEntities && this.fboProfileDetail.businessEntities.length > 0 ? true : false;
            const isBusinessEntityMatchesCountry = isBusinessEntityExists ? this.fboProfileDetail.businessEntities.some(businessEntity => businessEntity.countryCodeId == this.fboProfileDetail.homeCountryId) : false;
            if (isBusinessEntityExists && isBusinessEntityMatchesCountry) {
                const date = new Date();
                const businessEntityRecord = this.fboProfileDetail.businessEntities.find(businessEntity => businessEntity.countryCodeId == this.fboProfileDetail.homeCountryId);
                const isActiveByStatus = (businessEntityRecord.status == RowStatus.Active) ? true : false;
                const startDate = businessEntityRecord.startDate ? businessEntityRecord.startDate : '';
                const endDate = businessEntityRecord.endDate ? businessEntityRecord.endDate : '';
                const isStartDateActive = startDate && this.isValidDate(startDate) && (new Date(moment(date, 'DD-MMM-YYYY').format('YYYY-MM-DD')).toISOString() >= new Date(moment(startDate, 'DD-MMM-YYYY').format('YYYY-MM-DD')).toISOString()) ? true : false;
                const isEndDateActive = this.checkEndDate(endDate);
                return this.isActive(businessEntityRecord, isActiveByStatus, isStartDateActive, isEndDateActive);
            }
            if (!(isBusinessEntityExists && isBusinessEntityMatchesCountry)) {
                return this.populateBusinessEntityDetails(true);
            }
        }
        else {
            return this.populateBusinessEntityDetails(false)
        }
    }

    isActive(businessEntityRecord, isActiveByStatus, isStartDateActive, isEndDateActive) {
        if (isActiveByStatus && isStartDateActive && isEndDateActive) {
            const businessEntityName = businessEntityRecord.businessEntityName ? businessEntityRecord.businessEntityName : '';
            const vatId = businessEntityRecord.incomeTaxID ? businessEntityRecord.incomeTaxID : '';
            const countryName = !!this.countriesList.length && businessEntityRecord.countryCodeId ? this.countriesList.filter(item => item.countryId == businessEntityRecord.countryCodeId)[0] : '';
            const state = !!this.states.length && businessEntityRecord.stateCodeId ? this.states.find((state: any) => state.id === businessEntityRecord.stateCodeId) :'';
            let address:BusinessEntityAddress = { line1: '', line2: '', line3: '', line4: '', city: '', state: '', postalCode: '', Country: '', countryCode: '' };
            address.line1 = businessEntityRecord.addressLine1 ? businessEntityRecord.addressLine1 : '';
            address.line2 = businessEntityRecord.addressLine2 ? businessEntityRecord.addressLine2 : '';
            address.line3 = '';
            address.line4 = '';
            address.city = businessEntityRecord.city ? businessEntityRecord.city : '';
            address.state = state && state.stateName ?state.stateName :'';
            address.postalCode = businessEntityRecord.postalCode ? businessEntityRecord.postalCode : '';
            address.Country = countryName && countryName.name ? countryName.name : '';
            address.countryCode = countryName && countryName.isocodeTwo ? countryName.isocodeTwo : '';

            const businessDetails = { name: '', vatId: '', address: {},entityId:'' };
            businessDetails.name = businessEntityName
            businessDetails.vatId = vatId;
            businessDetails.address = address;
            businessDetails.entityId = businessEntityRecord.id?businessEntityRecord.id.toString():'';
            return this.populateBusinessEntityDetails(true, businessDetails);
        }
        else {
            return this.populateBusinessEntityDetails(true);
        }
    }

    isValidDate(date) {
        return (new Date(date).toString() !== DateConstants.InvalidDate) ? true : false;
    }

    populateBusinessEntityDetails(hideName, businessEntities?) {
        let businessDetailsObj = { name: '', vatId: '', address: {} }
        this.hideBusinessEntityName = false;
        if (hideName) {
            this.hideBusinessEntityName = hideName;
        }
        if (businessEntities) {
            return businessEntities;
        }
        businessDetailsObj.vatId = this.getVatIdfromMember();
        businessDetailsObj.address = this.populateAddress();
        return businessDetailsObj
    }

    checkEndDate(date) {
        const currDate = new Date();
        if (!date || (new Date(date).toString() == DateConstants.InvalidDate)) return true;
        return (new Date(moment(currDate, 'DD-MM-YYYY').format('YYYY-MM-DD')).toISOString() <=  new Date(moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD')).toISOString()) ? true : false;
    }

 getVatIdfromMember() {
        let vatID = '';
        if(!this.memberGovernmentIdentifiations && !this.memberGovernmentIdentifiations.length && this.fboProfileDetail && this.fboProfileDetail.memberId){
            this.getMembergovernmentIdentificationsInfo(this.fboProfileDetail.memberId);
         }
        if (this.fboProfileDetail && this.memberGovernmentIdentifiations && !!this.memberGovernmentIdentifiations.length  && this.fboProfileDetail.homeCountryId) {
            const memberGovernmentIdentifiation = this.memberGovernmentIdentifiations.find(x => (x.governmentIdentificationType).toUpperCase() === GovernmentIdentificationType.VAT_ID && x.countryID === this.fboProfileDetail.homeCountryId);
            vatID = memberGovernmentIdentifiation && memberGovernmentIdentifiation.value ? memberGovernmentIdentifiation.value : '';
        }
        return vatID;
    }

    populateAddress() {
        let address:BusinessEntityAddress = { line1: '', line2: '', line3: '', line4: '', city: '', state: '', postalCode: '', Country: '', countryCode: '' };
        if (this.fboProfileDetail && this.fboProfileDetail.address) {
            const memberAddress = this.fboProfileDetail.address;
            const countryIsoCodeTwo = !!this.countriesList.length && memberAddress.countryId ? this.countriesList.filter(item => item.countryId == memberAddress.countryId)[0] : '';
            address.id = memberAddress.id ? memberAddress.id.toString():'';
            address.line1 = memberAddress.addressLine1 ? memberAddress.addressLine1 : '';
            address.line2 = memberAddress.addressLine2 ? memberAddress.addressLine2 : '';
            address.line3 = memberAddress.addressLine3 ? memberAddress.addressLine3 : '';
            address.line4 = memberAddress.addressLine4 ? memberAddress.addressLine4 : '';
            address.city = memberAddress.city ? memberAddress.city : '';
            address.state = memberAddress.state ? memberAddress.state : '';
            address.postalCode = memberAddress.zipCode ? memberAddress.zipCode : '';
            address.Country = memberAddress.country ? memberAddress.country : '';
            address.countryCode = countryIsoCodeTwo ? countryIsoCodeTwo.isocodeTwo : '';
        }
        return address
    }

    /**
     * @description
     * @date 2019-08-13
     * @memberof FBOProfileComponent
     */
    onMemberNameChange(): void {

        if (this.changeMemberNameForm.value && this.changeMemberNameForm.value.firstName === this.basicInfo.firstName &&
            this.changeMemberNameForm.value.middleName === this.basicInfo.middleName &&
            this.changeMemberNameForm.value.lastName === this.basicInfo.lastName) {
            this.nameUpdate = true;
        } else {
            this.nameUpdate = false;
        }
    }

    /**
     * @description
     * @date 2019-08-02
     * @param {boolean} isValid
     * @memberof FBOProfileComponent
     */
    onSubmitMemberName(isValid: boolean): void {
        this.disableNameButton = true;
        this.errorCodes = [];
        if (isValid) {
            if (this.changeMemberNameForm && this.changeMemberNameForm.value && this.basicInfo) {
                const updateBasicInfo: MemberBasicInfo = Object.assign({}, this.basicInfo);
                updateBasicInfo.firstName = this.changeMemberNameForm.value.firstName;
                updateBasicInfo.middleName = this.changeMemberNameForm.value.middleName;
                updateBasicInfo.lastName = this.changeMemberNameForm.value.lastName;
                if (this.basicInfo.firstName !== this.changeMemberNameForm.value.firstName
                    || this.basicInfo.lastName !== this.changeMemberNameForm.value.lastName) {
                    const verifyAccountModel: VerifyAccountModel = this.prepareMemberVerifyAccountRequest(updateBasicInfo);
                    this._customerService.validateMemberUniqueFieldsWithAddress(verifyAccountModel)
                        .subscribe((response: VerifyAccountModel) => {
                            if (response && !response.accountExists) {
                                this.updateNameForMemberBasicInfo(updateBasicInfo);
                            } else if (response && response.accountExists) {
                                const msg = this._translatePipe.get('customer-service.User details exists')['value'];
                                this._commonService.createNotification('', msg, NotificationType.ERROR);
                            }
                        }, err => { });
                } else {
                    this.updateNameForMemberBasicInfo(updateBasicInfo);
                }
            }
        }
    }

    /**
     * @description
     * @date 2019-08-09
     * @private
     * @param {MemberBasicInfo} updateBasicInfo
     * @returns {VerifyAccountModel}
     * @memberof FBOProfileComponent
     */
    private prepareMemberVerifyAccountRequest(updateBasicInfo: MemberBasicInfo): VerifyAccountModel {
        const verifyAccountModel: VerifyAccountModel = {
            includeMemberTypeToVerify: true,
            firstName: updateBasicInfo.firstName,
            lastName: updateBasicInfo.lastName,
            memberTypeId: this.fboProfileDetail.memberTypeId,
            addressTypeId: this.fboProfileDetail.address.addressTypeId,
            addressLine1: this.fboProfileDetail.address.addressLine1,
            addressLine2: this.fboProfileDetail.address.addressLine2 ? this.fboProfileDetail.address.addressLine2 : '',
            city: this.fboProfileDetail.address.city,
            stateId: this.fboProfileDetail.address.stateId,
            postalCode: this.fboProfileDetail.address.zipCode,
            countryId: this.fboProfileDetail.address.countryId,
            memberId: this.fboProfileDetail.memberId
        };
        return verifyAccountModel;
    }
    /**
     * @description
     * @date 2019-08-09
     * @param {MemberBasicInfo} updateBasicInfo
     * @memberof FBOProfileComponent
     */
    updateNameForMemberBasicInfo(updateBasicInfo: MemberBasicInfo): void {
        if (this.basicInfo.firstName !== this.changeMemberNameForm.value.firstName
            || this.basicInfo.lastName !== this.changeMemberNameForm.value.lastName
            || this.basicInfo.middleName !== this.changeMemberNameForm.value.middleName) {
            updateBasicInfo.changedValueType = [FBOProfileUpdateEnum.MEMBER_NAME_CHANGE];
        }
        let transliterateProp = this.populateTransliterateObj();
        this._customerService.updateMemberBasicInfo(updateBasicInfo, transliterateProp).subscribe(response => {
            if (response.success) {
                this.saveMemberNameActiveLog(this.basicInfo, updateBasicInfo);
                const msg = this._translatePipe.get('customer-service.Update completed Successful.')['value'];
                this._commonService.createNotification('', msg, NotificationType.SUCCESS);
                this.updateMemberNamePopup.close();
                this.disableNameButton = false;
                this.getFBOProfileInfoFromTitan();
            } else if (response.validations && response.validations.length) {
                this.errorCodes = response.validations;
                this.disableNameButton = false;
            }
        }, err => { });

    }
    /**
     * @description
     * @date 2019-08-09
     * @param {MemberBasicInfo} basicInfo
     * @param {MemberBasicInfo} updateBasicInfo
     * @memberof FBOProfileComponent
     */
    saveMemberNameActiveLog(basicInfo: MemberBasicInfo, updateBasicInfo: MemberBasicInfo): void {
        const activityLogKeys: ActivityLogKey[] = [];
        if (basicInfo.firstName !== updateBasicInfo.firstName) {
            activityLogKeys.push({
                key: MemberActivityLogType.Member_First_Name_Updated,
                value: updateBasicInfo.firstName
            });
        }
        if (basicInfo.middleName !== updateBasicInfo.middleName) {
            activityLogKeys.push({
                key: MemberActivityLogType.Member_Middle_Name_Updated,
                value: updateBasicInfo.middleName
            });
        }
        if (basicInfo.lastName !== updateBasicInfo.lastName) {
            activityLogKeys.push({
                key: MemberActivityLogType.Member_Last_Name_Updated,
                value: updateBasicInfo.lastName
            });
        }
        if (activityLogKeys && activityLogKeys.length) {
            this._commonService.saveMemberActivity(basicInfo.memberId, activityLogKeys)
                .subscribe(res => { }, (error: any) => { });
        }

    }
    /**
     * @description open phone number update modal
     * @date 2019-07-29
     * @memberof FBOProfileComponent
     */
    openUpdatePhoneNumberModal(): void {
        this.errorCodes = [];
        this.closePhoneNumberPopup();
        this._customerService.getMemberBasicInfoById(+this.fboProfileDetail.memberId).subscribe((basicInfo: MemberBasicInfo) => {
            if (basicInfo) {
                this.showUpdatePhoneModal = true;
                this.basicInfo = basicInfo;
                this.mapBasicInfoResponse();
                this.updatePhoneNumberForm = this._formbuilder.group({
                    phoneType: [this.basicInfo.phoneType, [Validators.required]],
                    phoneNumber: [this.basicInfo.phone, this.addValidationsForForm()]
                });
                this.updatePhoneNumberPopup.open();
            }
        }, errorRes => {
            const addedNotification = this._translatePipe.get('errorcodes.Unable to Update Phone Number. Please try again later')['value'];
            this._commonService.createNotification('', addedNotification, NotificationType.ERROR);
        });
    }

    addValidationsForForm(isPhoneNotRequired?: boolean) {
        const fieldValidations = [];
        const formControlName = this.personalInfoFormValidations
            ? this.personalInfoFormValidations[PersonalInfoFormConstants.PHONENUMBER]
            : {};
        if (formControlName) {
            if (formControlName[PersonalInfoFormConstants.MINLENGTH]) {
                fieldValidations.push(Validators.minLength(formControlName[PersonalInfoFormConstants.MINLENGTH]));
            }
            if (formControlName[PersonalInfoFormConstants.MAXLENGTH]) {
                fieldValidations.push(Validators.maxLength(formControlName[PersonalInfoFormConstants.MAXLENGTH]));
            }
            if (formControlName[PersonalInfoFormConstants.PATTERN]) {
                fieldValidations.push(Validators.pattern(formControlName[PersonalInfoFormConstants.PATTERN]));
            }
            if (formControlName[PersonalInfoFormConstants.Required]) {
                if (!(this.phoneNumbers && this.phoneNumbers.length > 1)) {
                    if (!isPhoneNotRequired) {
                        fieldValidations.push(Validators.required);
                    }
                }
            }
        }
        return fieldValidations;
    }

    /**
     * @description map phone number while changing phone type
     * @date 2019-07-29
     * @memberof FBOProfileComponent
     */
    onChangePhoneType(value: string): void {
        const phoneNumber = this.basicInfo.memberContacts.find(x =>
            (x.contactTypeID === +value));
        let phone: any;
        if (phoneNumber) {
            if (this.phoneNumberFormat) {
                phone = this._maskPipe.transform(phoneNumber.value, this.phoneNumberFormat);
            } else {
                phone = phoneNumber.value;
            }
            this.updatePhoneNumberForm.controls['phoneNumber'].setValue(phone);
            this.updatePhoneNumberForm.controls['phoneNumber'].setValidators(this.addValidationsForForm(false));
            this.updatePhoneNumberForm.controls['phoneNumber'].updateValueAndValidity();
        } else {
            this.updatePhoneNumberForm.controls['phoneNumber'].setValue('');
            this.updatePhoneNumberForm.controls['phoneNumber'].setValidators(this.addValidationsForForm(true));
            this.updatePhoneNumberForm.controls['phoneNumber'].updateValueAndValidity();
        }
    }

    /**
     * @description map basic info response
     * @date 2019-07-29
     * @memberof FBOProfileComponent
     */
    mapBasicInfoResponse(): void {
        const phoneNumber = this.basicInfo.memberContacts.find(x => (x.contactTypeID === ContactTypeValue.MOBILE
            || x.contactTypeID === ContactTypeValue.PHONE));
        if (phoneNumber) {
            this.phoneNumberFormat = this.phoneNumberFormat || '';
            if (this.phoneNumberFormat) {
                this.basicInfo.phone = this._maskPipe.transform(phoneNumber.value, this.phoneNumberFormat);
            } else {
                this.basicInfo.phone = phoneNumber.value;
            }
            this.basicInfo.phoneType = phoneNumber.contactTypeID;
        }
        this.basicInfo.memberContacts.forEach(info => {
            if (info.contactTypeID === ContactTypeValue.MOBILE || info.contactTypeID === ContactTypeValue.PHONE) {
                this.phoneNumbers.push(info);
            }
        });
    }

    /**
     * @description close phone number popup
     * @date 2019-07-29
     * @memberof FBOProfileComponent
     */
    closePhoneNumberPopup(): void {
        this.updatePhoneNumberPopup.close();
        this.showUpdatePhoneModal = false;
        this.phoneNumbers = [];
    }


    /**
     * @description Update phone number
     * @date 2019-07-29
     * @memberof FBOProfileComponent
     */
    onSubmitPhoneNumber(isValid: boolean): void {
        this.errorCodes = [];
        if (isValid) {
            if (this.updatePhoneNumberForm && this.updatePhoneNumberForm.value && this.basicInfo) {
                const phone = this.updatePhoneNumberForm.value.phoneNumber.trim().replace(/[^a-zA-Z0-9]/g, '');
                this._customerService.updateMemberBasicInfo(this.mapPhoneNumberToBasicInfo(this.basicInfo, phone,
                    +this.updatePhoneNumberForm.value.phoneType)).subscribe(response => {
                        if (response.success) {
                            this.saveMemberPhoneActivityLog(phone, +this.updatePhoneNumberForm.value.phoneType);
                            const msg = this._translatePipe.get('customer-service.Update completed Successful.')['value'];
                            this._commonService.createNotification('', msg, NotificationType.SUCCESS);
                            this.closePhoneNumberPopup();
                            this.getFBOProfileInfoFromTitan();
                        } else if (response.validations && response.validations.length) {
                            this.errorCodes = response.validations;
                        }
                    }, err => { });
            }
        }
    }

    /** Save member activity log while updating phone number
     *saveMemberPhoneActivityLog()
    */
    saveMemberPhoneActivityLog(phone: string, phoneType: number): void {
        const activityLogKeys: ActivityLogKey[] = [];
        if (this.basicInfo.phone !== phone) {
            const value = this.contactTypes.find(x => x.value === phoneType).name;
            const translateValue = this.getMessageTemplate(false,
                ContactTypeValue.PHONE === phoneType ? PhoneUpdateMessageConstants.HOME : value, '', phone);
            activityLogKeys.push({
                key: MemberActivityLogType.Phone_Updated,
                value: translateValue
            });
        }
        if (this.basicInfo.phoneType !== phoneType) {
            const value = this.contactTypes.find(x => x.value === phoneType).name;
            const oldType = this.contactTypes.find(x => x.value === this.basicInfo.phoneType).name;
            const translateValue = this.getMessageTemplate(true,
                ContactTypeValue.PHONE === phoneType ? PhoneUpdateMessageConstants.HOME : value,
                ContactTypeValue.PHONE === this.basicInfo.phoneType ? PhoneUpdateMessageConstants.HOME : oldType);
            activityLogKeys.push({
                key: MemberActivityLogType.Phone_Type_Updated,
                value: translateValue
            });
        }
        this._commonService.saveMemberActivity(this.fboProfileDetail.id, activityLogKeys).subscribe();
    }

    /** get message while updating phone number and type.
     * getMessageTemplate()
    */
    getMessageTemplate(isUpdatePhoneType, phoneType?: string, oldType?: string, phoneNumber?: string): string {
        let value = '';
        if (isUpdatePhoneType) {
            const translatedValues = {
                phoneType: phoneType,
                oldType: oldType
            };
            value = this._translateKey.transform(PhoneUpdateMessageConstants.PHONE_TYPE_UPDATE_TEMPLATE, translatedValues);
        } else {
            const translatedValues = {
                phoneType: phoneType,
                phoneNumber: phoneNumber
            };
            value = this._translateKey.transform(PhoneUpdateMessageConstants.PHONE_UPDATE_TEMPLATE, translatedValues);
        }
        return value;
    }

    /**
    * Mapping member basic info request
    */
    mapPhoneNumberToBasicInfo(profileInfo: MemberBasicInfo, phone: string, phoneType: number) {
        const phoneNumber = profileInfo.memberContacts.find(x => (x.contactTypeID === phoneType));
        if (phoneNumber) {
            profileInfo.memberContacts.forEach(item => {
                if (item.contactTypeID === phoneType) {
                    item.value = phone;
                }
            });
        } else {
            const phoneContact = {
                contactTypeID: phoneType,
                value: phone
            };
            profileInfo.memberContacts.push(phoneContact);
        }
        const memberBasicInfo: MemberBasicInfo = {
            firstName: profileInfo.firstName,
            displayName: profileInfo.displayName,
            lastName: profileInfo.lastName,
            middleName: profileInfo.middleName,
            memberId: profileInfo.memberId,
            userId: profileInfo.userId,
            email: profileInfo.email,
            primaryEmailId: profileInfo.email,
            phoneNumber: phone,
            memberPreferences: profileInfo.memberPreferences,
            memberContacts: profileInfo.memberContacts,
            phone: phone,
            phoneType: phoneType,
            storeId: this.storeId,
            memberGovernmentIdentifications: profileInfo.memberGovernmentIdentifications,
            changedValueType: [FBOProfileUpdateEnum.MEMBER_PHONE_CHANGE]
        };
        return memberBasicInfo;
    }

    /**
    * To Create or Update notification immediately
    */
    accountNotificationSubmit = () => {
        let payload: AccountNotificationRequest;
        if (this.accountNotification) {
            payload = Object.assign({}, this.accountNotification);
            payload.enable = this.accountNotificationForm.value.enable;
        } else {
            payload = {
                enable: this.accountNotificationForm.value.enable
            };
        }
        payload.subject = this.accountNotificationForm.value.subject;
        payload.body = this.accountNotificationForm.value.body;
        this._customerService.AccountNotificationChange(payload, this.fboProfileDetail.memberId).subscribe(response => {
            if (response.success) {
                let logKey: number;
                if (this.accountNotification && this.accountNotification.enable && !this.accountNotificationForm.value.enable) {
                    logKey = MemberActivityLogType.Account_Notification_Disabled;
                } else if (!this.accountNotification) {
                    logKey = MemberActivityLogType.Account_Notification_Created;
                } else {
                    logKey = MemberActivityLogType.Account_Notification_Updated;
                }
                const activityLogKeys: ActivityLogKey[] = [{
                    key: logKey,
                    value: null
                }];
                this._commonService.saveMemberActivity(this.fboProfileDetail.id, activityLogKeys).subscribe();
                const notification: any = this._translatePipe.get('customer-service.Account Notification Updated Successfully');
                this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                this.accountNotificationChangePopup.close();
                this.getFBOProfileInfoFromTitan(true);
            } else if (response.validations && response.validations.length) {
                const addedNotification: any = this._translatePipe.get('errorcodes.' + response.validations[0].name);
                this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
            }
        }, error => {
            if (error && error.validations && error.validations.length) {
                const addedNotification: any = this._translatePipe.get('errorcodes.' + error.validations[0].name);
                this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
            } else {
                const addedNotification: any = this._translatePipe.get('errorcodes.Unable to Update Account Notification. Please try again later.');
                this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
            }
        });

    }


    /**
    * Tiggers when enable checkbox in Account notification popup is changed
    */
    enableAccountNotificationChange = (event) => {
        if (event.currentTarget.checked) {
            this.accountNotificationForm.controls['subject'].setValidators(Validators.required);
            this.accountNotificationForm.controls['subject'].updateValueAndValidity();
        } else {
            this.accountNotificationForm.controls['subject'].clearValidators();
            this.accountNotificationForm.controls['subject'].updateValueAndValidity();
        }

    }


    /**
     * To display Change Email Popup
     */
    openChangeEmailModal = () => {
        this.errorCodes = [];
        this.emailForm = this._formbuilder.group({
            email: ['', [Validators.required, Utils.emailValidationRule]],
            confirmEmail: ['', [Validators.required, Utils.emailValidationRule]]
        });
        this.changeEmailPopup.open();
    }

    /**
    * To display Account Notification Popup
    */
    openChangeAccountNotificationModal = () => {
        if (this.accountNotification) {
            this.accountNotificationForm = this._formbuilder.group({
                subject: [this.accountNotification.subject ? this.accountNotification.subject : '', this.accountNotification.enable ? Validators.required : ''],
                body: [this.accountNotification.body ? this.accountNotification.body : ''],
                enable: this.accountNotification.enable ? true : false
            });
        } else {
            this.accountNotificationForm = this._formbuilder.group({
                subject: ['', Validators.required],
                body: [''],
                enable: true
            });
        }
        this.accountNotificationChangePopup.open();
    }

    openUpdateDOBModal() {
        this.changeDOBForm = this._formbuilder.group({
            birthDate: ['', Validators.required]
        });
        document.documentElement.classList.add('dob-popup');
        this.changeDOBPopup.open();
        setTimeout(function () {
            const element = document.getElementById('birthDate');
            if (element) {
                element.focus();
            }
        }, 200);
        if (this.fboProfileDetail.birthDate) {
            this.changeDOBForm.controls['birthDate'].setValue(moment(this.fboProfileDetail.birthDate, 'dd-MMM-yyyy'));
        }
        this.changeDOBForm.controls['birthDate'].setValidators([Validators.required, Utils.validateDateOfBirth]);
    }

    checkValidationForMonthlyLimitEndDate() {
        this.overrideMonthlyCCLimitForm.controls['endDate'].updateValueAndValidity();
    }

    onStatusChange = () => {
        this.statusForm.valueChanges.subscribe(formData => {
            if (formData.newstatus) {
                if (formData.newstatus == MemberStatus.Suspended) {
                    if (!this.isSuspendedStatus) {
                        this.isSuspendedStatus = true;
                        this.statusForm.controls['endDate'].setValidators([Validators.required, Utils.validateFutureDate]);
                    }
                } else {
                    if (this.isSuspendedStatus) {
                        this.isSuspendedStatus = false;
                        this.statusForm.controls['endDate'].clearValidators();
                        this.statusForm.controls['endDate'].setValue('');
                    }
                }
                this.statusChanged = true;
            }
        });
    }

    ChangeStatusSubmit = () => {
        this.disableStatusButton = false;
        this.statusForm.value.endDate = Utils.convertToSpecificDateFormat(this.statusForm.value.endDate, DateConstants.DOBConvertFormat);
        const payload = {
            'memberId': this.fboProfileDetail.fboId,
            'newstatus': this.statusForm.value.newstatus,
            'endDate': this.statusForm.value.endDate,
            'isRetailSubscriber': this.isRetailSubscriptionLogin
        };
        this._customerService.updateMemberStatus(payload).subscribe(response => {
            if (response && response.success) {
                let retailSubscriptionDetails={
                    isRetailSubscriptionCancelled:response.isRetailSubscriptionCancelled,
                    isretailSubscriptionMessage:response.retailSubscriptionMessage,
                    initialMsg:'',
                    msgType:NotificationType.SUCCESS
                }
                const activityLogKeys: ActivityLogKey[] = [{
                    key: MemberActivityLogType.Change_Status,
                    value: MemberStatus[this.statusForm.value.newstatus] + ' for ' + this.fboProfileDetail.fboId
                }];
                this._commonService.saveMemberActivity(this.fboProfileDetail.id, activityLogKeys).subscribe();

                let notesData = {
                    "noteTypeID": MemberNoteType.AccountStatusChangeTypeID,
                    "description": this.statusForm.controls['notes'].value.trim(),
                    "summary": "Member Status is changed from " + MemberStatus[this.memberStatus.id].toString() + " to " + MemberStatus[this.statusForm.controls['newstatus'].value].toString(),
                    "createdByUserId": this.userInfo.userId,
                    "createdByUserName": this.userInfo.userName,
                    "createdDate": new Date(),
                    "memberId": this.fboProfileDetail.id ? this.fboProfileDetail.id : null,
                    "distributorId": this._id,
                    "memberAccountStatusId": this.statusForm.controls['newstatus'].value,
                }
                this._customerservice.saveNoteAtMemberLevel(notesData).subscribe((response) => {
                    if (response && response.isSuccess) {
                        retailSubscriptionDetails.msgType = NotificationType.SUCCESS;
                        retailSubscriptionDetails.initialMsg = Constants.STATUS_UPDATED;
                        const retailSubscriptionMsg = this.showCancellationMsg(retailSubscriptionDetails);
                        const msg = (this._translatePipe.get('customer-service.'+retailSubscriptionMsg.initialMsg) as any).value; ;
                        this._commonService.createNotification('', msg, retailSubscriptionMsg.msgType );
                    }
                    else {
                        this.statusUpdateErrorMessage(retailSubscriptionDetails);
                    }
                },
                    () => {
                        this.statusUpdateErrorMessage(retailSubscriptionDetails);
                    });

                this.statusChanged = false;
                this.changeStatusPopup.close();
                this.getFBOProfileInfoFromTitan();

            } else if (response.validations && response.validations.length) {
                const addedNotification: any = this._translatePipe.get('errorcodes.' + response.validations[0].name);
                this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
            }
            this.disableStatusButton = true;
        }, error => {
            if (error && error.validations && error.validations.length) {
                const addedNotification: any = this._translatePipe.get('errorcodes.' + error.validations[0].name);
                this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
            } else {
                const addedNotification: any = this._translatePipe.get('errorcodes.FAIL: SYSDWN. Valence API for Status Change');
                this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
            }
            this.disableStatusButton = true;
        });
    }

    showCancellationMsg(retailSubscriptionDetails) {
        let notification = { ...retailSubscriptionDetails };
        if (this.isRetailSubscriptionLogin) {
            if (retailSubscriptionDetails.isRetailSubscriptionCancelled && retailSubscriptionDetails.isretailSubscriptionMessage) {
                notification.initialMsg = notification.initialMsg + ',' + Constants.SUBSCRIPTION_CANCELLED;
                notification.msgType = NotificationType.SUCCESS;
            }
            if (!retailSubscriptionDetails.isRetailSubscriptionCancelled && retailSubscriptionDetails.isretailSubscriptionMessage) {
                notification.initialMsg = notification.initialMsg + ',' + Constants.SUBSCRIPTION_CANCELLED_ERROR;
                notification.msgType = NotificationType.ERROR;
            }
        }
        return notification;
    }

    statusUpdateErrorMessage(isretailSubscriptionMessage?) {
        isretailSubscriptionMessage.initialMsg = Constants.STATUS_UPDATED_NOTE_FAILED;
        const retailSubscriptionMsg = this.showCancellationMsg(isretailSubscriptionMessage);
        const msg = (this._translatePipe.get('customer-service.'+retailSubscriptionMsg.initialMsg) as any).value;
        this._commonService.createNotification('', msg, NotificationType.ERROR);
    }
    businessEnitiySubmit() {
        this.disableBusinessEntityButton = true;
        this.businessEntityForm.value.startDate=moment(new Date(), 'DD-MMM-YYYY');
        this.businessEntityForm.controls['startDate'].setValue(this.businessEntityForm.value.startDate);
        this.businessEntityBWP = true;
        this.vatIdBWP = false;
        this.checkBondedWarehouseProject();
    }
    checkBusinessEntitySubmit() {
        if (this.appConfig && this.appConfig.businessEntityConfig && this.appConfig.businessEntityConfig.hideStateCode
            && !this.businessEntityForm.value.stateCodeId) {
            const state = this.states.filter(item => item.countryId == this.businessEntityForm.value.countryCodeId)[0];
            this.businessEntityForm.controls['stateCodeId'].setValue(state.id);
        }
        this.businessEntityForm.value.startDate=moment(new Date(), 'DD-MMM-YYYY');
        if (this.appConfig && this.appConfig.businessEntityConfig && this.appConfig.businessEntityConfig.showVatPayer) {
            if (VatPayerOption.Y === +this.businessEntityForm.value.vatPayer) {
                this.businessEntityForm.value.vatPayer = 'Y'
            } else {
                this.businessEntityForm.value.vatPayer = 'N'
            }
        }
        this.businessEntityForm.value.endDate = Utils.convertToSpecificDateFormat(this.businessEntityForm.value.endDate, DateConstants.DOBConvertFormat);
        this.businessEntityForm.value.startDate = Utils.convertToSpecificDateFormat(this.businessEntityForm.value.startDate, DateConstants.DOBConvertFormat);
        let transliterateProp = this.populateTransliterateObj();
        if (this.fboBusinessEntity && this.businessEntityForm && this.businessEntityForm.value) {
            let formattedStartDate = moment(this.fboBusinessEntity.startDate, "DD-MMM-YYYY").format("DD-MM-YYYY");
            if (this.fboBusinessEntity.businessEntityName != this.businessEntityForm.value.businessEntityName
                || this.fboBusinessEntity.businessEntityIdType != this.businessEntityForm.value.businessEntityIdType
                || this.fboBusinessEntity.businessEntityId != this.businessEntityForm.value.businessEntityId
                || this.fboBusinessEntity.incomeTaxID != this.businessEntityForm.value.incomeTaxID
                || this.fboBusinessEntity.addressLine1 != this.businessEntityForm.value.addressLine1
                || this.fboBusinessEntity.addressLine2 != this.businessEntityForm.value.addressLine2
                || this.fboBusinessEntity.city != this.businessEntityForm.value.city
                || this.fboBusinessEntity.countryCodeId != this.businessEntityForm.value.countryCodeId
                || formattedStartDate != this.businessEntityForm.value.startDate
                || this.fboBusinessEntity.endDate != this.businessEntityForm.value.endDate
                || this.fboBusinessEntity.status != this.businessEntityForm.value.status) {
                this.updateBusinessEntity = true;
            }
        }

        if(this.businessEntityForm.value.endDate && (this.businessEntityForm.value.endDate < this.businessEntityForm.value.startDate)){
            const notification: any = this._translatePipe.get('order.Unable to Update Business Entity');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        } else {
        this._customerService.updateBusinessEntity(this.fboProfileDetail.memberId, this.businessEntityForm.value,transliterateProp,this.updateBusinessEntity).subscribe(response => {
            if (response.isSuccess) {
                const activityLogKeys: ActivityLogKey[] = [{
                    key: MemberActivityLogType.Change_Business_Entity,
                    value: this.prepareBussinessEntityLogMessage(this.businessEntityForm.value)
                }];
                this._commonService.saveMemberActivity(this.fboProfileDetail.id, activityLogKeys).subscribe();
                this.changeBusinessEntityPopup.close();
                this.bwpConfirmationModal.close();
                this.disableBusinessEntityButton = false;
                this.updateBusinessEntity = false;
                if(this.businessEntityInfo && this.businessEntityInfo.length >0){
                const notification: any = this._translatePipe.get('order.Business Entity Updated Sucessfully.Today’s Date will be the New Start Date.');
                this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                } else {
                    const notification: any = this._translatePipe.get('order.Business Entity Updated Sucessfully');
                    this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                }
                this.getMemberBusinessEntityInfo(this.fboProfileDetail.memberId,this.fboProfileDetail.homeCountryCode,this.fboProfileDetail.preferenceValue);
            } else {
                this.updateBusinessEntity = false;
                this.disableBusinessEntityButton = false;
                const notification: any = this._translatePipe.get('order.Unable to Update Business Entity');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            }
        });
        }
    }
    prepareBussinessEntityLogMessage(businessEntity: any): string {
        let businessEntityLogMessage = businessEntity.businessEntityName;
        if (businessEntity.businessEntityId && businessEntity.businessEntityId !== '') {
            businessEntityLogMessage += ', ' + businessEntity.businessEntityId.substr(-4);
        }
        if (businessEntity.incomeTaxID && businessEntity.incomeTaxID !== '') {
            businessEntityLogMessage += ', ' + businessEntity.incomeTaxID.substr(-4);
        }
        if (businessEntity.businessEntityIdType && businessEntity.businessEntityIdType !== '') {
            if (businessEntity.businessEntityIdType == BusinessEntityIdType.CORPORATION) {
                businessEntityLogMessage += ', ' + BusinessEntityType.CORPORATION;
            } else if (businessEntity.businessEntityIdType == BusinessEntityIdType.LIABILITY) {
                businessEntityLogMessage += ', ' + BusinessEntityType.LIABILITY;
            } else if (businessEntity.businessEntityIdType == BusinessEntityIdType.OTHER_BUSINESS_ENTITY) {
                businessEntityLogMessage += ', ' + BusinessEntityType.OTHER_BUSINESS_ENTITY;
            } else if (businessEntity.businessEntityIdType == BusinessEntityIdType.TRUST) {
                businessEntityLogMessage += ', ' + BusinessEntityType.TRUST;
            }
        }
        businessEntityLogMessage += ', ' + businessEntity.addressLine1;
        if (businessEntity.addressLine2 && businessEntity.addressLine2 !== '') {
            businessEntityLogMessage += ', ' + businessEntity.addressLine2;
        }
        if (businessEntity.city && businessEntity.city !== '') {
            businessEntityLogMessage += ', ' + businessEntity.city;
        }
        if (businessEntity.stateCodeId && businessEntity.stateCodeId !== '') {
            const statesModal = this.states.filter(item => item.id == businessEntity.stateCodeId)[0];
            businessEntityLogMessage += ', ' + statesModal.stateCode;
        }
        if (businessEntity.countryCodeId && businessEntity.countryCodeId !== '') {
            const countriesModal = this.countriesList.filter(item => item.countryId === businessEntity.countryCodeId)[0];
            businessEntityLogMessage += ', ' + countriesModal.isocodeThree;
        }
        businessEntityLogMessage += ', ' + businessEntity.postalCode + '.';
        if (businessEntity.status && businessEntity.status !== '') {
            businessEntityLogMessage += ' Status is ' + (businessEntity.status == 1 ? 'Active' : 'In-Active');
        }
        if (businessEntity.startDate && businessEntity.startDate !== '') {
            businessEntityLogMessage += ', Start Date ' + this.convertTODateFormat(moment(this.convertToSpecificDateFormat(businessEntity.startDate), 'DD-MMM-YYYY'));
        }
        if (businessEntity.endDate && businessEntity.endDate !== '') {
            businessEntityLogMessage += ', End Date ' + this.convertTODateFormat(moment(this.convertToSpecificDateFormat(businessEntity.endDate), 'DD-MMM-YYYY'));
        }

        return businessEntityLogMessage;
    }
    statusChangeTransformDate(date: any) {
        const dateMomentObj = Utils.convertToSpecificDateFormat(date, DateConstants.DateFormat);
        if (dateMomentObj) {
            if (!(this.statusForm.controls['endDate'].hasError('Required') || this.statusForm.controls['endDate'].hasError('dateValidation'))) {
                this.statusForm.controls['endDate'].setValue(moment(dateMomentObj, 'DD-MMM-YYYY'));
            }
        }
    }
    convertTODateFormat(dateMomentObj: any) {
        const characterCheck = /[a-zA-z]/;
        if (typeof dateMomentObj._i === 'object') {
            dateMomentObj = dateMomentObj._d;
            dateMomentObj = this.momentConstructor(new Date(dateMomentObj))
                .format('DD-MMM-YYYY');
        }
        if (typeof dateMomentObj._i === 'string') {
            dateMomentObj = dateMomentObj._i;
            const dateParts = dateMomentObj.split('-');
            if (!characterCheck.test(dateParts[1])) {
                dateMomentObj = this.momentConstructor(new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]))
                    .format('DD-MMM-YYYY');
            }
        }
        return dateMomentObj;
    }

    /**
* @description convert date to specific format
* @date 2019-01-03
* @param {*} dateMomentObj
* @returns
* @memberof CreateWorkTicket
*/
    convertToSpecificDateFormat(dateMomentObj: any) {
        if (dateMomentObj) {
            const characterCheck = /[a-zA-z]/;
            if (dateMomentObj && typeof dateMomentObj._i === 'object') {
                dateMomentObj = dateMomentObj._d;
                dateMomentObj = this.momentConstructor(new Date(dateMomentObj))
                    .format('DD-MM-YYYY');
            }
            if (dateMomentObj && typeof dateMomentObj._i === 'string') {
                dateMomentObj = dateMomentObj._i;
                const dateParts = dateMomentObj.split('-');
                if (characterCheck.test(dateParts[1])) {
                    dateMomentObj = moment(dateMomentObj, 'DD-MMM-YYYY').format('DD-MM-YYYY');
                } else {
                    dateMomentObj = this.momentConstructor(new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0])).format('DD-MM-YYYY');
                }
            }
        }
        return dateMomentObj;
    }

    businessEntityTransformDate(date: any, isStartDate: boolean) {
        const dateMomentObj = Utils.convertToSpecificDateFormat(date, DateConstants.DOBConvertFormat);
        if (dateMomentObj) {
            if (isStartDate) {
                if (this.businessEntityForm.controls['startDate'].valid) {
                    this.businessEntityForm.controls['startDate'].setValue(moment(dateMomentObj, 'DD-MM-YYYY'));
                }
            } else if (this.businessEntityForm.controls['endDate'].valid) {
                this.businessEntityForm.controls['endDate'].setValue(moment(dateMomentObj, 'DD-MM-YYYY'));
            }
        }
    }

    /**
     * @description convert to Date Format
     * @date 2019-06-12
     * @param {string} date
     * @memberof FBOProfileComponent
     */
    convertDateFormat(date: string): void {
        this.businessEntityForm.controls['startDate'].setValue(moment(date, 'DD-MMM-YYYY'));
    }

    birthdatetransformDate(date: any) {
        const dateMomentObj = Utils.convertToSpecificDateFormat(date, DateConstants.DOBConvertFormat);
        if (dateMomentObj) {
            if (this.changeDOBForm.controls['birthDate'].valid) {
                this.changeDOBForm.controls['birthDate'].setValue(moment(dateMomentObj, 'DD-MM-YYYY'));
            }
        }
    }


    checkValidationForStartDate() {
        this.businessEntityForm.controls['startDate'].updateValueAndValidity();
    }
    checkValidationForEndDate() {
        if (this.businessEntityForm) {
            this.businessEntityForm.controls['endDate'].updateValueAndValidity();
        }
    }

    checkValidationForStatusEndDate = () => {
        this.statusForm.controls['endDate'].updateValueAndValidity();
    }

    /**
     * @description Fetch PC Sponsor participation details of Store
     * @param store
     */
    private fetchPCSponsorEligiblityForStore(store){
        if(store && store.businessEntityId){
            this._configurationService.getBusinessEntityDetails(store.businessEntityId).subscribe((businessEntityDetails) => {
                if(businessEntityDetails && businessEntityDetails.pCSponsorshipParticipationType == PCSponsorConstants.PCSPONSORSHIP_PARITICIPATION_TYPE
                        && !environment.hidePCSponsorshipCountries.split(',').includes(this.storeInfo.operatingCountry)){
                        this.enableUpdatePCSponsor = true;
                }
                else{
                    this.enableUpdatePCSponsor = false;
                }
            });
        }
}

    openChangeStatusModal = () => {
        this._customerService.getMemberStatusesFromTitan().subscribe(
            response => {
                const memberStatuses = response;
                if (this.memberStatus) {
                    this.statusDropdownItems = memberStatuses.filter(status => status.id != this.memberStatus.id);
                    if (this.memberStatus.id == MemberStatus.Active) {
                        this.statusDropdownItems = this.statusDropdownItems.filter(status => status.id != MemberStatus.Pending);
                    }
                } else {
                    this.statusDropdownItems = memberStatuses;
                }
                this.statusDropdownItems.sort((a, b) => a.value.toUpperCase() !== b.value.toUpperCase() ? (a.value.toUpperCase() < b.value.toUpperCase() ? -1 : 1) : 0);
                this.isSuspendedStatus = false;
                this.statusChanged = false;
                this.statusForm = this._formbuilder.group({
                    newstatus: ['', [Validators.required]],
                    endDate: [''],
                    notes: ['', [Validators.required, CustomValidators.requiredNotEmpty, Validators.maxLength(2000)]]
                });
                this.changeStatusPopup.open();
                this.onStatusChange();
            });
    }

    updatePCSponsorEligibility() {
        if(this.isFpcEligibleForPcSponsor){
            this.pcSponsorEligibleStatus = 'Yes';
        }
        else{
            this.pcSponsorEligibleStatus = 'No';
        }
        this.selectedStatus = this.pcSponsorEligibleStatus;
        this.enableSubmit = false;
        this.updatePCSponsorStatusPopup.open();
    }
    /* To enable Submit button only if the selected value differs */
    onPCSponsorValueChange(event:any) {
        if (this.selectedStatus == this.pcSponsorEligibleStatus) {
          this.enableSubmit = false;
        } else {
          this.enableSubmit = true;
        }
    }

    onPCSponsorEligibilityChange() {
            const requestArray={
                    storeISOCodeThree: this.homeCountry,
                    operatingCountryCode: this.fboProfileDetail.operatingCountryCode,
                    pcSponsorEligibility: this.selectedStatus=='No' ? false : true,
                    memberId : this.fboProfileDetail.memberId
                }
            this._sponsorService.updatePCSponsorElgibility(this.fboProfileDetail.memberId, requestArray).subscribe(response=>{
                if(response.isSuccess === true){
                    const activityLogKeys: ActivityLogKey[] = [{
                        key: MemberActivityLogType.PCSponsor_Eligibility_Updated,
                        value:  (this.isFpcEligibleForPcSponsor == false ? "Not Eligible" : "Eligible") + ' to ' + (this.selectedStatus=='No' ? "Eligible" : "Not Eligible")
                    }];
                    this._commonService.saveMemberActivity(this.fboProfileDetail.memberId, activityLogKeys).subscribe(res => { },
                        (error: any) => { });
                    this._commonService.createNotification('', 'PC Sponsor eligibility status updated successfully', NotificationType.SUCCESS);
                }
                else{
                    this._commonService.createNotification('', 'PC Sponsor eligibility status update failed', NotificationType.ERROR);
                }
            });
            this.getDistributorWithPaymentDetails();
            this.selectedStatus = this.pcSponsorEligibleStatus;
            this.updatePCSponsorStatusPopup.close();
        }


    openResetPasswordModal = () => {
        this.resetPasswordForm.controls['resetPassword'].setValue(this.selectEnum.firstOption.toString());
        this.tempPassword = this.randomPassword(12);
        this.resetPasswordPopup.open();
    }

    openFlp360ResetPasswordModal = () => {
        this.flp360ResetPasswordForm.controls['flp360ResetPassword'].setValue(this.selectEnum.firstOption.toString());
        this.tempPassword = this.randomPassword(12);
        this.flp360ResetPasswordPopup.open();
    }

    randomPassword = (length: Number) => {
        const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@$#';
        let pass = '';
        for (let x = 0; x < length; x++) {
            pass += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return pass;
    }


    closePopUpforResetPassword = () => {
        this.tempPassword = '';
        this.resetPasswordPopup.close();
    }

    closeFlp360ResetPasswordModal = () => {
        this.tempPassword = '';
        this.flp360ResetPasswordPopup.close();
    }

    updateTemporaryPassword = () => {
        if (this.resetPasswordForm.controls['resetPassword'].value === this.selectEnum.secondOption.toString()) {
            this.resetPassword();
        } else {
            this._customerService.setTemporaryPassword(this.fboProfileDetail.emailId,
                this.tempPassword, this.fboProfileDetail.fboId).subscribe(response => {
                    if (response.isSuccess) {
                        const activityLogKeys: ActivityLogKey[] = [{
                            key: MemberActivityLogType.Change_Temporary_PWD,
                            value: this.fboProfileDetail.fboId
                        }];
                        this.logOutUserSessions();
                        this._commonService.saveMemberActivity(this.fboProfileDetail.id, activityLogKeys).subscribe();
                        const notification: any = this._translatePipe.get('customer-service.Temporary Password Updated Successfully');
                        this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                        this.resetPasswordPopup.close();
                    } else if (response.validations && response.validations.length) {
                        const addedNotification: any = this._translatePipe.get('errorcodes.' + response.validations[0].message);
                        this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                    }
                }, error => {
                    if (error && error.validations && error.validations.length) {
                        const addedNotification: any = this._translatePipe.get('errorcodes.' + error.validations[0].message);
                        this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                    }
                });
        }
    }
    /**
     * @description will logout all sessions of the user
     * @date 2020-09-17
     * @memberof FBOProfileComponent
     */
    logOutUserSessions(): void {
        this._customerService.logOutUserSessions(this.fboProfileDetail.fboId)
            .subscribe(response => { }, error => { });
    }

    /**
     * Send mail to reset FLP360 password
     */
    sendMailForFlp360ResetPassword() {
        //Send mail for flp360 reset password
        this._customerService.sendFlp360PasswordResetLink(this.fboProfileDetail.fboId)
            .subscribe(response => {
                if (response) {
                    if (response.isSuccess) {
                        //Add activity log for flp360 email for password change
                        const activityLogKeys: ActivityLogKey[] = [{
                            key: MemberActivityLogType.Flp360_Password_Reset_Emailed,
                            value: this.fboProfileDetail.fboId
                        }];
                        if (this.fboProfileDetail.id) {
                            this._commonService.saveMemberActivity(this.fboProfileDetail.id, activityLogKeys).subscribe();
                        }
                        this._commonService.createNotification('', 'Password reset link has been sent to Email', NotificationType.SUCCESS);
                        this.flp360ResetPasswordPopup.close();
                    } else {
                        this._commonService.createNotification('', 'Password Reset failed', NotificationType.ERROR);
                        this.flp360ResetPasswordPopup.close();
                    }
                }
            }, error => {
                this._commonService.createNotification('', 'Password Reset failed', NotificationType.ERROR);
                this.flp360ResetPasswordPopup.close();
            });
    }

    /**
     * Update the FLP360 password
     */
    updateFlp360TemporaryPassword() {
        if (this.flp360ResetPasswordForm.controls['flp360ResetPassword'].value === this.selectEnum.secondOption.toString()) {
            this.sendMailForFlp360ResetPassword();
        } else {
            //construct temporary password format
            let tempPasskey = this.fboProfileDetail.fboId + '||' + btoa(this.tempPassword);
            tempPasskey = EncryptionService.encryptText(tempPasskey);
            //Set temporary password
            this._customerService.setFlp360TemporaryPassword(tempPasskey)
                .subscribe(response => {
                    if (response.isSuccess) {
                        //Add activity log for flp360 password change
                        const activityLogKeys: ActivityLogKey[] = [{
                            key: MemberActivityLogType.Flp360_Change_Temporary_Password,
                            value: this.fboProfileDetail.fboId
                        }];
                        if (this.fboProfileDetail.id) {
                            this._commonService.saveMemberActivity(this.fboProfileDetail.id, activityLogKeys).subscribe();
                        }
                        const notification: any = this._translatePipe.get('customer-service.Temporary Password Updated Successfully');
                        this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                        this.flp360ResetPasswordPopup.close();
                    } else if (response.validations && response.validations.length) {
                        const addedNotification: any = this._translatePipe.get('errorcodes.' + response.validations[0].message);
                        this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                        this.flp360ResetPasswordPopup.close();
                    }
                }, error => {
                    if (error && error.validations && error.validations.length) {
                        const addedNotification: any = this._translatePipe.get('errorcodes.' + error.validations[0].message);
                        this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                        this.flp360ResetPasswordPopup.close();
                    }
                });
        }
    }

    openChangeBusinessEntityModal() {

        this.statesModal = [];
        let startDateValue;
        let endDateValue;
        if (!(this.fboBusinessEntity.countryCodeId >= 0)) {
            this.fboBusinessEntity.countryCodeId = this.fboProfileDetail.homeCountryId;
        }
        if (this.fboBusinessEntity && this.fboBusinessEntity.startDate) {
            startDateValue = moment(this.fboBusinessEntity.startDate, 'DD-MMM-YYYY');
        }else{
            startDateValue= moment(new Date(), 'DD-MMM-YYYY');
        }
        if (this.fboBusinessEntity && this.fboBusinessEntity.endDate) {
            endDateValue = moment(this.fboBusinessEntity.endDate, 'DD-MM-YYYY');
        }
        let taxIDValidation = [this.fboBusinessEntity.incomeTaxID, [Validators.required, Validators.maxLength(20), Utils.alphaNumericIphenCharacterValidation]];
        let stateCodeValidation = [this.fboBusinessEntity.stateCodeId || '', Validators.required];
        if (this.appConfig && this.appConfig.businessEntityConfig) {
            if (this.appConfig.businessEntityConfig.displayVATID) {
                taxIDValidation = [this.fboBusinessEntity.incomeTaxID, [Validators.required, Validators.minLength(2), Validators.maxLength(20), Utils.alphaNumericIphenCharacterValidation]];
            }
            if (this.appConfig.businessEntityConfig.hideStateCode) {
                stateCodeValidation = [this.fboBusinessEntity.stateCodeId || ''];
            }
        }
        let fbovatpayer;
        if (this.appConfig && this.appConfig.businessEntityConfig && this.appConfig.businessEntityConfig.showVatPayer) {
            if (this.fboBusinessEntity.vatPayer == 'Y') {
                fbovatpayer = this.vatPayerOption.Y;
            } else {
                fbovatpayer = this.vatPayerOption.N;
            }
        }
        this.businessEntityForm = this._formbuilder.group({
            businessEntityName: [this.fboBusinessEntity.businessEntityName, [Validators.required, Validators.minLength(3), Validators.maxLength(100)]],
            businessEntityId: [this.fboBusinessEntity.businessEntityId || '', this.getBusinessEntityValidators('businessEntityId')],
            incomeTaxID: taxIDValidation,
            businessEntityIdType: [this.fboBusinessEntity.businessEntityIdType || '', [Validators.required]],
            addressLine1: [this.fboBusinessEntity.addressLine1, [Validators.required, Validators.minLength(3), Validators.maxLength(50)]],
            addressLine2: [this.fboBusinessEntity.addressLine2, [Validators.minLength(3), Validators.maxLength(50)]],
            city: [this.fboBusinessEntity.city, [Validators.required, Validators.minLength(2), Validators.maxLength(100)]],
            stateCodeId: stateCodeValidation,
            countryCodeId: [this.fboBusinessEntity.countryCodeId],
            postalCode: [this.fboBusinessEntity.postalCode, [Validators.required, Validators.minLength(4), Validators.maxLength(10)]],
            status: [this.fboBusinessEntity.status || '', Validators.required],
            startDate: [startDateValue],
            endDate: [endDateValue],
            vatPayer: [fbovatpayer]

        });
        if(this.personalInfoSettings.removeVatId){
            this.businessEntityForm.removeControl('incomeTaxID');
        }
         this.businessEntityForm.controls['startDate'].disable();
        this.businessEntityForm.controls['endDate'].setValidators([Utils.validateEndDate]);
        this.statesModal = this.states.filter(item => item.countryId === this.businessEntityForm.controls['countryCodeId'].value);
        this.changeBusinessEntityPopup.open();
    }

    closeMemberlevelUpdatePopup() {
        this.changeMemberTypeandLevelPopup.close();
    }

    /**
    * To close Account Notification PopUp
    */
    closePopUpforAccountNotificationChange() {
        this.accountNotificationChangePopup.close();
    }
    /**
     * @description To close Update Name PopUp
     * @date 2019-08-01
     * @memberof FBOProfileComponent
     */
    closePopUpforNameChange() {
        this.updateMemberNamePopup.close();
    }

    /**
    * To close change Email PopUp
    */
    closePopUpforEmailChange() {
        this.changeEmailPopup.close();
    }

    /**
    * Custom Email Validations.
    */
    emailCheck = () => {
        if (this.emailForm && this.emailForm.value) {
            const emailFrom = this.emailForm.value.email.trim();
            const emailTo = this.emailForm.value.confirmEmail.trim();
            if (emailFrom && emailTo) {
                this.emailMismatch = (emailFrom.toLowerCase() === emailTo.toLowerCase()) ? false : true;
            }
            if (this.fboProfileDetail) {
                if (this.fboProfileDetail.emailId) {
                    this.isNewEmail = (!this.emailMismatch
                        && (this.emailForm.value.email.toLowerCase() !== this.fboProfileDetail.emailId.toLowerCase())) ? true : false;
                } else {
                    this.isNewEmail = true;
                }
            }

        }
    }

    /**
    * converts input to Member Basic Info
    */
    mapToBasicInfo(profileInfo, email): MemberBasicInfo {
        const memberBasicInfo: MemberBasicInfo = {
            firstName: '',
            lastName: '',
            middleName: '',
            memberId: 0,
            userId: 0,
            storeId: 0,
            primaryEmailId: '',
            phoneNumber: '',
            memberContacts: [],
            memberPreferences: [],
            memberGovernmentIdentifications: [],
            changedValueType:[]
        };
        memberBasicInfo.firstName = profileInfo.firstName;
        memberBasicInfo.displayName = profileInfo.displayName;
        memberBasicInfo.lastName = profileInfo.lastName;
        memberBasicInfo.middleName = profileInfo.middleName;
        memberBasicInfo.memberId = profileInfo.memberId;
        memberBasicInfo.userId = profileInfo.userId;
        memberBasicInfo.primaryEmailId = email;
        memberBasicInfo.phoneNumber = profileInfo.phone ? profileInfo.phone.replace(/[^a-zA-Z0-9]/g, '') : '';
        memberBasicInfo.memberPreferences = profileInfo.memberPreferences;
        memberBasicInfo.memberContacts = profileInfo.memberContacts;
        if ( this.fboProfileDetail.emailId && memberBasicInfo.primaryEmailId !== this.fboProfileDetail.emailId) {
            memberBasicInfo.changedValueType = [FBOProfileUpdateEnum.MEMBER_EMAIL_CHANGE];
        }
        return memberBasicInfo;
    }


    /**
     * Email update on form submit
     */
    changeEmailSubmit = () => {
        this.errorCodes = [];
        this.disableEmailButton = false;
        this._customerService.getMemberBasicInfoById(+this.fboProfileDetail.memberId).subscribe((basicInfo: MemberBasicInfo) => {
            if (this.emailForm && this.emailForm.value && basicInfo) {
                const emailID = this.emailForm.value.email.trim();
                this._customerService.updateMemberBasicInfo(this.mapToBasicInfo(basicInfo, emailID.toLowerCase())).subscribe(response => {
                    if (response.success) {
                        const activityLogKeys: ActivityLogKey[] = [{
                            key: MemberActivityLogType.Email_New,
                            value: this.emailForm.value.email.toLowerCase()
                        }];
                        this._commonService.saveMemberActivity(this.fboProfileDetail.id, activityLogKeys).subscribe();
                        if (this.fboProfileDetail.memberTypeId === this.memberTypeEnum.GUEST) {
                            const msg: any = this._translatePipe.get('customer-service.' + 'Email Has Been Updated SuccessFully');
                            this._commonService.createNotification('', msg.value, NotificationType.SUCCESS);
                        } else {
                            const msg: any = this._translatePipe.get('customer-service.' + 'We emailed a confirmation link to ||email||. Click the link in the email to confirm your email address.');
                            const translateValue = this.transform(msg.value, this.emailForm.value.email.toLowerCase());
                            this._commonService.createNotification('', translateValue, NotificationType.SUCCESS);
                        }
                        this.changeEmailPopup.close();
                        this.getFBOProfileInfoFromTitan();
                    } else if (response.validations && response.validations.length) {
                        this.errorCodes = response.validations;
                    }
                    this.disableEmailButton = true;
                }, error => {
                    if (error && error.validations && error.validations.length) {
                        this.errorCodes = error.validations;
                        const addedNotification: any = this._translatePipe.get('errorcodes.' + error.validations[0].message);
                        this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                    } else {
                        const addedNotification: any = this._translatePipe.get('errorcodes.Unable to Update Email. Please try again later');
                        this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                    }
                    this.disableEmailButton = true;
                });
            }
        }, error => {
            const addedNotification: any = this._translatePipe.get('errorcodes.Unable to Update Email. Please try again later');
            this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
            this.disableEmailButton = true;
        });

    }

    /**
   * @param  {Array<any>} items
   * @param  {predicate} filterOptions
   * @returns Array<any>
   */
    transform(translateText: string, param: any): string {
        if (translateText) {
            if (param) {
                translateText.match(/(\|\|{1}\w+\|\|{1})/g)
                    .map((x, y) => {
                        translateText = translateText.replace(x, param);
                    });
            }
            return translateText;
        }
    }

    closePopUp() {
        this.unlockPopup.close();
        if (this.bsModalRef) {
            this.bsModalRef.hide();
        }
        this.changeSponsorPopup.close();
        this.overrideMonthlyCCLimitPopup.close();
        this.changeStatusPopup.close();
        this.updatePCSponsorStatusPopup.close();
        this.resetPasswordPopup.close();
        this.changeMemberPreference.close();
        document.documentElement.classList.remove('dob-popup');
        this.changeDOBPopup.close();


    }
    closeGovtIDPopUp() {
        const control = <FormArray>this.updateGovIDForm.controls['govermentIdentification'];
        for (let i = control.length - 1; i >= 0; i--) {
            control.removeAt(i);
        }
        this.updateGovIDForm.markAsPristine();
        this.updateGovIDForm.markAsUntouched();
        this.isCancelButtonClicked = false;
        this.isUpdateButtonClicked = false;
        this.deleteHomeCountryVat = false;
        this.changeGovtIDPopup.close();
        this.governmentIdValueEditIndexes = [];
        this.duplicateGovIdErrorMessage = null;
        this.duplicateCheck = false;
    }
    closePopUpforBusinessEntity() {
        this.businessEntityForm.controls['startDate'].setValue(this.fboBusinessEntity.startDate);
        this.businessEntityForm.controls['endDate'].setValue(this.fboBusinessEntity.endDate);

        this.changeBusinessEntityPopup.close();
    }

    //  Filters States based on Country Selected in Business Entity.
    onChangeOfBusinessEntityCountry() {
        if (this.businessEntityForm.controls['countryCodeId'].value && this.statesModal) {
            this.statesModal = [];
            const countryId = this.businessEntityForm.controls['countryCodeId'].value;
            this.statesModal = this.states.filter(item => item.countryId === +countryId);
            this.businessEntityForm.controls['stateCodeId'].setValue('');
        } else {
            this.statesModal = [];
            this.businessEntityForm.controls['stateCodeId'].setValue('');
        }
    }


    NavigatetoPaymentMethod() {
        this.paymentMethodTab.emit(4);
    }

    customerReportMethod() {
        this.customerReportTab.emit(6);
    }
    getParticipatingCountriesByCountryCode(countryCode: string) {
        this._customerservice.getParticipatingCountriesByCountryCode(countryCode).subscribe(response => {
            if (response.success) {
                const countryIds: any[] = response.countriesUnderOperatingCountry.filter(x => x.countryId).map(a => a.countryId);
                if (countryIds && countryIds.length > 0) {
                    this.countriesList = this.countriesList.filter(x => countryIds.some(y => y === x.countryId));
                }

            }
        });
    }

    /** * HITS SERVICES   ----- BEGIN ----- ************************* */
    /**
     * Get Member information from titan
     */
    getFBOProfileInfoFromTitan(displayNotification?: boolean, updateBWP?: boolean) {
        this._customerservice.getMemberInformationFromTitan(this._id).subscribe(response => {
            if (response && response.isSuccess) {
                 this.isMemberRecordExistInTitan = true;
                this.prevBondedWarehouseProjectSelected = false;
                // this._cacheService.setSessionValue(CacheKey.UserDetails,response);
                const bwpMetaData = response.memberMetaData.find(element => (element.customKey === MemberMetaDataEnum.BWPENABLED) && (element.customValue === "1"));
                if (bwpMetaData) {
                    this.prevBondedWarehouseProjectSelected = true;
                }
                if (!this.changeOperatingCountry) {
                    this.getParticipatingCountriesByCountryCode(response.homeCountryCode);
                }
                this.getWholsesaleQualifiedDetails(this.fboid, response.homeCountryCode);
                this.isTitanEnabled = true;
                this.isBetaEnabled = this.isBetaEnabledCountry(response.homeCountryCode);
                this.fboProfileDetail = response;
                //this.memberGovernmentIdentifiations = response.memberGovernmentIdentifications;
                if(response && response.memberId){
                    this.getMembergovernmentIdentificationsInfo(response.memberId);
                   this.fboProfileDetail.businessEntities = this.getMemberBusinessEntityInfo(response.memberId,response.homeCountryCode,response.preferenceValue);
                 }
                if (response.memberAllowedCountries && response.memberAllowedCountries.length > 0) {
                    this.memberAllowedCountries = response.memberAllowedCountries;
                }
                this.fboProfileDetail.optinDate = this.getFormattedOptinDate(response.optinDate);
                this.fboProfileDetail.id = response.memberId;
                this.homeCountryInfo.emit(response.homeCountryCode);
                this.operatingCountryInfo.emit(response.operatingCountryCode);
                this.distributorInfoObj.memberId = response.memberId;
                this.distributorInfoObj.memberTypeId = response.memberTypeId;
                this.distributorInfoObj.memberType = response.memberType;
                this.distributorInfoObj.middleName=response.middleName;
                this.distributorInfoObj.homeCountryCode=response.homeCountryCode;
                this.distributorInfoObj.privacyRequested = this._commonService.isPrivacyRequested(response.memberPreferences);
                this.distributorInfo.emit(this.distributorInfoObj);
                this.fboProfileDetail.fboId = this._id;
                this.fboProfileDetail.spouseFullName = null;
                this.homeCountry = response.homeCountryCode;
                this.operatingCountry = response.operatingCountryCode;
                if (response && response.memberStatus) {
                    this.memberStatus = { id: MemberStatus[response.memberStatus], name: response.memberStatus };
                }
                this._configurationService.setEnrollCountry(this.homeCountry);
                this.personalInfoSettings = this._personalInfoConfigService.getSettings(this.homeCountry);
                this.isCreditAssessmentEnabled =  this.personalInfoSettings && this.personalInfoSettings.enableCreditAssessment ? false: true;
                this.showSingleAndDirectDebitMenu = this.personalInfoSettings.showBonusDebitInforMenu ? this.personalInfoSettings.showBonusDebitInforMenu : false;
                this.appConfig = this._appConfigService.getSettings(response.homeCountryCode, null); //storeConfiguration
                this.checkoutConfig = this._checkoutConfigService.getSettings(this.homeCountry, null);
                // this.getMemberBonusInfo();
                this.isDisplaySearchAddressSection = this.checkoutConfig ? this.checkoutConfig.displaySearchAddressSection : false;
                if (this.fboProfileDetail.businessEntities && this.fboProfileDetail.businessEntities.length) {
                    this.fboBusinessEntity = this.fboProfileDetail.businessEntities.find((entity) => entity.status !== RowStatus.Delete);
                    if (this.fboBusinessEntity && this.fboBusinessEntity.startDate) {
                        this.fboBusinessEntity.startDate =
                            moment(this.fboBusinessEntity.startDate, 'DD-MM-YYYY').format('DD-MMM-YYYY');
                    }
                    const country = this.countries.find(country => +country.countryId === +this.fboBusinessEntity.countryCodeId);
                    this.businessEntityCountry = country.name;
                    const state = this.statesModal.find(state => +state.id === +this.fboBusinessEntity.stateCodeId);
                    this.businessEntityState = state && state.stateName ? state.stateName : '';
                }
                if (+this.fboProfileDetail.memberTypeId == this.memberTypeEnum.DISTRIBUTOR && this.appConfig.disableBusinessEntityForFbo) {
                    this.disableBusinessEntityForFbo = true;
                } else {
                    this.disableBusinessEntityForFbo = false;
                }

                if (+this.fboProfileDetail.memberTypeId == this.memberTypeEnum.DISTRIBUTOR) {
                    this.isDistributor = true;
                    this.enableGovernmentID = true;
                }
                if (this.allowFullNamePermission) {
                    if ((+this.fboProfileDetail.memberTypeId == this.memberTypeEnum.RETAIL) ||
                        (+this.fboProfileDetail.memberTypeId == this.memberTypeEnum.GUEST)) {
                        this.allowFullNamePermission = false;
                    }
                    if ((+this.fboProfileDetail.memberTypeId == this.memberTypeEnum.DISTRIBUTOR) ||
                        (+this.fboProfileDetail.memberTypeId == this.memberTypeEnum.FPC)) {
                        this.allowFullNamePermission = true;
                        if(this.appConfig.showBonusInfoForFPC){
                            this.isDistributor = true;
                        }
                    }
                }
                if ((+this.fboProfileDetail.memberTypeId == this.memberTypeEnum.DISTRIBUTOR) ||
                    (+this.fboProfileDetail.memberTypeId == this.memberTypeEnum.FPC)) {
                    this.enableChangeStatus = true;
                    this.enableMemberCCOverride = true;
                    if(this.appConfig.showBonusInfoForFPC){
                        this.isDistributor = true;
                    }
                }
                if (+this.fboProfileDetail.memberTypeId != this.memberTypeEnum.GUEST) {
                    this.enableChangeHomeCountry = true;
                }
                if ((+this.fboProfileDetail.memberTypeId != this.memberTypeEnum.DISTRIBUTOR) &&
                    (+this.fboProfileDetail.memberTypeId != this.memberTypeEnum.FPC)) {
                    this.enableMemberTypeOrLevel = false;
                }
                this.enableChangeDOB = (this.fboProfileDetail.memberTypeId === this.memberTypeEnum.GUEST ||
                    this.fboProfileDetail.memberTypeId === this.memberTypeEnum.RETAIL) ? false : true;
                if (!this.fboProfileDetail.firstActiveUplineManager) {
                    this.fboProfileDetail.firstActiveUplineManager = new SponsorInformation();
                }
                this.fboProfileDetail.sponsorDetails = new SponsorInformation();
                let sponsorResults: any;
                sponsorResults = response.memberSponsorResults;
                if (sponsorResults !== undefined) {
                    this.fboProfileDetail.sponsorDetails.fboId = sponsorResults.sponsorFBOID ? sponsorResults.sponsorFBOID : '';
                    this.fboProfileDetail.sponsorDetails.firstName = sponsorResults.sponsorName ? sponsorResults.sponsorName : '';
                    this.fboProfileDetail.sponsorDetails.lastName = '';
                    this.fboProfileDetail.sponsorDetails.emailId = sponsorResults.email ? sponsorResults.email : '';
                    this.fboProfileDetail.sponsorDetails.mobile = sponsorResults.contactPhone ? sponsorResults.contactPhone : '';
                    this.fboProfileDetail.sponsorDetails.memberLevelID = sponsorResults.memberLevelID ? sponsorResults.memberLevelID : '';
                }
                this.fboProfileDetail.wholesaleQualified = response.wholeSaleQualified;
                this.fboProfileDetail.emailId = response.email;
                let mobileTypeInformation: any = [];
                mobileTypeInformation = response.memberContacts; // contactTypeID, value
                if (mobileTypeInformation && mobileTypeInformation.length > 0) {
                    const mobileNumber = mobileTypeInformation.find((item: any) => item.contactTypeID === ContactTypeValue.MOBILE);
                    if (mobileNumber != undefined) {
                        this.fboProfileDetail.mobile = mobileNumber.value;
                    }
                    const phone = mobileTypeInformation.find((item: any) => item.contactTypeID === ContactTypeValue.PHONE);
                    if (phone !== undefined) {
                        this.fboProfileDetail.homePhoneNumber = phone.value;
                    }
                }

                let memberPreferenceInformation: any = [];
                memberPreferenceInformation = response.memberPreferences;
                if (memberPreferenceInformation && memberPreferenceInformation.length) {
                    const byMail = memberPreferenceInformation.
                        find((item: any) => (item.preferenceId === MemberPreferenceType.Email) && +item.preferenceValue === PreferenceValues.no);
                    this.fboProfileDetail.memberPreference = byMail ? 'Yes' : 'No';
                    const subscription = memberPreferenceInformation.
                        find((item: any) => item.preferenceId === MemberPreferenceType.AmazonSubscription && +item.preferenceValue === PreferenceValues.yes);
                    this.fboProfileDetail.amazonSubscription = subscription ? CommonConstant.YES : CommonConstant.NO;
                }
                if (response.profileImageURL === null || response.profileImageURL === '' || response.profileImageURL === undefined ) {
                    this.profileImage = this.getStaticImageUrl();
                } else {
                    this.downloadImageFromUrl(response.profileImageURL);
                }
                this.getMemberLevelInfo(false, response, displayNotification);
                this.getChangeSponsorPermission();
                if (response.memberTypeId === this.memberTypeEnum.DISTRIBUTOR && response.memberTitleId !== MemberTitleExtEnums.Novus_Customer) {
                    this.isMemberTypeDistributor = true;
                }
                if (this.operatingCountry && this.AmazonSubscriptionEnabledOperatingCountries && this.AmazonSubscriptionEnabledOperatingCountries.length > 0 && this.AmazonSubscriptionEnabledOperatingCountries.includes(this.operatingCountry.toUpperCase())) {
                    this.enableAmazonSubscriptionFlag = true;
                }
                //this.isRetailSubscriptionLogin = TODO set flag here based on member retail subscription
                if (this.fboProfileDetail && (+this.fboProfileDetail.memberTypeId == this.memberTypeEnum.FPC)) {
                    this.isPrefferedCustomer = true;
                }
                this.checkMemberHomeCountryTitanEnabledcountry(this.homeCountry);
                if ( this.enableFLP360ImpersonationForFPC && (this.fboProfileDetail.memberTypeId == this.memberTypeEnum.DISTRIBUTOR || this.fboProfileDetail.memberTypeId == this.memberTypeEnum.FPC) && !this.isUserCreatedInKeycloak) {
                  this.createUserDetailsInFlp360Realm();
                }
              } else {
                this.getProfileInfo();
            }
        }, error => {
            this.getProfileInfo();
        });
        this.distributorInfo.emit(this.distributorInfoObj);
    }

    isStateCountriesDisable(countryCode: string): boolean {
        const stateCountry = environment.disableStateCountries.split(',');
            if (stateCountry && stateCountry.length) {
                return stateCountry.some((code) => code === countryCode);
            }
    }

    getMemberLanguageInformationFromTitan(country: string) {
        this._customerservice.getMemberLanguageInformationFromTitan(country).subscribe(response => {
            if (response.success) {
                const langauge = response.languages.find(language => language.languageId === +this.languageId);
                this.fboProfileDetail.preferredLanguage = (langauge && langauge.languageCode) ? langauge.languageCode.toUpperCase() : 'EN';
                this.languagecode = langauge && langauge.cultureName ? langauge.cultureName : 'en-us';
            }
        });
    }
    /**
     * @description create the formatted date of birth
     * @date 2019-10-10
     * @param {string} dateString
     * @returns {Date}
     * @memberof FBOProfileComponent
     */
    getFormattedDOB(dateString: string): Date {
        let birthDate = null;
        if (dateString) {
            const dob = new Date(dateString);
            birthDate = new Date(dob.getTime() + dob.getTimezoneOffset() * 60000);
        }
        return birthDate;
    }
    /**
     * @description create the formatted date of birth
     * @date 2019-10-10
     * @param {string} dateString
     * @returns {Date}
     * @memberof FBOProfileComponent
     */
    getFormattedOptinDate(dateString: string): Date {
        let optinDate = null;
        if (dateString) {
            const optin = new Date(dateString);
            optinDate = new Date(optin.getTime() + optin.getTimezoneOffset() * 60000);
        }
        return optinDate;
    }
    /**
     * Gets fbo / retail profile detail from AS400
     */
    getProfileInfo() {
        this.isFpcUser();
        let memberLevel;
        if (this.memberType === MemberType.GUEST || this.memberType === 'G') {
            memberLevel = 'G';
        } else if (this.memberType === MemberType.RETAIL || this.orderType === MemberOrderType.RETAIL || this.memberType === 'R') {
            memberLevel = 'R';
        }
        if (this.memberType === MemberType.GUEST || this.memberType === MemberType.RETAIL
            || this.memberType === 'G' || this.memberType === 'R') {
            this.memberType = 'R';
        } else if (this.memberType === MemberType.FPC) {
            this.memberType = MemberType.FPC;
        } else {
            this.memberType = MemberType.FOB;
            this.isDistributor = true;
        }
        this.isTitanEnabled = false;
        this.enableHomeCountry = false;
        this._customerservice.getFBOProfileInformation(this._id, this.memberType).subscribe(response => {
            if (response.success) {
                this.fboProfileDetail = response;
                this.fboProfileDetail.optinDate = this.getFormattedOptinDate(response.optinDate);
                this.homeCountryInfo.emit(this.fboProfileDetail.operatingCountry);
                this.fboProfileDetail.birthDate = this.getFormattedDOB(response.birthDate);
                this.fboProfileDetail.spouseFullName = response.spouse ? response.spouse : '';
                this.externalMemberStatus = response.status ? response.status.toLowerCase() : null;
                this.fboProfileDetail.fboId = this._id;
                if (this.fboProfileDetail.profileImageURL === null || this.fboProfileDetail.profileImageURL === '' || this.fboProfileDetail.profileImageURL === undefined) {
                    // this.fboProfileDetail.profileImageURL = this.getStaticImageUrl();
                    this.profileImage = this.getStaticImageUrl();
                } else {
                  this.downloadImageFromUrl(this.fboProfileDetail.profileImageURL);
              }
                if (!this.fboProfileDetail.accountLevelId) {
                    this.fboProfileDetail.accountLevelId = null;
                }
                if (memberLevel === 'G') {
                    this.isGuestMemberType = true;
                    this.fboProfileDetail.memberLevel = MemberType.GUEST;
                }
                if (memberLevel === 'R') {
                    this.fboProfileDetail.memberLevel = MemberType.RETAIL;
                }

                if (this.fboProfileDetail.memberLevel === MemberType.GUEST || this.fboProfileDetail.memberLevel === MemberType.RETAIL
                    || this.fboProfileDetail.memberLevel === MemberOrderType.RETAIL || this.fboProfileDetail.memberLevel === MemberType.RETAILCUSTOMER) {
                    this.showCCSnapshotSection = false;
                    this.enableChangeDOB = false;
                } else {
                    this.enableChangeDOB = true;
                    this.showCCSnapshotSection = true;
                    this.getSnapshotInfo();
                }

                if (!this.fboProfileDetail.address) {
                    this.fboProfileDetail.address = new AddressInformation();
                } else {
                    this.homeCountry = this.fboProfileDetail.address.country;
                    this.fboProfileCountry = this.fboProfileDetail.address.country;
                    this.getFormValidationsJSON();
                    this.fboInfo.push({ fboId: this._id, homeCountryCode: this.homeCountry });
                    if (this.fboProfileDetail.address.country !== null) {
                        this.phoneNumberFormat = this._commonService.getPhoneNumberFormatByCountryCode(
                            this.fboProfileDetail.address.country);
                    }
                    this._dataServcie.setCustomerFBOInfoServiceMessage(this.fboInfo);
                    this.addressFirstLine = (this.fboProfileDetail.address.addressFirstLine && this.fboProfileDetail.address.addressFirstLine !== '') ?
                        this.fboProfileDetail.address.addressFirstLine.trim() : '';

                    if (this.fboProfileDetail.address.addressSecondLine && this.fboProfileDetail.address.addressSecondLine !== '') {
                        this.addressFirstLine += ', ' + this.fboProfileDetail.address.addressSecondLine.trim();
                    }

                    if (this.fboProfileDetail.address.addressThirdLine && this.fboProfileDetail.address.addressThirdLine !== '') {
                        this.addressFirstLine += ', ' + this.fboProfileDetail.address.addressThirdLine;
                    }

                    this.fboProfileDetail.address.addressFirstLine = this.addressFirstLine;
                    this.addressSecondLine = (this.fboProfileDetail.address.city && this.fboProfileDetail.address.city !== '') ? this.fboProfileDetail.address.city.trim() : '';
                    if (this.fboProfileDetail.address.state && !this.isStateCountriesDisable(this.homeCountry)) {
                        this.addressSecondLine += ', ' + this.fboProfileDetail.address.state;
                    }
                }
                if (!this.fboProfileDetail.autoShipItems) {
                    this.fboProfileDetail.autoShipItems = new Array<Autoship>();
                }
                if (!this.fboProfileDetail.sponsorDetails) {
                    this.fboProfileDetail.sponsorDetails = new SponsorInformation();
                }
                if (!this.fboProfileDetail.firstActiveUplineManager) {
                    this.fboProfileDetail.firstActiveUplineManager = new SponsorInformation();
                }
                if (response.enrollmentDate !== null) {
                    this.isEnrollmentDateExists = true;
                    this.fboProfileDetail.enrollmentDate = this.getFormattedEnrollmentDate(response.enrollmentDate);
                }
                this.isfirstPurchaseDateEmpty = response.firstPurchaseDate === null || response.firstPurchaseDate === '0-0-' ? true : false;
                this.fboProfileDetail.firstPurchaseDate = new Date(response.firstPurchaseDate);
                this.distributorInfoObj.memberId = this.fboProfileDetail.id;
                this.distributorInfoObj.name = this.fboProfileDetail.firstName + ' ' + (this.fboProfileDetail.lastName ? this.fboProfileDetail.lastName : '');
                this.distributorInfoObj.contactNumber = response.mobile ? response.mobile : '';
                this.distributorInfoObj.email = this.fboProfileDetail.emailId ? this.fboProfileDetail.emailId : '';
                this.distributorInfoObj.distributorId = this.fboProfileDetail.fboId;
                this.distributorInfoObj.firstName = this.fboProfileDetail.firstName;
                this.distributorInfoObj.lastName = this.fboProfileDetail.lastName;
                this.distributorInfoObj.displayName = this.fboProfileDetail.displayName;
                this.distributorInfoObj.privacyRequested = this._commonService.isPrivacyRequested(response.memberPreferences);
                this.getMemberLevelInfo(true);
                this.fboProfileDetail.operatingCountry = response.operatingCountry;
                if (!this.changeOperatingCountry) {
                    this.getParticipatingCountriesByCountryCode(response.operatingCountry);
                }
                if (this.enableFLP360ImpersonationForFPC && (this.fboProfileDetail.memberTypeId == this.memberTypeEnum.DISTRIBUTOR || this.fboProfileDetail.memberTypeId == this.memberTypeEnum.FPC) && !this.isUserCreatedInKeycloak) {
                  this.createUserDetailsInFlp360Realm();
                }
            } else {
                if (response.validations && response.validations.length > 0) {
                    this.displayErrorMessage(this._id);
                }
            }
        }, error => {

            if (error.validations && error.validations.length > 0) {
                this.displayErrorMessage(this._id);
            }
        });
        this.distributorInfo.emit(this.distributorInfoObj);
    }

    getMemberLevelInfo(isAS400: boolean, titanResponse?, displayNotification?): void {
        this.isDisplayMemberTitle = true;
        if (this.fboProfileDetail.memberTitle != null && this.fboProfileDetail.memberTitle != undefined) {
            this.fboProfileDetail.memberLevel = this.fboProfileDetail.memberTitle;
        } else {
            isAS400 = true;
        }
        if (isAS400) {
            this.getAS400UserRelatedInfo();
        } else {
            this.getTitanUserRelatedInfo(titanResponse, displayNotification);
        }
        // this._commonService.getMemberLevelDetails(this.fboProfileDetail.fboId).subscribe((response) => {
        //     if (response) {
        //         this.fboProfileDetail.memberLevel = response.memberLevel;
        //         this.isDisplayMemberTitle = true;
        //         if (isAS400) {
        //             this.getAS400UserRelatedInfo();
        //         } else {
        //             if (!response.memberLevel) {
        //                 this.fboProfileDetail.memberLevel = response.memberType;
        //             }
        //             this.getTitanUserRelatedInfo(titanResponse, displayNotification);
        //         }
        //     }
        // }, (error) => {
        //     this.isDisplayMemberTitle = true;
        //     if (isAS400) {
        //         this.getAS400UserRelatedInfo();
        //     } else {
        //         this.getTitanUserRelatedInfo(titanResponse, displayNotification);
        //     }
        // });
    }

    getTitanUserRelatedInfo(response, displayNotification): void {
        if (this.fboProfileDetail.memberLevel === MemberType.GUEST || this.fboProfileDetail.memberLevel === MemberType.RETAIL
            || this.fboProfileDetail.memberLevel === MemberOrderType.RETAIL ||
            this.fboProfileDetail.memberLevel === MemberType.RETAILCUSTOMER) {
            this.showCCSnapshotSection = false;
        } else {
            this.showCCSnapshotSection = true;
            this.getSnapshotInfo();
        }
        if (this.fboProfileDetail.memberTypeId === this.memberTypeEnum.GUEST) {
            this.fboProfileDetail.memberLevel = MemberType.GUEST;
        }
        if (this.fboProfileDetail.memberTypeId === this.memberTypeEnum.FPC || this.fboProfileDetail.memberTitleId === MemberLevel.PREFERREDCUSTOMER || (this.fboProfileDetail.memberTypeId === MemberLevel.ASSISTANTMANAGER && this.fboProfileDetail.memberTitleId === MemberLevel.NOVICCUSTOMER)) {
            this.fboProfileDetail.memberLevel = MemberType.PREFERREDCUSTOMER
        }
        if (this.fboProfileDetail.memberTypeId === this.memberTypeEnum.FPC || this.fboProfileDetail.accountLevelId === MemberLevel.PREFERREDCUSTOMER || (this.fboProfileDetail.memberTypeId === MemberLevel.ASSISTANTMANAGER && this.fboProfileDetail.accountLevelId === MemberLevel.NOVICCUSTOMER)) {
            this.fboProfileDetail.accountLevelTitle = MemberType.PREFERREDCUSTOMER
        }
        this.fboProfileDetail.memberType = response.memberType;
        this.languageId = response.preferenceValue;
        if (response.memberGovernmentIdentifications.length > 0 && response.homeCountryCode !== null) {
            this.governmentIdentification = response.memberGovernmentIdentifications.find(x => x.governmentIdentificationType === 'SSN');

            if (this.governmentIdentification) {
                this.fboProfileDetail.governmentIdentificationType = this.governmentIdentification.governmentIdentificationType;
                this.fboProfileDetail.governmentIDType = this.governmentIdentification.governmentIDType;
                this.fboProfileDetail.governmentId = this.governmentIdentification.value;
                const regexp = /^\d{3}-\d{2}-\d{4}$/;
                const regexpr = /^\d{2}-\d{7}$/;
                if (this.governmentIdentification.value != null && regexp.test(this.governmentIdentification.value)) {
                    this.fboProfileDetail.governmentId = this.governmentIdentification.value !== null ?
                        ('XXX-XX-' + this.governmentIdentification.value.substr(-4)) : null;
                } else if (this.governmentIdentification.value != null && regexpr.test(this.governmentIdentification.value)) {
                    this.fboProfileDetail.governmentId = this.governmentIdentification.value !== null ?
                        ('XX-XXX' + this.governmentIdentification.value.substr(-4)) : null;
                } else if (this.governmentIdentification.value != null) {
                    this.fboProfileDetail.governmentId = this.governmentIdentification.value !== null ?
                        ('XXX-XX-' + this.governmentIdentification.value.substr(-4)) : null;
                }
            }
        }
        if (response.createdDate !== null) {
            this.isEnrollmentDateExists = true;
            this.fboProfileDetail.enrollmentDate = this.getFormattedEnrollmentDate(response.createdDate);
        }
        if (response.homeCountryCode !== null) {
            this.homeCountry = response.homeCountryCode;
            this.getFormValidationsJSON();
            this.fboProfileDetail.operatingCountry = response.homeCountryCode;
            this.getMemberLanguageInformationFromTitan(this.fboProfileDetail.operatingCountry);
            this.fboInfo.push({ fboId: this._id, homeCountryCode: this.homeCountry });
            this._dataServcie.setCustomerFBOInfoServiceMessage(this.fboInfo);
            this.phoneNumberFormat = this._commonService.getPhoneNumberFormatByCountryCode(response.homeCountryCode);
        }
        // if (response.memberMetaData.length > 0) {
        //     let memberMetaData: any;
        //     let customKeyValue: any;
        //     memberMetaData = response.memberMetaData.find((metaData: any) => metaData.customKey === this.metaDataKey);
        //     if (memberMetaData != undefined) {
        //         customKeyValue = memberMetaData.customValue.split(":");
        //         this.fboProfileDetail.spouseFullName = customKeyValue.length === 2 ?
        //             customKeyValue[1].replace(/[^a-zA-Z ]/g, "") : "NA";
        //     }

        // }
        if (response.memberRankLevels.length > 0) {
            this.memberRankLevels = response.memberRankLevels;
        }

        if (response.memberAllowedCountries.length > 0) {
            const operatingCountries = response.memberAllowedCountries.filter((country: any) => country.homeCountry === true);
            if (operatingCountries !== undefined && operatingCountries !== null && operatingCountries.length > 0) {
                let isTitanMember = false;
                operatingCountries.forEach(operatingCountry => {
                    const operatingCountryResult = this.countriesList.filter(country =>
                        country.isocodeThree == operatingCountry.isoCodeThree && country.titanPlatformEnabled === true);
                    if (operatingCountryResult && operatingCountryResult.length > 0) {
                        isTitanMember = true;
                    }
                });
                this.isTitanEnabled = isTitanMember;
            }
            const authorizedCountries = response.memberAllowedCountries.filter((country: any) => country.authorized === true);
            if (authorizedCountries !== undefined && authorizedCountries !== null && authorizedCountries.length > 0) {
                this.fboProfileDetail.storeEligibility = this.getCountryNames(authorizedCountries, 'countryName');
            }
        } else {
            this.fboProfileDetail.storeEligibility = '';
        }
        if (this.fboProfileDetail && this.fboProfileDetail.storeEligibility) {
            this.showPayByAccountCheck = this.fboProfileDetail.storeEligibility.includes('United States');
        }

        this.isfirstPurchaseDateEmpty = true;
        // this.fboProfileDetail.firstPurchaseDate = new Date(response.firstPurchaseDate);
        this.distributorInfoObj.memberId = this.fboProfileDetail.id;
        this.distributorInfoObj.name = this.fboProfileDetail.firstName + ' ' +
            (this.fboProfileDetail.lastName ? this.fboProfileDetail.lastName : '');
        this.distributorInfoObj.firstName = this.fboProfileDetail.firstName;
        this.distributorInfoObj.lastName = this.fboProfileDetail.lastName;
        this.distributorInfoObj.displayName = this.fboProfileDetail.displayName;
        this.distributorInfoObj.contactNumber = response.phone ? response.phone : '';
        this.distributorInfoObj.email = this.fboProfileDetail.emailId ? this.fboProfileDetail.emailId : '';
        this.distributorInfoObj.distributorId = this.fboProfileDetail.fboId;
        this.distributorInfoObj.level = this.fboProfileDetail.memberLevel;
        this.distributorInfoObj.privacyRequested = this._commonService.isPrivacyRequested(response.memberPreferences);
        if (+this.fboProfileDetail.memberTypeId === this.memberTypeEnum.FPC) {
            this.distributorInfoObj.memberType = MemberType.FPC;
        } else {
            this.distributorInfoObj.memberType = this.fboProfileDetail.memberType;
        }
        if (this.fboProfileDetail.memberLevel === MemberType.RETAIL) {
            this.enableHomeCountry = false;
        }
        if (this.fboProfileDetail.memberType === MemberType.GUEST) {
            this.isGuestMemberType = true;
        }
        this.distributorInfo.emit(this.distributorInfoObj);
        const autoShipItems = new Array<Autoship>();
        this.fboProfileDetail.autoShipItems = autoShipItems;
        this.saveRecentlyViewedAccount();
        if (!this.fboProfileDetail.storeEligibility || this.fboProfileDetail.storeEligibility.length === 0) {
            this.getFBOStoreEligibleInfo();
        }
        this.fboProfileDetail.address = new AddressInformation();
        this.countryId = response.homeCountryId ? response.homeCountryId : null;
        this.homeCountryId = response.homeCountryId ? response.homeCountryId : null;
        if (this.countryId && this.countries && this.countries.length && this.fboProfileDetail &&
            this.fboProfileDetail.address) {
            const countryInfo = this.countries.find((country: any) => country.countryId === this.countryId);
            this.fboProfileDetail.address.country = countryInfo && countryInfo.name ? countryInfo.name : '';
            this.fboProfileCountry = this.fboProfileDetail.address.country;
        }
        this.getAccountLockInfo();
        this.getDistributorWithPaymentDetails(displayNotification);
    }

    getAS400UserRelatedInfo(): void {
        this.distributorInfoObj.level = this.fboProfileDetail.memberLevel;
        if (this.fboProfileDetail.memberLevel === StatusConstants.Novus
            || this.fboProfileDetail.memberLevelId === MemberLevel.PREFERREDCUSTOMER) {
            this.distributorInfoObj.memberType = MemberType.FPC;
            this.fboProfileDetail.memberLevel = MemberType.PREFERREDCUSTOMER;
        } else {
            this.distributorInfoObj.memberType = this.memberType;
        }
        this.distributorInfoObj.level = this.fboProfileDetail.memberLevel;
        const language = this.fboProfileDetail.preferredLanguage.replace(/[ ]/gi, '');
        this.fboProfileDetail.preferredLanguage = language;
        this.fboProfileDetail.preferredLanguage = this.fboProfileDetail.preferredLanguage
            && this.fboProfileDetail.preferredLanguage.length > 0 ? this.fboProfileDetail.preferredLanguage : null;
        this.distributorInfo.emit(this.distributorInfoObj);
        this.saveRecentlyViewedAccount();
        this.getFBOStoreEligibleInfo();
    }

    getFBOStoreEligibleInfo() {
        this._customerservice.getFBOStoreEligibleInfo(this._id).subscribe(response => {
            if (response) {
                const storeList = response.fboAuthorizedCountryList;
                if (this.homeCountry) {
                    const homeCountryInfo = storeList.find((country: any) => country.iSOCode === this.homeCountry);
                    if (homeCountryInfo) {
                        storeList.splice(storeList.indexOf(homeCountryInfo), 1);
                        storeList.splice(0, 0, homeCountryInfo);
                    }
                }

                if (storeList.length > 0) {
                    this.authorizedCountries = storeList.filter((country: any) => country.isAuthorizedToShop === true || country.isAuthorizedSponsor === true);
                    if (this.authorizedCountries !== null && this.authorizedCountries.length > 0 && this.authorizedCountries !== undefined) {

                        this.fboProfileDetail.storeEligibility = this.getCountryNames(this.authorizedCountries, 'countryName');
                    } else {
                        this.fboProfileDetail.storeEligibility = '';
                    }
                } else {
                    this.fboProfileDetail.storeEligibility = '';
                }
            }
        });
    }

    /**
     * @description to get countrynames
     * @date 2019-09-17
     * @param {any[]} countries
     * @param {string} key
     * @returns {*}
     * @memberof FBOProfileComponent
     */
    getCountryNames(countries: any[], key: string): any {
        let countryNames = '';
        if (countries && countries.length) {
            countryNames = orderBy(countries, key).map(function (country) {
                return country[key];
            }).join(', ');
        }
        return countryNames;
    }


    getSnapshotInfo() {
        this.isLoading = true;
        const date = new Date();
        const curMonth = date.getMonth() + 1;
        const lastYear = curMonth === 1 ? date.getFullYear() - 1 : date.getFullYear();
        const lastMonth = curMonth === 1 ? 12 : curMonth - 1;
        const snapObj: SnapPayload = {
            distributorID: this._id,
            country: this.operatingCountry ? this.operatingCountry.toUpperCase() : '',
            currentYear: date.getFullYear(),
            month: curMonth
        }
        this._commonService.getCCSnapDetails(snapObj)
            .subscribe(res => {
                let currentMonthData = res && !!res.length ? res.find(x => (x.processingYear == date.getFullYear() && x.valueType.toLowerCase() == CommonConstant.Monthly && (x.processingMonth == +curMonth))) : {};
                let previousMonthData = res && !!res.length ? res.find(x => ((x.processingYear == lastYear && x.valueType.toLowerCase() == CommonConstant.Monthly && x.processingMonth == +lastMonth))) : {};
                let currentYear = res && !!res.length ? res.find(x => (x.processingYear == date.getFullYear() && x.valueType.toLowerCase() == CommonConstant.Yearly && (+x.processingMonth == this.valueZero))) : {};
                this.ccSnapshot.list = this.iterateCCsnapShotValues(currentMonthData, previousMonthData, curMonth, lastMonth);
                this.ccSnapshot.globalCC = currentYear && currentYear.globalTotalCC ? currentYear.globalTotalCC : 0;
                this.ccSnapshot.totMgrCount = currentYear && currentYear.recognizedManagerCount ? currentYear.recognizedManagerCount : 0;
                this.ccSnapshot.currentMonthTotal = currentMonthData && currentMonthData.totalCC ? currentMonthData.totalCC : 0;
                this.ccSnapshot.recognizedManagers = "";
            },
                err => {
                    this.ccSnapshot.list = [];
                    this.ccSnapshot.globalCC = 0;
                    this.ccSnapshot.totMgrCount = 0;
                    this.ccSnapshot.currentMonthTotal = 0;
                    this.isLoading = false;
                }, () => {
                    this.isLoading = false;
                })
    }

    iterateCCsnapShotValues(currentMonth, previousMonth, curMonth, lastMonth) {
        currentMonth = currentMonth ? currentMonth : {}
        previousMonth = previousMonth ? previousMonth : {}
        let snapData = [];
        snapData.push(
            { ccKey: '', currentMonthValue: this.monthAndYear.find(x => x.value == curMonth).monthName, previousMonthValue: this.monthAndYear.find(x => x.value == lastMonth).monthName },
            { ccKey: (this._translatePipe.get('customer-service.Personal') as any).value, currentMonthValue: currentMonth.personalCC ? currentMonth.personalCC : 0, previousMonthValue: previousMonth.personalCC ? previousMonth.personalCC : 0 },
            { ccKey: (this._translatePipe.get('customer-service.New FBO') as any).value, currentMonthValue: currentMonth.preferredCustomerCC ? currentMonth.preferredCustomerCC : 0, previousMonthValue: previousMonth.preferredCustomerCC ? previousMonth.preferredCustomerCC : 0 },
            { ccKey: (this._translatePipe.get('customer-service.Total Active') as any).value, currentMonthValue: currentMonth.activeCC ? currentMonth.activeCC : 0, previousMonthValue: previousMonth.activeCC ? previousMonth.activeCC : 0 },
            { ccKey: (this._translatePipe.get('customer-service.Non Manager') as any).value, currentMonthValue: currentMonth.nonManagerCC ? currentMonth.nonManagerCC : 0, previousMonthValue: previousMonth.nonManagerCC ? previousMonth.nonManagerCC : 0 },
            { ccKey: (this._translatePipe.get('customer-service.Leadership') as any).value, currentMonthValue: currentMonth.leadershipCC ? currentMonth.leadershipCC : 0, previousMonthValue: previousMonth.leadershipCC ? previousMonth.leadershipCC : 0 },
            { ccKey: (this._translatePipe.get('customer-service.Monthly Total') as any).value, currentMonthValue: currentMonth.totalCC ? currentMonth.totalCC : 0, previousMonthValue: previousMonth.totalCC ? previousMonth.totalCC : 0 },
            {
                ccKey: (this._translatePipe.get('customer-service.Level') as any).value, currentMonthValue: currentMonth.endinglevel ? currentMonth.endinglevel : '-', previousMonthValue: previousMonth.endinglevel ? previousMonth.endinglevel : '-',
                currentMonthTitle: currentMonth.endinglevel ? this.getMemberLevel(+currentMonth.endinglevel) : '', previousMonthTitle: previousMonth.endinglevel ? this.getMemberLevel(+previousMonth.endinglevel) : ''
            },
            { ccKey: (this._translatePipe.get('customer-service.4CC Active') as any).value, currentMonthValue: currentMonth.currentMonthActive, previousMonthValue: previousMonth.currentMonthActive })
        return [...snapData];
    }

    /**
  * sorting of columns // not hits service...
  * @param sortColumn
  */
    sortColumnInformation(sortColumn: string, tableName: String) {
        let snapshotDetails = new Array<SnapshotDetails>();
        let autoshipDetails = new Array<Autoship>();

        if (tableName == 'CCSnapshot') {
            if (!this.isCCSnapshot) {
                this.isDesc = false;
                this.sortColumn = '';
            }
            this.isCCSnapshot = true;
            snapshotDetails = this.ccSnapshot.list;
            this.sortItems(snapshotDetails, sortColumn);
        } else {
            if (this.isCCSnapshot) {
                this.isDesc = false;
                this.sortColumn = '';
            }
            this.isCCSnapshot = false;
            autoshipDetails = this.fboProfileDetail.autoShipItems;
            this.sortItems(autoshipDetails, sortColumn);
        }
    }

    /**
        * sorting of columns  based on list type
        * @param sortColumn
    */
    sortItems(list: any[], sortColumn: string) {
        this.isDesc = (this.sortColumn == sortColumn || sortColumn == '') ? !this.isDesc : this.isDesc;
        list.sort((a, b) => {
            if (a[sortColumn] > b[sortColumn]) {
                return this.isDesc ? -1 : 1;
            }

            if (a[sortColumn] < b[sortColumn]) {
                return this.isDesc ? 1 : -1;
            }
        });
        this.sortColumn = sortColumn;
    }

    saveRecentlyViewedAccount(): void {
        const accountModel = new AccountModel();
        accountModel.id = 0;
        if (this.isTitanEnabled) {
            if (this.fboProfileDetail.memberTypeId === this.memberTypeEnum.DISTRIBUTOR || this.fboProfileDetail.memberTypeId === this.memberTypeEnum.FPC) {
                accountModel.memberType = MemberType.FOB;
            } else if (this.fboProfileDetail.memberTypeId === this.memberTypeEnum.GUEST || this.fboProfileDetail.memberTypeId === this.memberTypeEnum.RETAIL) {
                accountModel.memberType = MemberType.RETAIL;
            }
        } else {
            accountModel.memberType = this.memberType === 'R' ? MemberType.RETAIL : MemberType.FOB;
        }
        accountModel.memberAccountId = this.fboProfileDetail.fboId;
        accountModel.memberAccountName = this.fboProfileDetail.displayName || (this.fboProfileDetail.firstName + (this.fboProfileDetail.lastName != null ? (' ' + this.fboProfileDetail.lastName) : ''));
        accountModel.customerAgentId = this.userId;
        accountModel.memberLevelId = this.fboProfileDetail.accountLevelId;
        this._customerservice.saveRecentlyViewedAccount(accountModel)
            .subscribe(response => {
            }, error => {
            });
    }

    /**
    To get the member level and display that in a popup
    **/
    viewMemberLevel(): void {
        this._customerService.getOperatingCountriesByCountryCode(this.fboProfileDetail.operatingCountry).subscribe(res => {
            this.reviewModel.memberDetail = {
                'firstName': this.fboProfileDetail.firstName,
                'lastName': this.fboProfileDetail.lastName,
                'fboId': this.fboProfileDetail.fboId,
                'memberLevel': this.fboProfileDetail.memberLevel,
                'operatingCountry': res.operatingCountryCode
            };
            this.showMemberLevel = false;
            this._customerservice.getMemberLevelsInfo(res.operatingCountryCode, this.fboid).subscribe(response => {
                if (response && response.fboMemberLevelHistoryResponse && response.fboMemberLevelHistoryResponse.length > 0) {
                    if (response.fboMemberLevelHistoryResponse && response.fboMemberLevelHistoryResponse.length > 0) {
                        this.reviewModel.memberLeveldata = response.fboMemberLevelHistoryResponse;
                        //this.reviewModel.memberLeveldata = this.reviewModel.memberLeveldata.filter(item => item.levelId != 'null');
                        this.reviewModel.dataAvailable = this.reviewModel.memberLeveldata.length > 0 ? true : false;
                        this.reviewModel.memberLeveldata.forEach(item => {
                            if (item.levelId === 'null') {
                                item.level = this.fboProfileDetail.memberLevel;
                            } else {
                                const level = this.memberLevels.find((memberlevel: any) => memberlevel.customId === (+item.levelId));
                                if (level && level.id === MemberLevel.PREFERREDCUSTOMER) {
                                    item.level = MemberType.PREFERREDCUSTOMER;
                                } else if (level && level.name) {
                                    item.level = level.name;
                                }
                            }
                        });
                    } else {
                        this.reviewModel.dataAvailable = false;
                    }
                    this.showMemberLevel = true;
                    this.reviewModel.toggle = true;
                } else {
                    const memberLeveldata: MemberLevelInfo[] = [];
                    const memberLevel = new MemberLevelInfo();
                    this.reviewModel.dataAvailable = true;
                    if (this.memberRankLevels.length > 0) {
                        this.memberRankLevels.forEach(level => {
                            memberLevel.date = new Date(level.achievedOn).toString();
                            memberLevel.level = level.memberTitle.toUpperCase() === UserTitleType.PREFERREDCUSTOMER
                                ? MemberType.PREFERREDCUSTOMER : level.memberTitle;
                            memberLevel.levelId = level.memberTitleId.toString();
                            memberLeveldata.push(memberLevel);
                        });
                    }
                    this.reviewModel.memberLeveldata = memberLeveldata;
                    this.reviewModel.dataAvailable = this.reviewModel.memberLeveldata.length > 0 ? true : false;
                    this.showMemberLevel = true;
                    this.reviewModel.toggle = true;
                }
            });
        });
    }
    openTab(tabName: string) {
        const tab = { tabName: tabName, fboId: this.fboid };
        this.messageService.setTabs(tab);
    }

    resetPassword() {
        this.SendPasswordResetLink();
    }
    SendPasswordResetLink() {
        this._customerservice.SendPasswordResetLink(this.fboProfileDetail.userName)
            .subscribe(response => {
                if (response) {
                    if (response.isSuccess) {
                        const activityLogKeys: ActivityLogKey[] = [{
                            key: MemberActivityLogType.PasswordReset_Emailed,
                            value: this.fboProfileDetail.fboId
                        }];
                        this._commonService.saveMemberActivity(this.fboProfileDetail.id, activityLogKeys).subscribe();
                        this._commonService.createNotification('', 'Password reset link has been sent to Email', NotificationType.SUCCESS);
                        this.resetPasswordPopup.close();
                    } else {
                        this._commonService.createNotification('', 'Please verify the Customer\'s Email ID', NotificationType.ERROR);
                    }
                }
            }, error => {
                this._commonService.createNotification('', 'Password Reset failed', NotificationType.ERROR);
            });
    }
    getDistributorWithPaymentDetails(displayNotification?: boolean) {
        this._customerservice.getMemberDetails(this.fboid).subscribe(response => {
            if (response && response.memberId) {
                if (response.address !== null) {
                    let stateInfo: any;
                    let countryInfo: any;
                    let mobileTypeInformation: any = [];
                    this.businessEntityInfo=response.businessEntities;
                    mobileTypeInformation = response.memberContacts;
                    if (mobileTypeInformation && mobileTypeInformation.length > 0) {
                        const mobileNumber = mobileTypeInformation.find((item: any) => item.contactTypeID === ContactTypeValue.MOBILE);
                        if (mobileNumber != undefined) {
                            this.fboProfileDetail.mobile = mobileNumber.value;
                            this.distributorInfoObj.contactNumber = mobileNumber.value;
                        }
                        const phone = mobileTypeInformation.find((item: any) => item.contactTypeID === ContactTypeValue.PHONE);
                        if (phone !== undefined) {
                            this.fboProfileDetail.homePhoneNumber = phone.value;
                            this.distributorInfoObj.contactNumber = phone.value;
                        }
                    }
                    if (response.memberAccountNotifications && response.memberAccountNotifications.length) {
                        this.accountNotification = response.memberAccountNotifications[0];
                        this.notification = {
                            id: this.fboProfileDetail.fboId,
                            firstName: this.fboProfileDetail.firstName,
                            middleName: this.fboProfileDetail.middleName ? this.fboProfileDetail.middleName : '',
                            lastName: this.fboProfileDetail.lastName,
                            displayName: this.fboProfileDetail.displayName,
                            memberLevel: this.fboProfileDetail.memberLevel,
                            memberTypeId: this.fboProfileDetail.memberTypeId,
                            subject: response.memberAccountNotifications[0].subject ? response.memberAccountNotifications[0].subject : '',
                            body: response.memberAccountNotifications[0].body ? response.memberAccountNotifications[0].body : '',
                            enable: response.memberAccountNotifications[0].enable ? true : false,
                        };
                        if(displayNotification){
                        this.displayNotification = displayNotification;
                        }

                    }
                    this.memberStatus = response.memberStatus;
                    this.fboProfileDetail.address = new AddressInformation();
                    this.fboProfileDetail.birthDate = this.getFormattedDOB(response.dateOfBirth);
                    this.addressFirstLine = (response.address.addressLine1 && response.address.addressLine1 !== '') ? response.address.addressLine1 : '';
                    this.fboProfileDetail.address.addressFirstLine = this.addressFirstLine;
                    if (response.address.addressLine2 && response.address.addressLine2 !== '') {
                        this.fboProfileDetail.address.addressSecondLine = response.address.addressLine2;
                        this.addressFirstLine += ', ' + response.address.addressLine2;
                    }
                    if (response.address.addressLine3 && response.address.addressLine3 !== '') {
                        this.fboProfileDetail.address.addressThirdLine = response.address.addressLine3;
                        this.addressFirstLine += ',' + response.address.addressLine3;
                    }
                    if (response.address.addressLine4 && response.address.addressLine4 !== '') {
                        this.fboProfileDetail.address.addressFourthLine = response.address.addressLine4;
                        this.addressFirstLine += ',' + response.address.addressLine4;
                    }
                    this.fboProfileDetail.address.id = response.address.id;
                    this.fboProfileDetail.address.addressTypeId = response.address.addressTypeId;
                    this.fboProfileDetail.address.countryId = response.address.countryId;
                    this.fboProfileDetail.address.addressLine1 = response.address.addressLine1;
                    this.fboProfileDetail.address.stateId = response.address.stateId;
                    this.fboProfileDetail.address.addressLine2 = response.address.addressLine2;
                    this.fboProfileDetail.address.addressLine3 = response.address.addressLine3;
                    this.fboProfileDetail.address.addressLine4 = response.address.addressLine4;
                    const stateValue = this.states.find((state: any) => state.id === this.fboProfileDetail.address.stateId);
                    this.fboProfileDetail.address.stateCode = stateValue ? stateValue.stateCode : null;
                    this.addressDetailId = response.address.id;
                    this.memberAddressDetailId = response.address.memberAddressDetailId;
                    this.stateId = response.address.stateId ? response.address.stateId : null;
                    this.countryId = response.address.countryId ? response.address.countryId : null;
                    if (this.stateId !== null || this.stateId !== undefined) {
                        if (this.states !== undefined) {
                            stateInfo = this.states.find((state: any) => state.id === this.stateId);
                        }
                    }
                    if (this.countryId !== null || this.countryId !== undefined) {
                        if (this.countries !== undefined) {
                            countryInfo = this.countries.find((country: any) => country.countryId === this.countryId);
                        }
                    }
                    this.fboProfileDetail.address.state = stateInfo !== null && stateInfo !== undefined ? stateInfo.stateName : '';
                    this.addressSecondLine = (response.address.city && response.address.city !== '') ? response.address.city : '';
                    this.fboProfileDetail.address.city = response.address.city;
                    if (this.fboProfileDetail.address.state && !this.isStateCountriesDisable(this.homeCountry)) {
                        this.addressSecondLine += ', ' + this.fboProfileDetail.address.state;
                    }
                    if (response.address.postalCode && response.address.postalCode !== '') {
                        this.fboProfileDetail.address.zipCode = response.address.postalCode;
                    }
                    this.fboProfileDetail.address.country = countryInfo !== null && countryInfo !== undefined ? countryInfo.name : '';
                    this.fboProfileCountry = this.fboProfileDetail.address.country;
                }
                this.fboProfileDetail.spouseFullName = response.spouseName;
                const memberId = response.memberId;
                this.autoshipMemberInfo.memberId = memberId;
                this.autoshipMemberInfo.homeCountry = this.homeCountry;
                this.autoshipMemberInfo.memberLevel = this.fboProfileDetail.memberLevel;
                this.autoshipMemberInfo.wholesaleQualified = response.wholeSaleQualified;
                this.fboProfileDetail.wholesaleQualified = response.wholeSaleQualified;
                if (this.memberLevels && this.memberLevels.length > 0) {
                    const level = this.memberLevels.find((item: any) => item.name === this.autoshipMemberInfo.memberLevel);
                    this.autoshipMemberInfo.memberLevelId = level ? level.id : 0;
                }
                if (response.memberRetailSubscriptionId != null && response.memberRetailSubscriptionId > 0) {
                    this.isRetailSubscriptionLogin = true;
                    this.memberRetailSubscriptionId = response.memberRetailSubscriptionId;
                    this.getRetailSubscriptionDetail(this.memberRetailSubscriptionId);
                }
                this.getAllAutoships(memberId, this.homeCountry);
                this.getMemberPaymentDetails(memberId);
                // if(memberId){
                //     this.getSavedAchs();
                // }
                //this.getDistributorECheckPayments(memberId, this.homeCountry);
                if (this.homeCountry !== '' && this.homeCountry !== undefined) {
                    this.getStoreInfo();
                }

            }
            this.isFpcEligibleForPcSponsor = response && response.pcSponsorEligible ? true :false;
        });
    }

    /*
    get member levels lookup
    */
    getMemberLevels() {
        this._customerservice.getMemberLevelsLookup()
            .subscribe(response => {
                if (response) {
                    this.memberLevels = response;
                }
            });
    }
    /*
    get store Info
    */
    getStoreInfo() {
        const countryCodes = [this.homeCountry];
        this._customerservice.getStoreInfoFromConfig(countryCodes)
            .subscribe(response => {
                if (response) {
                    this.storeId = response.countryId;
                    this.storeInfo = response;
                    if (this.fboProfileDetail) {
                    this.fboProfileDetail = {...this.fboProfileDetail, displayMiddleName : this.storeInfo.displayMiddleName};
                    }
                    if (this.displayNotification && this.notification) {
                        this.notification.displayMiddleName = this.storeInfo.displayMiddleName;
                        this._messageService.setAccountNotification(this.notification)
                    }
                    this._messageService.setStoreID(response.id);
                    this.setFboBonusInformationPermissions(response.id);
                    this.setSingleAndDirectDebitPermissions(response.id);
                    this.fetchPCSponsorEligiblityForStore(this.storeInfo);
                    this.autoshipMemberInfo.currencySymbol = response.currencySymbol.trim();
                    this.autoshipTabInfo.emit(this.autoshipMemberInfo);
                    this.homeStoreId = response.id;
                    this.getStoreLevelPermissions();
                    this.bondedWarehouseProjectViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.bondedWarehouseProjectPermission[0] + ']'), AccessLevel.Store, this.homeStoreId);
                    this.bondedWarehouseProjectManagePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.bondedWarehouseProjectPermission[1] + ']'), AccessLevel.Store, this.homeStoreId);
                    if (this.showSingleAndDirectDebitMenu) {
                        this.getStorePaymentMethods(response.id);
                    }
                    if (response.retailSubscriptionModel ? true : false) {
                        this.fboProfileDetail.retailSubscriptionModel = new RetailSubscription();
                        this.fboProfileDetail.retailSubscriptionModel.chargeBeePlanId = response.retailSubscriptionModel.chargeBeePlanId;
                        this.fboProfileDetail.retailSubscriptionModel.storeSubscriptionType = response.retailSubscriptionModel.storeSubscriptionType;
                        this.fboProfileDetail.retailSubscriptionModel.designateStoreId = response.retailSubscriptionModel.designateStoreId;
                        this.fboProfileDetail.retailSubscriptionModel.opCoSubscriptionType = response.retailSubscriptionModel.opCoSubscriptionType;

                        if (this.fboProfileDetail.retailSubscriptionModel.opCoSubscriptionType === OpCoRetailSubscriptionEnum.OperatingCountryLevel &&
                            this.fboProfileDetail.retailSubscriptionModel.designateStoreId){
                                this._customerservice.getRetailParticipationTypeByStore(this.fboProfileDetail.retailSubscriptionModel.designateStoreId).subscribe(
                                    retailParticipationResponse => {
                                        if (retailParticipationResponse) {
                                            if(retailParticipationResponse && retailParticipationResponse.chargebeePlanID && retailParticipationResponse.subscriptionParticipationType){
                                                if(retailParticipationResponse.subscriptionParticipationType === StoreRetailSubscriptionEnum.Participating) {
                                                    this.isStoreRetailSubscriptionEnabled = true;
                                                    this.fboProfileDetail.retailSubscriptionModel.chargeBeePlanId = retailParticipationResponse.chargebeePlanID;
                                                }
                                            }
                                        }
                                    }
                                );
                        } else if((this.fboProfileDetail.retailSubscriptionModel.opCoSubscriptionType === OpCoRetailSubscriptionEnum.StoreLevel &&
                            this.fboProfileDetail.retailSubscriptionModel.storeSubscriptionType === StoreRetailSubscriptionEnum.Participating)) {
                            this.isStoreRetailSubscriptionEnabled = true;
                        }
                    }
                    if(this.storeId){
                        this.getMemberBonusInfo();
                    }
                }
            });
    }

    getStorePaymentMethods(storeid) {
        const fpc5PercentEnabled = this.appConfig && this.appConfig.fpc5PercentEnabled ? this.appConfig.fpc5PercentEnabled : false;
        if (this.showSingleAndDirectDebitMenu) {
            this._orderService.getPaymentMethodsByStore(storeid, this.fboProfileDetail.homeCountryCode, this.languagecode, this.fboProfileDetail.memberTypeId, this.fboProfileDetail.wholesaleQualified, fpc5PercentEnabled, false, false, this.fboProfileDetail.memberId).subscribe((response: any) => {
                if (response) {
                    const storeInfoPayment = response;
                    storeInfoPayment.forEach(payment => {
                        if (payment.paymentMethodId === PaymentType.Single_Debit) {
                            this.showSingleDebit = true;
                        }
                        if (payment.paymentMethodId === PaymentType.Direct_Debit) {
                            this.showDirectDebit = true;
                        }
                    })
                }
            });
        }
    }

    setFboBonusInformationPermissions(storeId: number) {
        this.hasFboBonusInfoViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.FBO_BONUS_INFO_VIEW + ']'), AccessLevel.Store, storeId);
        this.hasFboBonusInfoDeletePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.FBO_BONUS_INFO_DELETE + ']'), AccessLevel.Store, storeId);
        this.hasFboBonusInfoManagePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.FBO_BONUS_INFO_MANAGE + ']'), AccessLevel.Store, storeId);
    }
    setSingleAndDirectDebitPermissions(storeId: number) {
        this.singleAndDirectDebitViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.SINGLE_AND_DIRECT_DEBIT_VIEW + ']'), AccessLevel.Store, storeId);
        this.singleAndDirectDebitManagePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.SINGLE_AND_DIRECT_DEBIT_MANAGE + ']'), AccessLevel.Store, storeId);
    }
    /*
   get Echeck payment methods of the distributor
   */
    getDistributorECheckPayments(distributorMemberId: any, countryCode: any) {
        this._customerservice.getPersonalChecks(distributorMemberId, countryCode).subscribe(response => {
            if (response && response.length > 0) {
                this.distributorDefaultECheckPaymentInfo = response;
                this.distributorDefaultECheckPaymentInfo.forEach((eCheque: any) => {
                    eCheque.notes = eCheque.defaultECheck ? 'Default' : '';
                });
            }
        });
    }
    /*
    get autoship details
    */
    getAllAutoships(memberId, countryCode) {
        this._customerservice.getAllAutoships(memberId, countryCode)
            .subscribe(response => {
                if (response && response.length > 0) {

                    const autoShipInfo = response[0].body;
                    this.activeAutoShipInfo = autoShipInfo.filter((autoship: any) => autoship.autoshipStatusId === RowStatus.Active);
                    if (this.activeAutoShipInfo && this.activeAutoShipInfo.length > 0) {
                        if (this.activeAutoShipInfo[0].autoShipDisplayDate) {
                            this.activeAutoShipInfo[0].autoShipDisplayDate = this.getDateObject(this.activeAutoShipInfo[0].autoShipDisplayDate);
                        }
                    }

                    this.inactiveAutoShipInfo = autoShipInfo.filter((autoship: any) => autoship.autoshipStatusId === RowStatus.InComplete);

                } else {
                    this.activeAutoShipInfo = [];
                }
            });

    }

    getDateObject(date: string) {
        let resultDate: Date;
        if (date) {
            const splitDate = date.split('-');
            // Setting the year ,month , date
            resultDate = new Date(Number(splitDate[0]), Number(splitDate[1]) - 1, Number(splitDate[2]));
            return resultDate;
        }
    }
    getMemberPaymentDetails(memberId: any) {
        this._customerservice.getMemberPaymentDetails(memberId).subscribe(response => {
            if (response && response.savedCards && response.savedCards.length > 0) {
                this.distributorDefaultCardPaymentInfo = response.savedCards;
                this.distributorDefaultCardPaymentInfo.forEach((card: any) => {
                    card.notes = card.default ? 'Default' : '';
                });
            }
            if (response && response.personalChecks && response.personalChecks.length > 0) {
                this.distributorDefaultECheckPaymentInfo = response.personalChecks;
                this.distributorDefaultECheckPaymentInfo.forEach((eCheque: any) => {
                    eCheque.notes = eCheque.default ? 'Default' : '';
                });
            }

        });
    }

    getAllCountriesInfo() {
        this._customerService.getAllCountries(true).subscribe(response => {
            if (response) {
                this.titanEnabledCountries = response.filter(country => country.titanEnabled);
                this.countries = response;
                this.countriesList = response;
            }
            this.getAllStates();
        });
    }

    getAllStates() {
        this._customerService.getAllStates().subscribe(response => {

            if (response) {
                this.states = response;
                this.statesModal = response;
            }
            this._id ? this.getFBOProfileInfoFromTitan(true) : '';
        });
    }


    /**
* failed to upload file
* @param item
* @param response
* @param status
* @param headers
*/
    onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
        this.ngProgress.done();
        let message: any = this._translatePipe.get('customer-service.Invalid file format');
        this.message = message.value + (response ? ',' + response : '');
        this.showEmailErrorMessage = true;
        this.isSendingEmail = false;
        this.count = 0;
        this.composeEmailRequest.messageModel.attachments = [];
        this.uploadResponse = [];
    }

    /**
         * On Successful upload of file
         * @param item
         * @param response
         * @param status
         * @param headers
         */
    count = 0;
    onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
        if (response) {
            const res = JSON.parse(response);
            const fileDetails = {
                'userId': this.userInfo.userId,
                'fileName': this.uploader.queue[this.count].file.name,
                'url': res.url,
                'eTag': res.eTag,
                'key': res.key
            };
            this.uploadResponse.push(fileDetails);
            this.count++;
            if (this.uploader.queue.length === this.count) {
                this.composeEmailRequest.messageModel.attachments = this.uploadResponse;
                this.sentEmail(this.composeEmailRequest);
            }
        } else {
            this._commonService.createNotification('', 'File Not uploaded', NotificationType.ERROR);
        }
        this.ngProgress.done();
    }


    /**
    *Empty Method
    */
    noAction() {
    }


    /*Check for max of 5 attachments */
    checkMaxAttachments() {
        if (this.uploader.queue) {
            this.attachmentsLength = this.uploader.queue.length;
            if (this.attachmentsLength >= 5) {
                while (this.attachmentsLength > 5) {
                    this.uploader.queue[this.uploader.queue.length - 1].remove();
                    this.attachmentsLength--;
                }
            }
        }
    }

    impersonateUser() {
        this.enableFBOLogin = false;
        this.cookieService.delete(CacheKey.COUNTRY_CODE, environment.cookiePath, environment.cookieDomain);
        this.cookieService.delete(CacheKey.LANGUAGE_CODE, environment.cookiePath, environment.cookieDomain);
        this.cookieService.delete(CacheKey.COUNTRY_ID, environment.cookiePath, environment.cookieDomain);
        if (this.fboProfileDetail.memberId) {
            this.impersonateTitan(this.fboProfileDetail.fboId);
        } else if (this.fboProfileDetail && this.fboProfileDetail.address && this.fboProfileDetail.address.country) {
            this.impersonateLegacy(this.fboProfileDetail.fboId, this.fboProfileDetail.address.country);
        }
    }

    checkAndImpersonateTitanUser(fboId: string): void {
        this._customerService.getUserResourceDetail(fboId)
            .subscribe(res => {
                if (res && res.id) {
                    const activityLogKeys: ActivityLogKey[] = [{
                        key: MemberActivityLogType.Impersonation_Started,
                        value: fboId
                    }];
                    this._commonService.saveMemberActivity(this.fboProfileDetail.id, activityLogKeys).subscribe();
                    this.checkAndCreateExternalUserSession(fboId);
                    this.enableFBOLogin = true;
                } else {
                    this.showImpersonateUserErrorMessage();
                }
            }, error => this.handleError());
    }
    showImpersonateUserErrorMessage() {
        const message: any = this._translatePipe.get('customer-service.Impersonate User Error Message');
        const options: any = this._translatePipe.get('customer-service.Click here for other options');
        const html = `<div>
                    <div>` + message.value + `</div>` +
            `<div id="more-info"><a id="more-options">` + options.value + `</a></div>
                    </div>`;
        const type: any = this._commonService.getNotificationType(NotificationType.ERROR);
        const toast = this._notificationService.html(html, type, {
            timeOut: 0,
            showProgressBar: false,
            pauseOnHover: false,
            clickToClose: false,
            clickIconToClose: true,
            icons: this._commonService.getIcons()
        });

        toast.click.subscribe((event) => {
            if (event.target.getAttribute(ImpersonateUserConstants.ID) === ImpersonateUserConstants.MORE_INFO
                || event.target.getAttribute(ImpersonateUserConstants.ID) === ImpersonateUserConstants.MORE_OPTIONS) {
                this.showMoreInformationPopup.open();
            }
        });

        this.enableFBOLogin = true;
    }

    closeShowMoreInformationPopup() {
        this.showMoreInformationPopup.close();
    }

    checkAndCreateExternalUserSession(fboId: string): void {
        const sessionId = this.cookieService.get(CacheKey.EPSS);
        if (sessionId) {
            this._customerService.getAdminToken(fboId).subscribe(response => {
                if (response) {
                    this._customerService.endUserSession(sessionId).subscribe(r =>
                        this._customerService.impersonate(response, fboId, CacheKey.TITAN).subscribe(res => {
                            window.open(window.location.origin + '/impersonation?istitan=' + this.isTitanEnabled, '_blank');
                        }, error => this.handleError()),
                        error => this.handleError());
                }
            }, error => this.handleError());
        } else {
            this._customerService.getAdminToken(fboId).subscribe(response => {
                if (response) {
                    this._customerService.impersonate(response, fboId, CacheKey.TITAN).subscribe(res => {
                        window.open(window.location.origin + '/impersonation?istitan=' + this.isTitanEnabled, '_blank');
                    }, error => this.handleError());
                }
            }, error => this.handleError());
        }
    }

    impersonateTitan(fboId: string): void {
        this.checkAndImpersonateTitanUser(fboId);
    }

    impersonateLegacy(fboId: String, country: String): void {
        this._customerService.getAdminToken().subscribe(response => {
            if (response) {
                this.enableFBOLogin = true;
                this._customerService.impersonate(response, fboId, CacheKey.AS400).subscribe(res => {
                    window.open(window.location.origin + '/impersonation?istitan=' + this.isTitanEnabled, '_blank');
                }, error => this.handleError());
            }
        }, error => this.handleError());
    }


    handleError = () => {
        this.showImpersonateUserErrorMessage();
    }

    /**
     * @description will update the home Country in titan
     * @date 2020-09-23
     * @param {*} addressDetails
     * @memberof FBOProfileComponent
     */
    updateHomeCountryInTitan(addressDetails: any, transliterateProp?): void {
        const btn = document.getElementsByClassName('remove-disable')[0] as HTMLButtonElement;
        if (addressDetails && addressDetails.addressLine1 && addressDetails.city && addressDetails.countryId) {
            this._customerservice.updateHomeCountryInTitan(this.fboProfileDetail.id, this.memberAddressDetailId, addressDetails, transliterateProp)
                .subscribe((response) => {
                    btn.disabled = false;
                    if (response.success) {
                        const activityLogKeys: ActivityLogKey[] = [{
                            key: MemberActivityLogType.RegisteredAddress_Updated,
                            value: this.prepareHomeCountryAddress(addressDetails)
                        }];
                        this._commonService.saveMemberActivity(this.fboProfileDetail.id, activityLogKeys).subscribe();
                        const addedNotification: any = this._translatePipe.get('customer-service.Registered Address Updated Successfully');
                        this._commonService.createNotification('', addedNotification.value, NotificationType.SUCCESS);
                        this.getFBOProfileInfoFromTitan();
                        this.closePopUp();
                    } else if (response.error !== '') {
                        this._commonService.createNotification('', response.error, NotificationType.ERROR);
                    }
                }, error => {
                    btn.disabled = false;
                    this._commonService.createNotification('', 'Unable to Update Address', NotificationType.ERROR);
                });
        }
    }

    /**
     * @date 2020-09-23
     * @param {Address} address
     * @memberof FBOProfileComponent
     */
    getNewAddressInfo(address: Address): void {
        if (address) {
            let titanPlatformEnabled = false;
            const addressDetails = this.prepareSaveAddressRequest(address, false);
            const homeCountry = this.countriesList.find((country: any) => country.countryId === address.countryId);
            if (homeCountry) {
                titanPlatformEnabled = homeCountry.titanPlatformEnabled;
            }

            let tranliterateProp = this.populateTransliterateObj();
            if (this.fboProfileDetail && this.fboProfileDetail.homeCountryCode && address.countryCode && this.fboProfileDetail.homeCountryCode.toLowerCase() == address.countryCode.toLowerCase()) {
                this.updateCountry(address, addressDetails, tranliterateProp);
            }
            else {
                this._customerservice.getStoreInfoFromConfig(address.countryCode).pipe(catchError(err => of(err))).subscribe(store => {
                    if(store && store.homeIsocodeThree && this.fboProfileDetail && this.fboProfileDetail.homeCountryCode
                        && this.fboProfileDetail.homeCountryCode.toLowerCase() !== store.homeIsocodeThree.toLowerCase()){
                            let language = this._commonService.getStoreDefaultLanguage(store);
                        tranliterateProp = this._commonService.mapTransliterateProperties(store, language);
                    }
                    this.updateCountry(address, addressDetails, tranliterateProp);
                })
            }
        }
    }

    updateCountry(address,addressDetails,tranliterateProp){
        const btn = document.getElementsByClassName('remove-disable')[0] as HTMLButtonElement;
        if (btn && !btn.disabled) {
            btn.disabled = true;
        }
        if (this.fboProfileDetail.memberTypeId === this.memberTypeEnum.RETAIL) {
            this.updateHomeCountryInTitan(addressDetails, tranliterateProp);
        } else {
            this._customerservice.getOperatingCountriesByCountryCode(address.countryCode).subscribe((response: any) => {
                if (response && this.fboProfileDetail.operatingCountryCode) {
                    if (this.fboProfileDetail.operatingCountryCode !== response.operatingCountryCode) {
                        this.updateOperatingCountry(address, true, tranliterateProp);
                    } else {
                        this.updateHomeCountryInTitan(addressDetails, tranliterateProp);
                    }
                }
            });
        }
    }

    /**
     * @description will update the registered address
     * @date 2020-09-23
     * @param {*} address
     * @param {boolean} isUpdateMemberHomeCompany
     * @memberof FBOProfileComponent
     */
    updateOperatingCountry(address: any, isUpdateMemberHomeCompany: boolean, transliterateProp?) {
        const addressDetail = this.prepareSaveAddressRequest(address, isUpdateMemberHomeCompany);
        const btn = document.getElementsByClassName('remove-disable')[0] as HTMLButtonElement;
        if (addressDetail && addressDetail.addressLine1 && addressDetail.city && addressDetail.countryCode) {
            this._customerservice.updateMemberRegisterAddress(+this.fboProfileDetail.id, this.memberAddressDetailId, addressDetail, transliterateProp)
                .subscribe((response) => {
                    btn.disabled = false;
                    if (response.success) {
                        let notification: any = null;
                        if (response.requestStatus && response.requestStatus === StatusConstants.SUCCESS) {
                            notification = this._translatePipe.get('customer-service.Registered Address Updated Successfully');
                            this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                            const activityLogKeys: ActivityLogKey[] = [{
                                key: MemberActivityLogType.Homecountry_Updated,
                                value: addressDetail.countryCode
                            }];
                            this._commonService.saveMemberActivity(this.fboProfileDetail.id, activityLogKeys).subscribe();
                        } else if (response.requestStatus && response.requestStatus === StatusConstants.IN_PROGRESS) {
                            notification = this._translatePipe.get('Please allow up to 24 hours for modifications to be processed.');
                            this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                        } else {
                            notification = this._translatePipe.get('errorcodes.' + response.validations[0].name);
                            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                        }
                        this.getFBOProfileInfoFromTitan();
                        this.closePopUp();
                    } else if (response.validations && response.validations.length) {
                        btn.disabled = false;
                        const notification: any = this._translatePipe.get('errorcodes.' + response.validations[0].name);
                        this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    }
                }, error => {
                    btn.disabled = false;
                    if (error.validations && error.validations.length) {
                        const notification: any = this._translatePipe.get('errorcodes.' + error.validations[0].name);
                        this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    } else {
                        const notification: any =
                            this._translatePipe.get('errorcodes.FAIL: SYSDWN. Valence API for Member Home Country Change');
                        this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                    }
                });
        }
    }

    prepareHomeCountryAddress(address: any): string {
        let addressDetails = (address.addressLine1 && address.addressLine1 !== '') ? address.addressLine1.trim() : '';
        if (address.addressLine2 && address.addressLine2 !== '') {
            addressDetails += ',' + address.addressLine2.trim();
        }
        addressDetails += ',' + ((address.city && address.city !== '') ? address.city : '');
        if (address.stateCode && address.stateCode !== '') {
            addressDetails += ',' + address.stateCode;
        }
        if (address.postalCode && address.postalCode !== '') {
            addressDetails += ',' + address.postalCode;
        }
        if (address.countryCode && address.countryCode !== '') {
            addressDetails += ',' + address.countryCode;
        }
        return addressDetails;
    }

    GetMemberTypeList() {
        this.memberTypeName = [];
        this.memberTypeName.push({ id: this.memberTypeEnum.DISTRIBUTOR, type: StatusConstants.FBO });
        this.memberTypeName.push({ id: this.memberTypeEnum.FPC, type: StatusConstants.FPC });

        return this.memberTypeName;
    }

    GetMemberLevelList() {
        this.memberLevelList = [];
        this.memberLevelList.push({ id: MemberTitleExtEnums.Retail, type: StatusConstants.Retail });
        this.memberLevelList.push({ id: MemberTitleExtEnums.PreferredCustomer, type: StatusConstants.PreferredCustomer });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Assistant_Supervisor, type: StatusConstants.Assistant_Supervisor });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Supervisor, type: StatusConstants.Supervisor });

        this.memberLevelList.push({ id: MemberTitleExtEnums.Assistant_Manager, type: StatusConstants.Assistant_Manager });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Manager, type: StatusConstants.Manager });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Unrecognized_Manager, type: StatusConstants.Unrecognized_Manager });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Recognized_Manager, type: StatusConstants.Recognized_Manager });

        this.memberLevelList.push({ id: MemberTitleExtEnums.Senior_Manager, type: StatusConstants.Senior_Manager });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Soaring_Manager, type: StatusConstants.Soaring_Manager });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Sapphire_Manager, type: StatusConstants.Sapphire_Manager });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Diamond_Sapphire_Manager, type: StatusConstants.Diamond_Sapphire_Manager });

        this.memberLevelList.push({ id: MemberTitleExtEnums.Diamond_Manager, type: StatusConstants.Diamond_Manager });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Double_Diamond_Manager, type: StatusConstants.Double_Diamond_Manager });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Triple_Diamond_Manager, type: StatusConstants.Triple_Diamond_Manager });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Diamond_Centurion_Manager, type: StatusConstants.Diamond_Centurion_Manager });

        this.memberLevelList.push({ id: MemberTitleExtEnums.PreferredCustomer, type: StatusConstants.FPC });
        this.memberLevelList.push({ id: MemberTitleExtEnums.Guest, type: StatusConstants.GUEST });
        return this.memberLevelList;
    }

    getFlp360AccessInfo() {

    }

    saveMemberTypeorLevelInfo() {
        if (this.changeMemberTypeandLevelForm.valid) {
            this.memberWholesaleQualifiedRequest.memberId = this.fboProfileDetail.fboId;
            this.memberWholesaleQualifiedRequest.memberNdpFlag = this.changeMemberTypeandLevelForm.value.enableStatus ? 'N' : 'Y';
            this.memberWholesaleQualifiedRequest.memberHomeCountry = this.homeCountry;
            this._customerservice.saveWholesaleQualifiedInfo(this.memberWholesaleQualifiedRequest)
                .subscribe(response => {
                    if (response && response.success) {
                        this._customerservice.saveWholesaleQualifiedInfoToTitan(this.memberWholesaleQualifiedRequest)
                            .subscribe(res => {
                                if (res && res.isSuccess) {
                                    this.SaveMemberNote();
                                    this.changeMemberTypeandLevelPopup.close();
                                    this._commonService.createNotification('', 'Member is Updated to wholesale qualified', NotificationType.SUCCESS);
                                    this.getDistributorWithPaymentDetails();
                                }
                            });
                    } else {
                        this.changeMemberTypeandLevelPopup.close();
                        this._commonService.createNotification('', 'error, While Updating', NotificationType.ERROR);
                    }
                });
        } else {
            this._commonService.createNotification('', 'error', NotificationType.ERROR);
        }
    }

    SaveMemberNote() {
        const notesData = {
            'noteTypeID': MemberNoteType.AccountTypeID,
            'description': MemberNoteType.Description + ' by ' + this.userInfo.userName,
            'summary': MemberNoteType.Description,
            'createdByUserId': this.userInfo.userId,
            'createdByUserName': this.userInfo.userName,
            'createdDate': new Date(),
            'memberId': this.fboProfileDetail.id ? this.fboProfileDetail.id : null,
            'distributorId': this._id,
        };
        this._customerservice.saveNoteAtMemberLevel(notesData).subscribe((response) => {
            if (response) {
            }
        });
    }
    /**
   *Gets static Image URLS from Assets
   *
   * @memberof MyprofileComponent
   */
    getStaticImageUrl(): string {
        if (environment.production) {
            return environment.baseHref + '/resources/static/src/' + DefaultProfileImage.PROFILE_DEFAULT_IMAGE;
        } else {
            return environment.baseHref + DefaultProfileImage.PROFILE_DEFAULT_IMAGE;
        }
    }

    /**
     * @description Navigate sponsor details while click on fbo number or name
     * @date 2019-07-08
     * @param {*} id
     * @param {string} memberType
     * @param {string} name
     * @memberof FBOProfileComponent
     */
    navigateToFBOProfile(id: any, memberType: string, firstName: string, lastName?: string, memberLevelID?: number): void {
        // verifying permissions - whether any one of the permission exists for logged in user.
        this._commonService.getMemberStatus(id).subscribe(response => {
            if( response && response.status === AccountRestrictionStatus.RESTRICTED && !this.accountViewPermission){
                const memberlevel = this._commonService.getMemberLevel(memberLevelID);
                this.accountRestriction = true;
                const memberDetails = {
                    fboId: id,
                    firstName: firstName,
                    lastname: lastName,
                    memberLevel: memberlevel
                };
                this.memberDetails = memberDetails;
            } else {
                this.navigateFBODetail(id,memberType,firstName)
            }
        });
    }
    navigateFBODetail(id,memberType,firstName){
        if (this._commonService.checkPermissionByAccessLevel(this.FBODetailPermissions, AccessLevel.Customer_Service)) {
            const fboInfo = { id: id, tabName: firstName, componentName: 'fboPage', memberType: MemberType.FOB };
            this.messageService.setCustomerServiceTabContent(fboInfo);
        } else {
            this.displayAlertbox();
        }
    }
    closeModal(status: boolean){
        this.accountRestriction = status;
    }
    /**
   * display alert box if the logged in user do not have permission to see the fbo/retail information
   */
    displayAlertbox(): void {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.noPermissionMessage;
    }

    /**
   * Get json form validations
   *
   * @memberof PersonalInfoComponent
   */
    getFormValidationsJSON(): void {
        this._commonService.getFormValidationsJSON()
            .subscribe((response: any) => {
                this.getCountrySpecificValidations(response);
            });
    }

    getCountrySpecificValidations(validations: CountryLevelValidations[]): void {
        if (validations) {
            const filterCountryLevlValidations = validations
                .find(x => x.countryCode.toUpperCase() === this.homeCountry.toUpperCase());
             if (filterCountryLevlValidations) {
                this.personalInfoFormValidations = filterCountryLevlValidations.validations;
            }
        }
    }

    onKeypress(event: any, controlName: string) {
        this.duplicateCheck = false;
        if (controlName === 'ssn') {
        }
        if (event.keyCode != 9) {
            const value: any = (event.key ? event.key : '');
            if (this.personalInfoFormValidations && this.personalInfoFormValidations.governmentID) {
                if (!new RegExp(this.personalInfoFormValidations.governmentID.pattern).test(value)) {
                    event.preventDefault();
                }
            } else {
                const pattern = /^[0-9]*$/;
                if (!new RegExp(pattern).test(value)) {
                    event.preventDefault();
                }
            }
        } else {
            error;
        }
    }

    // Updating updateGovernmentID
    updateGovernmentID(isValid: boolean) {
        this.fboProfileDetail.governmentIDType = this.fboProfileDetail.governmentIDType || GovernmentIDType.SSN;
        if (isValid && this.ssn !== '') {
            const identificationType = this.getIdentificationType();
            const identificationModel: IdentificationType = this.identificationTypes.find((x: IdentificationType) =>
                x.countryID === this.fboProfileDetail.homeCountryId && x.identificationType === identificationType
            );
            const memberGovernmentIdentifications = {
                'governmentIDType': identificationModel && identificationModel.identificationTypeID,
                'value': this.changeGovtIDForm.controls['ssn'].value,
                'identificationType': identificationModel && identificationModel.identificationType
            };
            this._customerService.validateGovernmentID(this.storeId, this.changeGovtIDForm.controls['ssn'].value,
                this.homeCountry, this.fboProfileDetail.memberId).subscribe((response) => {
                    this.duplicateCheck = true;
                }, error => {
                    this.duplicateCheck = false;
                    this._customerservice.updateGovernmentID(memberGovernmentIdentifications,
                        this.fboProfileDetail.id).subscribe((response) => {
                            if (response.isSuccess === true) {
                                this.memberGovernmentIdentifiations = [];
                                const activityLogKeys: ActivityLogKey[] = [{
                                    key: MemberActivityLogType.Change_Government_ID,
                                    value: '******' + this.changeGovtIDForm.controls['ssn'].value.substr(-4)
                                }];
                                this._id ? this.getMembergovernmentIdentificationsInfo(this.fboProfileDetail.memberId) : '';
                                this._commonService.saveMemberActivity(this.fboProfileDetail.id, activityLogKeys).subscribe(res => { },
                                    (error: any) => { });
                                this.message = 'Request for Government ID update was submitted, changes will reflect shortly.';
                                this._commonService.createNotification('', this.message, NotificationType.WARN);
                            } else {
                                this._commonService.createNotification('', 'error, While Updating', NotificationType.ERROR);
                            }
                            this.changeGovtIDPopup.close();
                        });
                });
        }
    }

    /*
    * Update Date of Birth
    */
    updateDateOfBirth(isValid: boolean) {
        if (isValid) {
            const dob: any = this._datePipe.transform(this.changeDOBForm.controls['birthDate'].value, 'yyyy-MM-dd');
            this._customerService.updateDOB(this.fboProfileDetail.id, dob).subscribe(response => {
                if (response.isSuccess) {
                    const activityLogKeys: ActivityLogKey[] = [{
                        key: MemberActivityLogType.Change_DOB,
                        value: this._datePipe.transform(this.changeDOBForm.controls['birthDate'].value, 'dd-MMM-yyyy')
                    }];
                    this._commonService.saveMemberActivity(this.fboProfileDetail.id, activityLogKeys).subscribe();
                    const notification: any = this._translatePipe.get('customer-service.DOB Updated Successfully');
                    this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                    this.closePopUp();
                    this.getFBOProfileInfoFromTitan();
                } else {
                    this._commonService.createNotification('', 'error, While Updating', NotificationType.ERROR);
                }
                this.getFBOProfileInfoFromTitan();
            });
        }
    }

    /**
     * @description open member preferences popup
     * @date 2020-04-13
     * @memberof FBOProfileComponent
     */
    openChangeMemberPreferences(): void {
        this.myMemberPreferences = [];
        if (this.fboProfileDetail.memberId) {
            this._customerService.getMemberPreferences(this.fboProfileDetail.memberId).subscribe(response => {
                if (response.memberPreferenceModels) {
                    response.memberPreferenceModels.forEach(item => {
                        if (item.preferenceId === MemberPreferenceType.Email) {
                            this.myMemberPreferences.push(item);
                        }
                    });
                    if (this.myMemberPreferences && this.myMemberPreferences.length) {
                        this.myMemberPreferences.forEach(preference => {
                            if (preference.preferenceId === MemberPreferenceType.Email) {
                                if (Number(preference.preferenceValue) === PreferenceValues.no) {
                                    preference.selected = true;
                                }
                                else if(Number(preference.preferenceValue) === PreferenceValues.yes) {
                                    preference.selected = false;
                                }
                            }
                        });
                    } else {
                        this.myMemberPreferences.push({
                            preferenceId: MemberPreferenceType.Email,
                            preferenceValue: '37',
                            selected: false,
                            memberId: this.fboProfileDetail.memberId,
                            id: MemberPreferenceType.Email
                        });
                    }
                    this.changeMemberPreference.open();
                }
            });
        }
    }

    /**
     * @description on checkbox change
     * @date 2020-04-13
     * @param {MemberPrefernceModel} preference
     * @memberof FBOProfileComponent
     */
    OnCheckPreference(preference: MemberPrefernceModel, isChecked) {
        this.myMemberPreferences.forEach(item => {
            if (item.id === preference.id) {
                item.selected = isChecked ? true : false;
            }
        });
    }

    /**
     * @description update member preferences
     * @date 2020-04-13
     * @memberof FBOProfileComponent
     */
    updateMemberPreferences() {
        const requestArray: any[] = [];
        this.saveMemberPreferenceActiveLog();
        this.fboProfileDetail.memberPreference = this.myMemberPreferences[0].selected ? 'Yes' : 'No';
        this.distributorInfoObj.privacyRequested = this.fboProfileDetail.memberPreference;
        this.distributorInfo.emit(this.distributorInfoObj);
        this.myMemberPreferences.forEach(preference => {
            requestArray.push({
                id: preference.preferenceId,
                selected: preference.selected ? false : true
            });
            requestArray.push({
                id: MemberPreferenceType.PrivacyPreference,
                selected: preference.selected ? false : true,
            });
        });
        this.memberPreferenceUpdate(this.fboProfileDetail.memberId, requestArray);
        this.changeMemberPreference.close();
    }

    saveMemberPreferenceActiveLog(): void {
        const activityLogKeys: ActivityLogKey[] = [];
        if (this.fboProfileDetail.memberPreference !== (this.myMemberPreferences[0].selected ? 'Yes' : 'No')) {
            activityLogKeys.push({
                key: MemberActivityLogType.Member_Preference_Updated,
                value: this.myMemberPreferences[0].selected ? 'Yes' : 'No'
            });
        }
        if (activityLogKeys && activityLogKeys.length) {
            this._commonService.saveMemberActivity(this.fboProfileDetail.memberId, activityLogKeys)
                .subscribe(res => { }, (error: any) => { });
        }
        return;
    }

    enableAmazonSubscription(subscribed: boolean): void {
        const amazonSubscription: boolean = this.fboProfileDetail.amazonSubscription === CommonConstant.YES ? true : false;
        if (!(amazonSubscription === subscribed)) {
            const preference: any[] = [];
            preference.push({
                id: MemberPreferenceType.AmazonSubscription,
                selected: subscribed
            });
            this.memberPreferenceUpdate(this.fboProfileDetail.memberId, preference, true);
            this.fboProfileDetail.amazonSubscription = subscribed ? CommonConstant.YES : CommonConstant.NO;
            this.saveMemberAmazonSubscriptionLog(subscribed);
        }

    }

    memberPreferenceUpdate(memberId: any, preference: any[], isAmazonSubscription?: boolean): void {
        let updatedBy;
        const userId = localStorage.getItem('appadmin.UserId')
        if(userId)
        {
            updatedBy=userId;
        }
        this._customerService.updateMemberPreferences(memberId, preference,updatedBy)
            .subscribe(response => {
                if (response) {
                    const notificationValue = isAmazonSubscription ? 'Amazon Subscription Updated Successfully' : 'Member Preference Updated Successfully';
                    const notification: any = this._translatePipe.get(notificationValue);
                    this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                }
            }, error => {
                if (error) {
                    const addedNotification: any = this._translatePipe.get('errorcodes.' + error.validations[0].name);
                    this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                }
            });
    }

    saveMemberAmazonSubscriptionLog(subscribed?: boolean): void {
        const activityLogKeys: ActivityLogKey[] = [];
        activityLogKeys.push({
            key: MemberActivityLogType.Amazon_Subscription_Updated,
            value: subscribed ? 'Yes' : 'No'
        });
        if (activityLogKeys && activityLogKeys.length) {
            this._commonService.saveMemberActivity(this.fboProfileDetail.memberId, activityLogKeys)
                .subscribe(res => { }, (error: any) => { });
        }
        return;
    }

    /**
   * @description create the formatted enrollment date
   * @date 2020-08-04
   * @param {string} dateString
   * @returns {Date}
   * @memberof FBOProfileComponent
   */
    getFormattedEnrollmentDate(dateString: string): Date {
        let enrollmentDate = null;
        if (dateString) {
            const enrolDate = new Date(dateString);
            enrollmentDate = new Date(enrolDate.getTime() + enrolDate.getTimezoneOffset() * 60000);
        }
        return enrollmentDate;
    }

    /**
     * @description Get member level and 4CC active
     * @date 2020-08-04
     * @param {string} homeCountry
     * @memberof FBOProfileComponent
     */
    getMemberLevel4CCActive(operatingCountry) {
        operatingCountry = operatingCountry ? operatingCountry.toString() : '';
        if (operatingCountry) {
            this._commonService
                .getTwoCCSnapshotDetails(this._id, operatingCountry)
                .subscribe(response => {
                    if (response) {
                        this.ccSnapshot4CCActive.ccKey = '4CC Active';
                        this.ccSnapshotLevel.ccKey = 'Level';
                        // if (response[0].monthlyCCValues[2]) {
                        this.ccSnapshot4CCActive.previousMonthValue = response[0].currentMonthActive;
                        this.ccSnapshotLevel.previousMonthValue = response[0].endingLevel;
                        // }
                        // if (response[0].monthlyCCValues[3]) {
                        this.ccSnapshot4CCActive.currentMonthValue = response[1].currentMonthActive;
                        this.ccSnapshotLevel.currentMonthValue = response[1].endingLevel;
                        // }
                    }
                });
        }

    }

    /**
     * @description Get Member level
     * @date 2020-08-28
     * @param {number} level
     * @returns {string}
     * @memberof FBOProfileComponent
     */
    getMemberLevel(level: number): string {
        return MemberTitleExtEnums[level] ? MemberTitleExtEnums[level].replace('_', ' ') : '';
    }

    /**
     * @description will return save address request
     * @date 2020-09-23
     * @param {Address} address
     * @param {boolean} isUpdatememberHomeCompany
     * @returns {*}
     * @memberof FBOProfileComponent
     */
    prepareSaveAddressRequest(address: Address, isUpdatememberHomeCompany: boolean): any {
        const saveAddressRequest = {
            'memberId': this.fboProfileDetail.id,
            'addressLine1': address.addressLine1,
            'addressLine2': address.addressLine2,
            'addressLine3': address.addressLine3 ? address.addressLine3 : '',
            'addressLine4': address.addressLine4 ? address.addressLine4 : '',
            'city': address.city,
            'stateId': address.stateId ? address.stateId : null,
            'stateCode': address.stateCode ? address.stateCode : '',
            'countryId': address.countryId ? address.countryId : null,
            'countryCode': address.countryCode ? address.countryCode : null,
            'postalCode': address.postalCode ? address.postalCode : '',
            'contactTypeID': '',
            'defaultAddress': false,
            'addressVerified': address.addressVerified,
            'addressTypeId': AddressType.MAILING,
            'id': this.addressDetailId,
            'loggedInUserId': this.userInfo ? this.userInfo.userId : '',
            'responseCodes': address.responseCodes ? address.responseCodes : null,
            'latitude': address.latitude,
            'longitude': address.longitude,
            'changedValueType':[]
        };
        if (isUpdatememberHomeCompany) {
            saveAddressRequest['memberHomeCompany'] = this.fboProfileDetail.operatingCountry;
        }
        if ((saveAddressRequest.addressLine1 ? saveAddressRequest.addressLine1 : "") !== (this.fboProfileDetail.address.addressLine1 ? this.fboProfileDetail.address.addressLine1 : "") ||
            (saveAddressRequest.addressLine2 ? saveAddressRequest.addressLine2 : "") !== (this.fboProfileDetail.address.addressLine2 ? this.fboProfileDetail.address.addressLine2 : '') ||
            (saveAddressRequest.addressLine3 ? saveAddressRequest.addressLine3 : "") !== (this.fboProfileDetail.address.addressLine3 ? this.fboProfileDetail.address.addressLine3 : '') ||
            (saveAddressRequest.addressLine4 ? saveAddressRequest.addressLine4 : "") !== (this.fboProfileDetail.address.addressLine4 ? this.fboProfileDetail.address.addressLine4 : '') ||
            (saveAddressRequest.city ? saveAddressRequest.city : "") !== (this.fboProfileDetail.address.city ? this.fboProfileDetail.address.city : "") ||
            (saveAddressRequest.postalCode ? saveAddressRequest.postalCode : "") !== (this.fboProfileDetail.address.zipCode ? this.fboProfileDetail.address.zipCode : "") ||
            (saveAddressRequest.countryId ? saveAddressRequest.countryId : "") !== (this.fboProfileDetail.address.countryId ? this.fboProfileDetail.address.countryId : "") ||
            (saveAddressRequest.stateId ? saveAddressRequest.stateId : "") !== (this.fboProfileDetail.address.stateId ? this.fboProfileDetail.address.stateId : "")) {
            if ((saveAddressRequest.countryId ? saveAddressRequest.countryId : "") !== (this.fboProfileDetail.address.countryId ? this.fboProfileDetail.address.countryId : "")) {
                saveAddressRequest.changedValueType = [FBOProfileUpdateEnum.MEMBER_HOME_COUNTRTY_CHANGE];
            } else {
                saveAddressRequest.changedValueType = [FBOProfileUpdateEnum.MEMBER_MAILING_ADDRESS_CHANGE];
            }
        }
        let addressVerifiedflag = +saveAddressRequest.latitude === 0 && +saveAddressRequest.longitude === 0 ? false : true;
        saveAddressRequest.addressVerified = saveAddressRequest.addressVerified && addressVerifiedflag ? true : false;
        return saveAddressRequest;
    }
    /**
     * @description will set enable Address subject
     * @date 2020-09-23
     * @param {string} block
     * @memberof FBOProfileComponent
     */
    enableAddressFields(block: string): void {
        const addressFieldInfo: AddressVisibility = {
            isEnableAddressFields: true,
            block: block
        };
        this.messageService.setEnableAddressFields(addressFieldInfo);
    }

    /**
     * @date 2020-10-07
     * @param {*} event
     * @memberof FBOProfileComponent
     */
    displaySearchAddressSection(event: any): void {
        this.isDisplaySearchAddressSection = event;
    }
    getIdentificationTypes(): void {
        this._customerService.getGovernmentIdentificationTypes()
            .subscribe((response) => {
                if (response) {
                    this.identificationTypes = response;
                    this.governmentIdentificationTypes = JSON.parse(JSON.stringify(response));
                    this.alterIdentificationTypes(this.governmentIdentificationTypes);
                }
        });
    }

    alterIdentificationTypes(governmentIdentificationTypes): void {             
        try{
            const storedCountries = localStorage.getItem("appadmin.Countries");
            const countries = storedCountries ? JSON.parse(storedCountries) : [];
            if (governmentIdentificationTypes && governmentIdentificationTypes.length && countries && countries.length) {
                const eligibleCountryIDs = countries
                .filter(country => country && country.isocodeThree && CountryCodeConstant.EligibleCountriesForVatTaxId.includes(country.isocodeThree.toUpperCase()))
                .map(country => country.countryId);
                governmentIdentificationTypes.forEach(governmentIdentificationType => {
                    if (governmentIdentificationType && governmentIdentificationType.identificationType &&
                        governmentIdentificationType.identificationType === GovernmentIdentificationType.VAT_ID &&
                        governmentIdentificationType.countryID && eligibleCountryIDs &&
                        eligibleCountryIDs.includes(governmentIdentificationType.countryID)) {
                        governmentIdentificationType.governmentIdTypeLabel = GovernmentIdentificationType.TAX_ID;
                    }
                });
            }
        }catch(error){
            console.log(error);
        }
    } 


    private getIdentificationType(): string {
        let identificationType: string;
        switch (this.fboProfileDetail.homeCountryCode.toUpperCase()) {
            case 'USA':
                identificationType = IdentificationTypeConstant.USA;
                break;
            case 'CAN':
                identificationType = IdentificationTypeConstant.CAN;
                break;
            case 'GBR':
                identificationType = IdentificationTypeConstant.GBR;
                break;
            case 'IRL':
                identificationType = IdentificationTypeConstant.GBR;
                break;
            case 'ILN':
                identificationType = IdentificationTypeConstant.GBR;
                break;
            case 'ARE':
                identificationType = IdentificationTypeConstant.ARE;
                break;
            case 'SAU':
                identificationType = IdentificationTypeConstant.SAU;
                break;
            case 'QAT':
                identificationType = IdentificationTypeConstant.QAT;
                break;
            case 'KWT':
                identificationType = IdentificationTypeConstant.KWT;
                break;
            case 'BHR':
                identificationType = IdentificationTypeConstant.BHR;
                break;
            case 'OMN':
                identificationType = IdentificationTypeConstant.OMN;
                break;
            case 'AUS':
                identificationType = IdentificationTypeConstant.AUS;
                break;
            case 'SWE':
                identificationType = IdentificationTypeConstant.SWE;
                break;
            case 'FIN':
                identificationType = IdentificationTypeConstant.FIN;
                break;
            case 'NOR':
                identificationType = IdentificationTypeConstant.NOR;
                break;
            case 'DNK':
                identificationType = IdentificationTypeConstant.DNK;
                break;
            case 'NZL':
                identificationType = IdentificationTypeConstant.NZL;
                break;
            case 'POL':
                identificationType = IdentificationTypeConstant.POL;
                break;
            case 'MKD':
                    identificationType = IdentificationTypeConstant.MKD;
                    break;
            case 'BGR':
                    identificationType = IdentificationTypeConstant.BGR;
                    break;
            default:
                identificationType = IdentificationTypeConstant.USA;
                break;
        }
        return identificationType;
    }
    openChangeGovtIDModal() {
        if(!this.memberGovernmentIdentifiations && !this.memberGovernmentIdentifiations.length  && this.fboProfileDetail && this.fboProfileDetail.memberId){
            this.getMembergovernmentIdentificationsInfo(this.fboProfileDetail.memberId);
         }
        const control = <FormArray>this.updateGovIDForm.controls['govermentIdentification'];
        for (let i = control.length - 1; i >= 0; i--) {
            control.removeAt(i);
        }
        if (this.memberGovernmentIdentifiations && this.memberGovernmentIdentifiations.length > 0) {
            const control = <FormArray>this.updateGovIDForm.controls['govermentIdentification'];
            if (control && control.length < 10) {
                const createIdentificationForm: any = this.updateGovIDForm.get('govermentIdentification') as FormArray;
                this.memberGovernmentIdentifiations.forEach((item, index) => {
                    createIdentificationForm.push(this._formbuilder.group({
                        country: [this.getMemberAllowedCountryCode(item.countryID), Validators.required],
                        governmentIdType: [this.getIdentificationModel(item.governmentIdentificationType, item.countryID), Validators.required],
                        governmentIdValue: [item.value],
                        id: [item.id]
                    }));
                });
            }

        } else {
            this.addNewGovermentIdGroup();
        }
        this.governmentIdValueEditIndexes = [];
        this.changeGovtIDPopup.open();
        setTimeout(function () {
            if (document.getElementById('ssn-input')) {
                document.getElementById('ssn-input').focus();
            }
        }, 200);
    }
    getMemberAllowedCountryCode(countryId: number): string {
        if (countryId) {
            const selectedCountry = this.countries.find(country => country.countryId === countryId);
            return selectedCountry.isocodeThree;
        }
    }
    getIdentificationModel(governmentIdentificationType: string, countryID: number): IdentificationType {
        let identificationsByCountry: IdentificationType;
        if (governmentIdentificationType && countryID) {
            identificationsByCountry = this.governmentIdentificationTypes.find(x => x.countryID === countryID && x.identificationType === governmentIdentificationType);
        }
        return identificationsByCountry;
    }
    addNewGovermentIdGroup() {
        const control = <FormArray>this.updateGovIDForm.controls['govermentIdentification'];
        if (control && control.length < 10) {
            const createIdentificationForm = this.updateGovIDForm.get('govermentIdentification') as FormArray;
            createIdentificationForm.push(this._formbuilder.group({
                country: ['', Validators.required],
                governmentIdType: ['', Validators.required],
                governmentIdValue: ['', Validators.required],
                id: ['']
            }));
        }
    }
    countryChangeForGovermentId(countryCode: string, index: number, isCountryChange?: Boolean): void {
        const governmentIdentificationForm: any = this.updateGovIDForm.get('govermentIdentification');
        governmentIdentificationForm.controls[index].controls['governmentIdType'].setValue('');
        governmentIdentificationForm.controls[index].controls['governmentIdValue'].setValue('');
        governmentIdentificationForm.controls[index].controls['governmentIdType'].updateValueAndValidity();
        governmentIdentificationForm.controls[index].controls['governmentIdValue'].updateValueAndValidity();
    }
    deleteGovernmentID(index: number, id: number) {
        const governmentIdentificationForm: any = this.updateGovIDForm.get('govermentIdentification');
        if (governmentIdentificationForm.controls[index].controls['country'].value || governmentIdentificationForm.controls[index].controls['governmentIdValue'].value || governmentIdentificationForm.controls[index].controls['governmentIdType'].value) {
            this.govIdRemoveConfirmationPopup.open(index, id);
        } else {
            this.deleteGovernmentIDGroup(index, id);
        }
    }
    editGovernmentID(index: number, id: number) {
        this.isEditGovId = true;
        if (id) {
            this.governmentIdValueEditIndexes.push(id);
        }
        const governmentIdentificationForm: any = this.updateGovIDForm.get('govermentIdentification');
        governmentIdentificationForm.controls[index].controls['governmentIdValue'].setValue('');
        governmentIdentificationForm.controls[index].controls['governmentIdValue'].updateValueAndValidity();
        let isValidationsSet = false;
        if (governmentIdentificationForm.countryID && governmentIdentificationForm.governmentIdentificationType) {
            const pattern = this.getIdentificationPattern(this.getMemberAllowedCountryCode(governmentIdentificationForm.countryID),
                governmentIdentificationForm.governmentIdentificationType);
            if (pattern) {
                governmentIdentificationForm.controls[index].controls['governmentIdValue']
                    .setValidators(this.getValidators(pattern), false);
                governmentIdentificationForm.controls[index].controls['governmentIdValue'].updateValueAndValidity();
                isValidationsSet = true;
            }
        }
        if (!isValidationsSet) {
            governmentIdentificationForm.controls[index].controls['governmentIdValue'].setValidators([Validators.required]);
            governmentIdentificationForm.controls[index].controls['governmentIdValue'].updateValueAndValidity();
        }
        this.setValidationsToGovernmentId(index,governmentIdentificationForm.controls[index].controls['country'].value,governmentIdentificationForm.controls[index].controls['governmentIdType'].value);
    }
    closeDeleteGovernmentIDGroupPopup() {
        this.duplicateGovIdErrorMessage = null;
        this.govIdRemoveConfirmationPopup.close();
    }
    deleteGovernmentIDGroup(index: number, id: number) {
        if (this.fboProfileDetail && this.memberGovernmentIdentifiations && this.memberGovernmentIdentifiations.length  && this.fboProfileDetail.homeCountryId) {
            if(this.memberGovernmentIdentifiations.find(x => x.id == id && x.countryID == this.fboProfileDetail.homeCountryId && 
                (x.governmentIdentificationType).toUpperCase() === 'VAT ID')){
                this.deleteHomeCountryVat = true;
            }  
         }
        this.duplicateGovIdErrorMessage = null;
        this.govIdRemoveConfirmationPopup.close();
        // const control = <FormArray>this.updateGovIDForm.controls['govermentIdentification'];
        const control = this.updateGovIDForm.get('govermentIdentification') as FormArray;
        control.removeAt(index);
        const position = this.governmentIdValueEditIndexes.indexOf(id);
        if (position != -1) {
            this.governmentIdValueEditIndexes.splice(position, 1);
        }
        this.updateGovIDForm.markAsDirty();
    }
    getGovermentIdentificationPatterns() {
        this._commonService.getGovermentIdentificationPatterns().subscribe((response: any[]) => {
            this.govermentIdentificationPattern = response;
        });
    }
    addGovernmentIdsList(governmentIdForm: any, isValid: boolean): void {
        this.vatIdBWP = true;
        this.businessEntityBWP = false;
        this.checkBondedWarehouseProject(governmentIdForm, isValid);
    }
    checkGovernmentIdValue(governmentIdForm: any, isValid: boolean) {
        if (governmentIdForm && isValid) {
            this.governmentIdValidationInProgress = true;
            governmentIdForm.govermentIdentification.forEach(item => {
                if (this.fboProfileDetail && this.memberGovernmentIdentifiations && this.memberGovernmentIdentifiations.length && this.fboProfileDetail.homeCountryId) {
                    if (item.governmentIdType && item.governmentIdType.identificationType && item.governmentIdType.countryID &&
                        item.governmentIdType.identificationType === GovernmentIdentificationType.VAT_ID && item.governmentIdType.countryID == this.fboProfileDetail.homeCountryId) {
                        this.memberGovernmentIdentifiations.forEach(x => {
                            if (x.governmentIdentificationType && x.countryID && item.governmentIdValue &&
                                x.governmentIdentificationType === GovernmentIdentificationType.VAT_ID && x.countryID == this.fboProfileDetail.homeCountryId) {
                                    if(x.value){
                                        this.updateHomeCountryVat = item.governmentIdValue !== x.value;}
                                        else {
                                        this.updateHomeCountryVat = true;}
                            }
                        });
                        const memberGovernmentIdentifiations = this.memberGovernmentIdentifiations.filter((x) => x.governmentIdentificationType === GovernmentIdentificationType.VAT_ID && x.countryID == this.fboProfileDetail.homeCountryId);
                        if (!memberGovernmentIdentifiations.length && !this.updateHomeCountryVat) {
                            this.updateHomeCountryVat = true;
                        }
                    } else if (item.governmentIdType.identificationType != GovernmentIdentificationType.VAT_ID && item.governmentIdType.countryID == this.fboProfileDetail.homeCountryId) {
                        this.memberGovernmentIdentifiations.forEach(x => {
                            if (x.governmentIdentificationType === GovernmentIdentificationType.VAT_ID && x.governmentIdentificationType != item.governmentIdType.identificationType && x.countryID == this.fboProfileDetail.homeCountryId) {
                                this.deleteHomeCountryVat = true;
                            }
                        });
                    }
                }
                // newly inserting vatid record update
                else if (!this.memberGovernmentIdentifiations.length && item.governmentIdType.identificationType === GovernmentIdentificationType.VAT_ID
                    && item.governmentIdType.countryID == this.fboProfileDetail.homeCountryId) {
                    this.updateHomeCountryVat = true;
                }
            });
            const governmentIdTypes: GovernmentIDentifcation[] = this.prepareMemberGovernmentIdRequest(governmentIdForm);
            this._enrollService.updateMemberGovernmentIdentifications(this.fboProfileDetail.memberId, governmentIdTypes,this.deleteHomeCountryVat).subscribe(
                (response) => {
                    if (response) {
                        this.updateActivityLogForGovernmentIdentifications(governmentIdForm, this.memberGovernmentIdentifiations, this.fboProfileDetail.memberId);
                        // this.getFBOProfileInfoFromTitan(false, true);
                        this.getMembergovernmentIdentificationsInfo(this.fboProfileDetail.memberId);
                        // const notification: any = this._translatePipe.get('customer-service.Government Identifications are updated Successfully');
                        this._commonService.createNotification('', 'Government Identifications are updated Successfully', NotificationType.SUCCESS);
                        this.isUpdateButtonClicked = false;
                        this.governmentIdValidationInProgress = false;
                        if (governmentIdForm.govermentIdentification.find((el) => el && el.governmentIdType.countryID === this.homeCountryId)) {
                            this.bondedWarehouseProjectSelected = false;
                            this.bwpDisableMessage = false;
                            this.submitBondedWarehouseProject();
                        }
                        this.closeGovtIDPopUp();
                    }
                });
        }
    }
    prepareMemberGovernmentIdRequest(governmentIdForm: any): GovernmentIDentifcation[] {
        const governmentIdTypes: GovernmentIDentifcation[] = [];
        governmentIdForm.govermentIdentification.forEach(item => {
            governmentIdTypes.push({
                id: item.id ? item.id : null,
                governmentIDType: item.governmentIdType && item.governmentIdType.identificationTypeID ? item.governmentIdType.identificationTypeID : null,
                countryID: item.governmentIdType && item.governmentIdType.countryID ? item.governmentIdType.countryID : null,
                value: item.governmentIdValue ? item.governmentIdValue : null,
                identificationType: item.governmentIdType && item.governmentIdType.identificationTypeID ? item.governmentIdType.identificationType : null,
                changedValueType :((item.governmentIdType.identificationType === GovernmentIdentificationType.VAT_ID)&&
                (item.governmentIdType && item.governmentIdType.countryID &&(item.governmentIdType.countryID == this.fboProfileDetail.homeCountryId))&&
                (this.updateHomeCountryVat))? [FBOProfileUpdateEnum.MEMBER_VATID_CHANGE]:null
            });
        });
        return governmentIdTypes;
    }

    updateButtonClicked() {
        this.isUpdateButtonClicked = true;
    }
    cancelButtonClicked() {
        this.isCancelButtonClicked = true;
    }

    checkUniqueGovIDValue(govIdForm: any, index: number): void {
        const governmentIdentificationForm: any = this.updateGovIDForm.get('govermentIdentification');
        const country = governmentIdentificationForm.controls[index].controls['country'].value;
        const govIdValue = governmentIdentificationForm.controls[index].controls['governmentIdValue'].value;
        if(govIdValue){
            governmentIdentificationForm.controls[index].controls['governmentIdValue'].setValue(govIdValue.trim());
        }
        const govIdentificationType = governmentIdentificationForm.controls[index].controls['governmentIdType'].value;
        const idValue = governmentIdentificationForm.controls[index].controls['id'].value;
        let isDuplicateGovId = false;
        let isValidBsn = true;
        if (!this.isCancelButtonClicked) {
            if (country && govIdValue && governmentIdentificationForm.controls[index].valid) {
                this.governmentIdValidationInProgress = true;
                let storeInformation = null;
                this._configurationService.getStoreByCountry(country).subscribe((data) => {
                    this.governmentIdValidationInProgress = false;
                    storeInformation = data;
                    let storeId = null;
                    if (storeInformation && storeInformation.id) {
                        storeId = storeInformation.id;
                    }
                    this.governmentIdValidationInProgress = true;
                    if (this.appConfig.isBSNEnabled && govIdentificationType.identificationType === GovernmentIdentificationType.BSN) {
                        this._customerService.validateBSNumber(country, govIdValue)
                            .subscribe((response) => {
                                this.governmentIdValidationInProgress = false;
                                if (response && response.valid) {
                                    isValidBsn = true;
                                    const position = this.governmentIdValueEditIndexes.indexOf(idValue);
                                    if (position !== -1) {
                                        this.governmentIdValueEditIndexes.splice(position, 1);
                                    }
                                } else {
                                    isValidBsn = false;
                                    governmentIdentificationForm.controls[index].controls['governmentIdValue']
                                        .setErrors({ inValidBsn: 'Invalid BSN' });
                                }
                                if (this.isUpdateButtonClicked) {
                                    this.addGovernmentIdsList(govIdForm.value, govIdForm.valid);
                                }
                            }, (error) => {
                                this.governmentIdValidationInProgress = false;
                            });
                    } else {
                        this._customerService.validateGovernmentID(storeId, govIdValue, country, this.fboProfileDetail.memberId, govIdentificationType.identificationType)
                            .subscribe((response) => {
                                this.governmentIdValidationInProgress = false;
                                if (response && response.success) {
                                    isDuplicateGovId = true;
                                    // already exist
                                } else {
                                    isDuplicateGovId = true;
                                    // already exist
                                }
                                const personalInfoSettings =this._personalInfoConfigService.getSettings(country);
                                if (isDuplicateGovId) {
                                    governmentIdentificationForm.controls[index].controls['governmentIdValue'].setErrors({ duplicateGovId: personalInfoSettings && personalInfoSettings.personalIDValidationMgs  && govIdentificationType.identificationType.toLowerCase() === GovernmentIdentificationType.PERSONAL_ID.toLowerCase()? "Invalid PESEL Number" : 'Government Id Already Exists' });
                                }
                            },
                                (error: any) => {
                                    this.governmentIdValidationInProgress = false;
                                    const response = error;
                                    if (response && response.validations && !response.statusCode
                                        && response.validations.length > 0) {
                                    }
                                    // id not exist
                                    isDuplicateGovId = false;
                                    const position = this.governmentIdValueEditIndexes.indexOf(idValue);
                                    if (position != -1) {
                                        this.governmentIdValueEditIndexes.splice(position, 1);
                                    }
                                    if (this.isUpdateButtonClicked) {
                                        this.addGovernmentIdsList(govIdForm.value, govIdForm.valid);
                                    }
                                });
                    }
                }, (error) => {
                    this.governmentIdValidationInProgress = false;
                });
            }
        }
    }

    changeGovIdToUppercase(index: number) {
        const governmentIdentificationForm: any = this.updateGovIDForm.get('govermentIdentification');
        if (governmentIdentificationForm.controls[index].controls['governmentIdValue'].value) {
            governmentIdentificationForm.controls[index].controls['governmentIdValue'].setValue(governmentIdentificationForm.controls[index].controls['governmentIdValue'].value.toUpperCase());
        }
    }

    setValidationsToGovernmentId(index: number, countryCode: string, governmentIdentificationType: any, isDuplicateGovId: boolean = false, clearValue: boolean = true) {
        const governmentIdentificationForm: any = this.updateGovIDForm.get('govermentIdentification');
        governmentIdentificationForm.controls[index].controls['governmentIdValue'].clearValidators();
        governmentIdentificationForm.controls[index].controls['governmentIdValue'].updateValueAndValidity();
        governmentIdentificationForm.controls[index].controls['governmentIdValue'].setValidators([Validators.required]);
        if (clearValue) {
            governmentIdentificationForm.controls[index].controls['governmentIdValue'].setValue('');
        }
        governmentIdentificationForm.controls[index].controls['governmentIdValue'].updateValueAndValidity();
        if (countryCode && governmentIdentificationType.identificationTypeID > 0 && index >= 0 && this.govermentIdentificationPattern.length > 0) {
            const selectedIdentificationType = governmentIdentificationType.identificationType;
            const countryIdentificationPattern = this.getIdentificationPattern(countryCode, selectedIdentificationType);
            if (countryIdentificationPattern) {
                this.setIdentificationValueValidators(governmentIdentificationForm, countryIdentificationPattern, index, isDuplicateGovId);
            }
        }
    }
    getIdentificationPattern(countryCode: string, identificationType: any) {
        if (countryCode && identificationType) {
            const pattern = this.govermentIdentificationPattern.find((identification) => identification.countryCode.toLowerCase() === countryCode.toLowerCase() && identification.identificationType.toLowerCase() === identificationType.toLowerCase());
            return pattern;
        } else {
            return null;
        }
    }

    setIdentificationValueValidators(governmentIdentificationForm: any, identificationPattern: any, index: number, isDuplicateGovId: boolean = false) {
        if (identificationPattern) {
            governmentIdentificationForm.controls[index].controls['governmentIdValue'].setValidators(this.getValidators(identificationPattern), isDuplicateGovId);
            governmentIdentificationForm.controls[index].controls['governmentIdValue'].updateValueAndValidity();
        }
    }

    getValidators(identificationPattern: any, isDuplicateGovId: boolean = false) {
        const validators = [];
        validators.push(Validators.required);
        if (identificationPattern.pattern) {
            validators.push(Validators.pattern(identificationPattern.pattern));
        }
        if (identificationPattern.minLength) {
            validators.push(Validators.minLength(identificationPattern.minLength));
        }
        if (identificationPattern.maxLength) {
            validators.push(Validators.maxLength(identificationPattern.maxLength));
        }
        if (isDuplicateGovId) {
            validators.push(DuplicateGovernmentIdValidator.duplicateGovId(isDuplicateGovId));
        }
        return validators;
    }

    getBusinessEntityValidators(fieldName) {
        const validators = [];
        switch (fieldName) {
            case 'businessEntityId':
                validators.push(Validators.minLength(5), Validators.maxLength(50), Utils.alphaNumericIphenCharacterValidation);
                if (this.appConfig && (!this.appConfig.businessEntityConfig || !this.appConfig.businessEntityConfig.businessEntityIDOptional)) {
                    validators.push(Validators.required);
                }
                break;
        }
        return validators;
    }

    duplicateGovIdType($event) {
        if ($event) {
            this.duplicateGovIdErrorMessage = $event;
            setTimeout(function () {
                this.duplicateGovIdErrorMessage = null;
            }, 5000);
        } else {
            this.duplicateGovIdErrorMessage = null;
        }
    }

    getGovIdMask(index: number): string {
        const governmentIdentificationForm: any = this.updateGovIDForm.get('govermentIdentification');
        const country = governmentIdentificationForm.controls[index].controls['country'].value;
        const identificationType = governmentIdentificationForm.controls[index].controls['governmentIdType'].value.identificationType;
        const govIdMask = this.getIdentificationPattern(country, identificationType);
        if (govIdMask && govIdMask.maskFormat) {
            return govIdMask.maskFormat;
        } else {
            return '';
        }
    }
    getGovIdMaxLength(index: number): string {
        const governmentIdentificationForm: any = this.updateGovIDForm.get('govermentIdentification');
        const country = governmentIdentificationForm.controls[index].controls['country'].value;
        const identificationType = governmentIdentificationForm.controls[index].controls['governmentIdType'].value.identificationType;
        const govIdpattern = this.getIdentificationPattern(country, identificationType);
        if (govIdpattern && govIdpattern.maxLength) {
            return govIdpattern.maxLength;
        } else {
            return '';
        }
    }
    getMaskedValue(value: string): string {
        return 'XXX-XX-' + value.substr(-4);
    }
    updateActivityLogForGovernmentIdentifications(governmentIdForm: any, memberGovernmentIdentifiations: any[], memberid: number) {
        const activityLogKeys: ActivityLogKey[] = [];
        memberGovernmentIdentifiations.filter(x => x.id);
        governmentIdForm.govermentIdentification.forEach(item => {
            if (!item.id) {
                const activityvalue = ' for ' + this.getMemberAllowedCountryName(item.governmentIdType.countryID) + ' ' + item.governmentIdType.identificationType + ' is created to ' + this.getMaskedValue(item.governmentIdValue);
                activityLogKeys.push({
                    key: MemberActivityLogType.GovernmentID_Created,
                    value: activityvalue
                });

            } if (item.id) {
                const memberidentity = memberGovernmentIdentifiations.find(memberidentity => memberidentity.id === item.id);
                if (memberidentity && memberidentity.value != item.governmentIdValue) {
                    const activityvalue = ' for ' + this.getMemberAllowedCountryName(memberidentity.countryID) + ' ' + memberidentity.governmentIdentificationType + ' is updated to ' + this.getMaskedValue(item.governmentIdValue);
                    activityLogKeys.push({
                        key: MemberActivityLogType.GovernmentID_Updated,
                        value: activityvalue

                    });
                }
            }
        });
        let deletedGovernmentIdList = memberGovernmentIdentifiations.filter((elem) => !governmentIdForm.govermentIdentification.find(({ id }) => elem.id === id));
        deletedGovernmentIdList.forEach(deletedGovernmentId => {
            const activityvalue = ' for ' + this.getMemberAllowedCountryName(deletedGovernmentId.countryID) + ' ' + deletedGovernmentId.governmentIdentificationType + ' is removed to ' + this.getMaskedValue(deletedGovernmentId.value);
            activityLogKeys.push({
                key: MemberActivityLogType.GovernmentID_Deleted,
                value: activityvalue
            });
        }

        );
        if (activityLogKeys && activityLogKeys.length) {
            this._commonService.saveMemberActivity(memberid, activityLogKeys)
                .subscribe(res => { }, (error: any) => { });
        }

    }

    getMemberAllowedCountryName(countryId: number): string {
        if (countryId) {
            const selectedCountry = this.countries.find(country => country.countryId === countryId);
            return selectedCountry.name;
        }
    }


    /**
     * on change of Ach
     */
    openPayByCheckAccountModal(achDetails: PersonalAch, isNewAch: boolean) {
        if (isNewAch) {
            this.isEditEcheck = false;
            this.editEcheckInfo = null;
            this.addNewAchCard = true;
            this.achPaymentPopup.open();
        }
    }
    /**
     * @description submit ach payment information
     * @memberof ACHComponent
   */
    closeAchPaymentPopup(achPaymentInfo) {
        if (achPaymentInfo) {
            this.achPaymentInfo = achPaymentInfo;
            this.achToken = this.achPaymentInfo.personalCheckId;
            this.achPaymentPopup.close();
            this.getMemberPaymentDetails(this.achPaymentInfo.customerId);
        }
    }
    onPaymentAchFormClose() {
        this.addNewAchCard = false;
        this.achPaymentPopup.close();
    }
    enableAuthFormReceiving(form: boolean, id: number) {
        if (this.distributorDefaultECheckPaymentInfo && this.distributorDefaultECheckPaymentInfo.length) {
            this.distributorDefaultECheckPaymentInfo.forEach(item => {
                if (item && item.id === id) {
                    this._customerService.verifyPersonalCheck(item.customerId, item.id, form)
                        .subscribe((response) => {
                            if (response) {
                            }
                        },
                            (error) => { });
                }
            });
        }

    }

    fetchEcheckSecTypes(secType: string): string {
        if (secType === 'WEB') {
            return 'WEB ACH'
        } else {
            return 'PPD ACH'
        }
    }

    /**
     * check agent allowed to change sponsor
     * @date 2021-02-23
     * @memberof FBOProfileComponent
     */
    getChangeSponsorPermission() {
        if (this.changeGeneralSponsorPermission) {
            this.isAgentAllowedToChangeSponsor = false;
            if (!this.userInfo.hasSystemRole) {
                if (this.userInfo.allowedOperatingCountries) {
                    this._customerservice.getOperatingCountries().subscribe((response) => {
                        if (response) {
                            const countryIds = this.userInfo.allowedOperatingCountries.split(',');
                            let countries = response.filter(function (item) {
                                return countryIds.indexOf(item.id.toString()) > -1;
                            });
                            for (let i = 0; i < countries.length; i++) {
                                if (countries[i].value === this.fboProfileDetail.operatingCountryCode) {
                                    this.isAgentAllowedToChangeSponsor = true;
                                    break;
                                }
                            }
                        }
                    });
                } else {
                    this.isAgentAllowedToChangeSponsor = false;
                }
            } else {
                this.isAgentAllowedToChangeSponsor = true;
            }
        }
    }

    /**
     * get sponsor detail by memberID
     * @date 2021-02-23
     * @memberof FBOProfileComponent
     */
    getSponsorDetails(memberId: number) {
        this.sponsorDetails = [];
        this._sponsorService.getSponsorDetailsByMemberID(memberId).subscribe(response => {
            if (response && response.length) {
                for (const sponsor of response) {
                    sponsor.storeCountryName = this.mapSponsorCountry(sponsor.storeCountryCode);
                }
                this.sponsorDetails = response;
            }
        }, (error) => {
            // No Sponsor message
        });
    }

    /**
     * Map sponsor country name based on country code
     * @date 2021-02-23
     * @memberof FBOProfileComponent
     */
    mapSponsorCountry(countryCode: string): string {
        if (this.countries) {
            const countryInfo = this.countries.find(country => country.isocodeThree && countryCode && country.isocodeThree.toLowerCase() === countryCode.toLowerCase());
            return countryInfo ? countryInfo.name : countryCode;
        }
        return countryCode;
    }

    /**
     * map list of countries to string
     * @date 2021-02-23
     * @memberof FBOProfileComponent
     */
    mapChangeSponsorCountries(): string {
        if (this.sponsorDetails && this.sponsorDetails.length) {
            const sponsorChangeCountryInfo = this.sponsorDetails.map(sponsor => sponsor.storeCountryName);
            return sponsorChangeCountryInfo.join(', ');
        }
    }

    /**
     * on submit sponsor change
     * @date 2021-02-23
     * @memberof FBOProfileComponent
     */
    onSubmitSponsorChange(isValidForm: boolean) {
        this.errorCodes = [];
        if (isValidForm) {
            if (this.changeSponsorForm && this.changeSponsorForm.controls['sponsorType'].value === SponsorType.General_Sponsor_Change) {
                const sponsorSearchRequest: SponsorSearchRequest = this.prepareSponsorSearchRequest();
                this._sponsorService.searchSponsors(sponsorSearchRequest).subscribe((sponsorSearchResponse: SponsorSearchResponse) => {
                    if (sponsorSearchResponse.requestStatus === ResponseStatus.COMPLETED) {
                        this.memberSponsorUpdate(sponsorSearchResponse);
                    } else if (sponsorSearchResponse.requestStatus === ResponseStatus.QUEUED ||
                        sponsorSearchResponse.requestStatus === ResponseStatus.IN_PROGRESS) {
                        setTimeout(() => {
                            this.searchSponsorByPolling(sponsorSearchResponse, SponsorSearchOption.SearchByIKnowSponsor);
                        }, 2000);
                    } else {
                        this.sponsorChangeError = true;
                    }
                }, (error) => {
                    if (error.validations && error.validations.length > 0 && error.validations[0].message === 'FBO not found') {
                        this.sponsorNotFoundError = true;
                    } else {
                        this.sponsorChangeError = true;
                    }
                });
            }
        }
    }

    /**
     * Update member sponsor
     * @date 2021-02-23
     * @memberof FBOProfileComponent
     */
    memberSponsorUpdate(sponsorSearchResponse: SponsorSearchResponse) {
        const sponsorChangeRequest: SponsorChangeRequest = this.prepareSponsorChangeRequest(sponsorSearchResponse);
        if (sponsorChangeRequest) {
            this._customerService.updateMemberSponsor(sponsorChangeRequest).subscribe(response => {
                if (response.success) {
                    this.saveSponsorChangeActivityLog();
                    this.newSponsor = sponsorSearchResponse.sponsorSearchResultModels[0];
                    this.sponsorChangeSuccess = true;
                    this.getFBOProfileInfoFromTitan();
                } else {
                    this.sponsorChangeError = true;
                }
            }, (error) => {
                this.sponsorChangeError = true;
            });
        }
    }

    /**
     * Search sponsor by UUID
     * @date 2021-02-23
     * @memberof FBOProfileComponent
     */
    private searchSponsorByPolling(searchResponse: SponsorSearchResponse, searchOption?: number): void {
        this.clearSponsorErrorMsg();
        this._sponsorService.getSearchSponsorsByUUID(searchResponse).subscribe((sponsorSearchResponse: SponsorSearchResponse) => {
            if (sponsorSearchResponse) {
                if (this.sponsorPollCount < this.sponsorMaxPollCount) {
                    this.sponsorPollCount = this.sponsorPollCount + 1;
                    if (sponsorSearchResponse.requestStatus === ResponseStatus.COMPLETED) {
                        this.memberSponsorUpdate(sponsorSearchResponse);
                    } else if (sponsorSearchResponse.requestStatus === ResponseStatus.QUEUED || sponsorSearchResponse.requestStatus === ResponseStatus.IN_PROGRESS) {
                        setTimeout(() => {
                            this.searchSponsorByPolling(sponsorSearchResponse, searchOption);
                        }, 2000);
                    } else {
                        this.sponsorChangeError = true;
                    }
                } else {
                    this.sponsorChangeError = true;
                }
            }
        }, (error) => {
            if (error.validations && error.validations.length > 0 && error.validations[0].message === 'FBO not found') {
                this.sponsorNotFoundError = true;
            } else {
                this.sponsorChangeError = true;
            }
        });
    }

    /**
     * Prepare sponsor change search request
     * @date 2021-02-23
     * @memberof FBOProfileComponent
     */
    prepareSponsorSearchRequest(): SponsorSearchRequest {
        return {
            UserName: this.changeSponsorForm.controls['newSponsorId'].value.trim(),
            Email: '',
            FirstName: '',
            LastName: '',
            CountryId: '',
            PreferenceValue: '',
            PostalCode: '',
            StateId: '',
            City: '',
            Option: SponsorSearchOption.SearchByIKnowSponsor,
            EnableLongPoll: environment.enableLongPoll,
            Store: this.fboProfileDetail.homeCountryCode
        };
    }

    /**
     * prepare sponsor change request object
     * @date 2021-02-23
     * @memberof FBOProfileComponent
     */
    prepareSponsorChangeRequest(sponsorSearchResponse: SponsorSearchResponse): SponsorChangeRequest {
        if (sponsorSearchResponse.sponsorSearchResultModels && sponsorSearchResponse.sponsorSearchResultModels.length > 0) {
            return {
                memberHomeCountry: this.fboProfileDetail.homeCountryCode,
                changeSponsorType: SponsorChangeType.GENERALSPONSOR,
                language: this.fboProfileDetail.preferredLanguage,
                email: sponsorSearchResponse.sponsorSearchResultModels[0].sponsorEmail,
                contactPhone: sponsorSearchResponse.sponsorSearchResultModels[0].sponsorPhone,
                sponsorId: this.changeSponsorForm.controls['newSponsorId'].value,
                distributorId: this.fboProfileDetail.distributorId,
                memberId: this.fboProfileDetail.id,
                sponsorName: sponsorSearchResponse.sponsorSearchResultModels[0].sponsorName,
                updatedBy: this.userInfo.userId,
                addressLine1: sponsorSearchResponse.sponsorSearchResultModels[0].sponsorAddressLine1,
                addressLine2: sponsorSearchResponse.sponsorSearchResultModels[0].sponsorAddressLine2,
                city: sponsorSearchResponse.sponsorSearchResultModels[0].sponsorCity,
                stateId: sponsorSearchResponse.sponsorSearchResultModels[0].sponsorStateId,
                countryId: sponsorSearchResponse.sponsorSearchResultModels[0].sponsorCountryId,
                postalCode: sponsorSearchResponse.sponsorSearchResultModels[0].sponsorPostalCode,
                uuid: sponsorSearchResponse.uuid
            };
        }
        return null;
    }

    /**
     * save sponsor change member activity
     * @date 2021-02-23
     * @memberof FBOProfileComponent
     */
    saveSponsorChangeActivityLog(): void {
        const activityLogKeys: ActivityLogKey[] = [];
        activityLogKeys.push({
            key: MemberActivityLogType.Sponsor_Update,
            value: this.fboProfileDetail.sponsorDetails.fboId + ' to ' + this.changeSponsorForm.controls['newSponsorId'].value
        });
        this._commonService.saveMemberActivity(this.fboProfileDetail.id, activityLogKeys).subscribe();
    }

    /**
     * Method to close sponsor change popup
     * @date 2021-02-23
     * @memberof FBOProfileComponent
     */
    closeSponsorPopUp() {
        this.sponsorDetails = [];
        this.changeSponsorPopup.close();
        this.clearSponsorErrorMsg();
    }

    /**
     * Method to clear change sponsor properties
     * @date 2021-02-23
     * @memberof FBOProfileComponent
     */
    clearSponsorErrorMsg() {
        this.sponsorChangeSuccess = false;
        this.sponsorChangeError = false;
        this.sponsorNotFoundError = false;
    }
    /**
     * Scroll the popup to Top on Open Compose Email popup
     */
    onComposeEmailPopupOpen(): void {

        setTimeout(() => {
            const modalElement = document.getElementsByClassName('draft-email__modal modalwidth');
            if (modalElement && modalElement.length > 0) {
                const childModalElement = modalElement[0].getElementsByClassName('modal in fade');
                if (childModalElement && childModalElement.length > 0) {
                    childModalElement[0].scrollTop = 0;
                }
            }
        }, 0);
    }

    /**
     * To Close Email Popup
     */
    closeComposeEmailPopup(): void {
        this.composeEmailPopup.close();
        this.composeEmailForm = null;
    }

    /**
     * To Set default value when open email popup
     */
    showComposeEmailPopup(): void {
        let operatingCountryCode = IsoCodeThree.USA
        if (operatingCountryCode && this.emailSignatureResponse && this.emailSignatureResponse.length > 0) {
            this.signatureValue = this._customerService.getSignatureValue(operatingCountryCode, this.emailSignatureResponse);
        }
        this.composeEmailPopup.closeOnOutsideClick = true;
        this.composeEmailPopup.closeOnEscape = false;
        this.showErrorMsg = false;
        this.showEmailErrorMessage = false;
        this.showMaxFileSizeValidation = false;
        this.getTicketStatuses();
        this.createComposeEmailForm();
        this.getOperatingCountries();
        this.composeEmailPopup.open();
    }

    /**
     * To Close Email Popup
     */
    onComposeEmailPopupClose(): void {
        this.composeEmailForm = null;
    }

    /**
     * To Get Allowed Countries
     */
    getAllowedCountries() {
        let countryIds: any = [];
        if (!this.userInfo.hasSystemRole) {
            if (this.userInfo.allowedOperatingCountries) {
                countryIds = this.userInfo.allowedOperatingCountries.split(",");
                if (this.userInfo.privileges.departments) {
                    countryIds.push.apply(countryIds, this.userInfo.privileges.departments.map(function (a) { return a.allowedOperatingCountries; }));
                }
                countryIds = countryIds ? countryIds : [];
                if (countryIds.length > 0) {
                    var ids = countryIds;
                    this.operatingCountries = this.businessEntities.filter(function (item) {
                        return ids.indexOf(item.id + "") != -1;
                    });
                }
            }
            else {
                this.operatingCountries = this.businessEntities;
            }
        } else {
            this.operatingCountries = this.businessEntities;
        }
        this.operatingCountries.sort(function (item1, item2) {
            const country1 = item1.name.toLowerCase(), country2 = item2.name.toLowerCase();
            if (country1 < country2) {
                return -1;
            }
            if (country1 > country2) {
                return 1;
            }
            return 0;
        });
        const usaInfo = this.operatingCountries.find((country: any) => country.id === OperatingCountryEnums.USA);
        if (usaInfo) {
            this.operatingCountries.splice(this.countries.indexOf(usaInfo), 1);
            this.operatingCountries.splice(0, 0, usaInfo);
        }
        this.composeEmailForm.controls['operatingCountry'].setValue(this.operatingCountries[0].id);
        this.getDepartmentDetails(this.operatingCountries[0].id);
        this.getTicketTypesAndSubTypes();
    }

    /**
     * To Get Allowed Operating Countries
     */
    getOperatingCountries() {
        this._customerservice.getAllBusinessEntities().subscribe((response: any) => {
            if (response) {
                this.businessEntities = response;
                this.getAllowedCountries();
            }
        });
    }

    /**
     * On Tags Change
     */
    onTagsChange(value: string): void {
        if (value && !this.composeEmailForm.controls['toAddress'].value.length) {
            this.showToAddressValidation = false;
        } else {
            this.showToAddressValidation = true;
        }
    }

    /**
     * To Change From Address And Update Email Id Dynamically
     */
    changeFromAddress(mailId): void {

        const departmentInfo = mailId && this.departments && this.departments.length > 0
            ? this.departments.find(department => department.id === +mailId) : null;

        if (departmentInfo) {
            this.changeSignatureByOperatingCountry(departmentInfo.operatingCountryId, departmentInfo.name.toLowerCase().includes(Department.SMILE_TEAM_360.toLowerCase()));
        }
        const emailId = departmentInfo && this.departments && this.departments.length > 0
            ? departmentInfo.email : mailId;
        const editorElement: any = document.querySelector('#ckeditor-js .ck-editor__editable');
        let editordata = editorElement.ckeditorInstance.getData();
        const emailElement = editorElement.querySelector('#emailId');
        if (emailId) {
            if (emailElement) {
                emailElement.innerHTML = emailId;
                editorElement.ckeditorInstance.setData(editorElement.innerHTML);
                this.composeEmailForm.controls['body'].setValue(editorElement.innerHTML);
            } else {
                const siteElement = editorElement.lastElementChild;
                if (siteElement.innerHTML.indexOf(CommonConstant.EmailSignature) > -1) {
                    const content = siteElement.outerHTML;
                    editordata = editordata.split(content).join('<p id="emailId">' + emailId + '</p>' + content);
                    editorElement.ckeditorInstance.setData(editorElement.innerHTML);
                } else {
                    editordata = editordata + '<p id="emailId">' + emailId + '</p>';
                    editorElement.ckeditorInstance.setData(editordata);
                }
                this.composeEmailForm.controls['body'].setValue(editorElement.innerHTML);

            }
        }

    }

    /**
     * To Create Compose Email Form
     */
    private createComposeEmailForm(): void {
        this.prepareEmailBodyContent();
        this.uploader.queue = [];
        this.composeEmailForm = this._formbuilder.group({
            operatingCountry: ['', Validators.required],
            fromAddress: ['', [Validators.required]],
            toAddress: [[], [Validators.required]],
            subject: ['', [Validators.required, Validators.maxLength(this.subjectMaxLength.maxLength)]],
            ccAddress: [[]],
            bccAddress: [[]],
            statusId: [Status.Closed, Validators.required],
            ticketType: ['', Validators.required],
            subType: ['', Validators.required],
            assignedToMyself: [],
            body: [this.bodyStr]
        });
        if (this.fboProfileDetail && (this.fboProfileDetail.emailId || this.fboProfileDetail.email)) {
            this.composeEmailForm.controls['toAddress'].setValue([{
                display: this.fboProfileDetail.emailId ? this.fboProfileDetail.emailId : this.fboProfileDetail.email,
                value: this.fboProfileDetail.emailId ? this.fboProfileDetail.emailId : this.fboProfileDetail.email
            }]);
        }
        this.composeEmailForm.controls['subject'].markAsTouched();
    }

    /**
     * get ticket status for populating to dropdown
     */
    getTicketStatuses() {
        this._customerservice.getTicketStatus().subscribe((response) => {
            if (response && response.length > 0) {
                this.statuses = sortBy(response, 'value');
            } else {
                this.statuses = [];
            }
        });
    }

    /**
     * To prepare email body content for compose email
     */
    private prepareEmailBodyContent(): void {
        let fboDetails = '';
        if (this.fboProfileDetail) {
            let fboId = this.distributorFormatPipe
                .transform((this.fboProfileDetail.distributorId ?
                    this.fboProfileDetail.distributorId : this.fboProfileDetail.fboId));
            fboId = (this.fboProfileDetail.memberType !== MemberType.GUEST ? (' | ' + fboId) : ' ');
            fboDetails = (this.fboProfileDetail.firstName + ' ') + (this.fboProfileDetail.displayMiddleName && this.fboProfileDetail.middleName ?
                this.fboProfileDetail.middleName + ' ': '')  + this.fboProfileDetail.lastName;
                + fboId + (this.fboProfileDetail.memberType
                    ? (' | ' + (this.fboProfileDetail.level ? this.fboProfileDetail.level : this.fboProfileDetail.memberType)) : '');
        } else {
            fboDetails = 'NA';
        }
        if (this.signatureValue && this.signatureValue.length > 0) {
            this.bodyStr = `<div>
            <p></p>
            </div> `
                + '<div class="emailbody"><strong>Member: </strong>'
                + fboDetails + '</div>'
                + '<div class="emailbody"><strong>Email: </strong>'
                + (this.fboProfileDetail && (this.fboProfileDetail.email || this.fboProfileDetail.emailId)
                    ? (this.fboProfileDetail.email ? this.fboProfileDetail.email : this.fboProfileDetail.emailId) : 'NA') + '</div>'
                + '<p></p>'
                + '<div id="emailsignature">' + this.signatureValue + '</div>';
            const styles = `<style>p,h1,h2,h3,h4{margin:0}</style>`;
            if (this.bodyStr.includes(styles)) {
                this.bodyStr = this.bodyStr.replace(styles, '');
            }
            if (this.bodyStr.includes('<style>')) {
                this.bodyStr = this.bodyStr.replace(/<style>(.|\n)*?<\/style>/g, '');
            } else if (this.bodyStr.includes('&lt;!--') && this.bodyStr.includes('--&gt;')) {
                this.bodyStr = this.bodyStr.replace(/&lt;!--(.|\n)*?--&gt;/, '');
            }
            this.bodyStr = this.bodyStr.replace(/<div[^>]*style="display:none[^>]*>(.|\n)*?<\/div>/, '');
            this.bodyStr = this.bodyStr.replace(/<span[^>]*style="display:none[^>]*>(.*?)<\/span>/, '');
            if (this.bodyStr.includes(`style="mso-margin-top-alt:auto;mso-margin-bottom-alt:auto"`)) {
                // tslint:disable-next-line:max-line-length
                this.bodyStr = this.bodyStr.replace(/<p[^>]*style="mso-margin-top-alt:auto;mso-margin-bottom-alt:auto[^>](.*?)>/, `<p></p><p>`);
            }
        }
    }

    /**
     * To Validate the Attachments
     */
    validateMessageAttachments(): void {
        this.showMaxFileSizeValidation = false;
        if (this.uploader.queue) {
            let totalSize = 0;
            let messageAttachmentSize = 0;
            this.uploader.queue.forEach(item => {
                messageAttachmentSize = messageAttachmentSize + item.file.size;
            });
            totalSize = +(messageAttachmentSize / 1024 / 1024).toFixed(2);
            this.attachmentsLength = this.uploader.queue.length;
            if (totalSize > environment.draftEmailAttachmentsSize) {
                this.uploader.queue[this.uploader.queue.length - 1].remove();
                this.attachmentsLength--;
                this.showMaxFileSizeValidation = true;
            }
            if (this.attachmentsLength >= 5) {
                while (this.attachmentsLength > 5) {
                    this.uploader.queue[this.uploader.queue.length - 1].remove();
                    this.attachmentsLength--;
                }
            }
        }
    }

    /**
     * To Remove the attchments
     */
    removeSize() {
        this.validateMessageAttachments();
    }

    /**
     * To Get department Details
     */
    getDepartmentDetails(id) {
        const isSuperadmin = this.userInfo.hasSystemRole;
        let departmentIds = [];
        if (!isSuperadmin) {
            const departmentData = this.userInfo.privileges.departments;
            if (departmentData && departmentData.length > 0) {
                this.showErrorMsg = false;
                for (let i = 0; i < departmentData.length; i++) {
                    departmentIds.push(departmentData[i].id);
                }
            } else {
                this.showErrorMsg = true;
            }
        }
        if (isSuperadmin || (!isSuperadmin && departmentIds)) {
            this._departmentService.getDepartmentsdataByOperatingCountryId(id).subscribe(response => {
                if (response) {
                    this.departments = response;
                    if (isSuperadmin) {
                        this.departments = response.filter(item => item.email && item.whiteListed);
                    } else {
                        const data = [];
                        for (let i = 0; i < departmentIds.length; i++) {
                            for (let j = 0; j < this.departments.length; j++) {
                                if (departmentIds[i] === this.departments[j].id && this.departments[j].email && this.departments[j].whiteListed) {
                                    data.push(this.departments[j]);
                                }
                            }
                        }
                        this.departments = data;
                    }
                    this.showErrorMsg = this.departments && this.departments.length > 0 ? false : true;
                }
            });
        }
    }

    /**
     * This method used to get users by search text
    */
    setOffsetPosition(positionTimeout: any) {
        clearTimeout(positionTimeout);
        positionTimeout = setTimeout(() => {
            const tagInput: any = document.querySelector('.copy_to__block .ng2-tag-input__text-input');
            const dropdownElement: any = document.querySelector('.copy_to__block .ng2-dropdown-menu');
            if (tagInput) {
                dropdownElement.style.left = (12 + tagInput.offsetLeft) + 'px';
            }
        }, 0);
    }

    /**
     * To Submit Email Form
     */
    onSubmit(isValid: boolean, formValue: any): void {
        this.isSendingEmail = true;
        this.getCkeditorData(isValid, formValue);
    }

    /**
     * Will get the data from ckEditorInstance
     */
    getCkeditorData(isValid: boolean, formValue: any) {
        const editor: any = document.querySelector('#ckeditor-js .ck-editor__editable');
        this.uploadedImageLength = 0;
        this.uploadedImageUrlArr = [];
        if (editor) {
            let contentDiv = document.querySelector('#ckeditor-content');
            contentDiv.innerHTML = (editor.ckeditorInstance.getData());
                let elements: any = document.querySelectorAll('#ckeditor-content')[0].getElementsByClassName('image');
                if (elements && elements.length > 0) {
                  for (let element of elements) {

                    if (element && element.nodeName === 'FIGURE') {
                        if (element && element.attributes && element.attributes.style && element.attributes.style.value) {
                            let width = element.attributes.style.value.replace('width:', '');
                            if (element.firstChild && element.firstChild.nodeName === 'IMG') {
                                element.firstChild.setAttribute('width', width);
                                element.removeAttribute('style');
                                if (element.firstChild.attributes.src.value.split(',')[0].indexOf('base64') >= 0) {
                                    this.dataURItoBlob(isValid, formValue, element);
                                    this.uploadedImageLength++;
                                }
                            }
                        }
                        else {
                            if (element && element.firstChild && element.firstChild.nodeName === 'IMG') {
                                if (element.firstChild.attributes.src.value.split(',')[0].indexOf('base64') >= 0) {
                                    this.dataURItoBlob(isValid, formValue, element);
                                    this.uploadedImageLength++;
                                }
                            }
                        }
                    }
                }
            }
            this.bodyStr = document.querySelector('#ckeditor-content').innerHTML;
            this.composeEmailForm.controls['body'].setValue(this.bodyStr);
        }
        if (this.uploadedImageLength === 0) {
            this.onSubmitComplete(isValid, formValue);
        }
    }

    /**
     * To Conversion
     */
    dataURItoBlob(isValid: boolean, formValue: any, element: any) {
        let byteString;
        let fileName = 'image_' + Date.now();
        let dataURI = element.firstChild.attributes.src.value;
        if (dataURI.split(',')[0].indexOf('base64') >= 0)
            byteString = atob(dataURI.split(',')[1]);
        else
            byteString = decodeURI(dataURI.split(',')[1]);

        // separate out the mime component
        let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        let ia = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        let blob = new Blob([ia], { type: mimeString });
        var formData: any = new FormData(document.forms[0]);

        const file = new File([blob], fileName);
        formData.append("file", file);
        formData.append("fileName", fileName);
        formData.append("path", 'content/customer-service/' + this._id + '/images/');
        this._customerservice.uploadImageFile(formData)
            .subscribe((response: any) => {
                if (response) {
                    element.firstChild.attributes.src.value = response.signedUrl;
                    this.uploadedImageUrlArr.push(response.key);
                    if (this.uploadedImageLength === this.uploadedImageUrlArr.length) {
                        this.onSubmitComplete(isValid, formValue);
                    }
                }
            });
    }

    /**
     * Upload file
     */
    uploadFile() {
        if (this.uploader && this.uploader.queue.length > 0) {
            this.ngProgress.start();
            let filelength = 0;
            const fboId = this._id;
            this.uploader.onBuildItemForm = (item: any, form: any) => {
                filelength++;
                item.withCredentials = false;
                item.uploader.authToken = this._customerservice.getAuthorizationToken();
                const fileNameArr = item.file.name.split('.');
                const filename = fileNameArr[0].replace(/[&\/\\#,+()$~%'":*?@!$^*;<>{}/ +(?= )]/g, '');
                item.file.name = filename + '_' + fboId + '_' + filelength
                    + (fileNameArr.length > 1 ? '.' + fileNameArr[fileNameArr.length - 1] : '');
                form.append('fileName', decodeURIComponent(encodeURIComponent(item.file.name)));
                form.append('path', 'content/customer-service/' + this._id + '/');
            };
            for (let i = 0; i < this.uploader.queue.length; i++) {
                this.uploader.queue[i].upload();
            }
        }
    }

    /**
     * To Map Input Values
     */
    private mapTagInputValue(tagInputValue: TagInputValue[]): string[] {
        if (tagInputValue && tagInputValue.length > 0) {
            return tagInputValue.map(x => {
                return x['value'];
            });
        }
    }

    /**
     * To Submit the form values
     */
    onSubmitComplete(isValid: boolean, formValue: any): void {
        this.bodyStr = document.querySelector('#ckeditor-content').innerHTML;
        this.composeEmailForm.controls['body'].setValue(this.bodyStr);
        this.bodyStr = this.bodyStr.replace(/<p>&nbsp;<\/p>/gi, '');
        this.bodyStr = this.bodyStr.replace(/<h4>&nbsp;<\/h4>/gi, '');
        if (isValid && !this.submitCompleted) {
            const departmentInfo = formValue && formValue.fromAddress && this.departments && this.departments.length > 0
                ? this.departments.find(department => department.id === +formValue.fromAddress) : null;
            this.composeEmailRequest = {
                messageModel: {
                    from: departmentInfo ? departmentInfo.email : '',
                    to: this.mapTagInputValue(formValue.toAddress),
                    cc: this.mapTagInputValue(formValue.ccAddress),
                    bcc: this.mapTagInputValue(formValue.bccAddress),
                    subject: formValue && formValue.subject ? formValue.subject : '',
                    mailBody: this.bodyStr,
                    attachments: null,
                },
                ticketModel: {
                    sourceId: this.sourceTypesEnum.Email,
                    callerName: this.userInfo.firstName + ' ' + this.userInfo.lastName,
                    operatingCountryId: formValue.operatingCountry,
                    typeId: formValue.ticketType,
                    subTypeId: formValue.subType,
                    description: this.bodyStr,
                    departmentId: departmentInfo ? departmentInfo.id : null,
                    priorityId: (departmentInfo.name.toLowerCase().indexOf(Department.KEY.toLowerCase()) > -1
                        && formValue.operatingCountry == OperatingCountryEnums.SWE) ? Priority.High : Priority.Medium,
                    dueDate: null,
                    subject: formValue.subject,
                    assignedToId: this.userInfo.userId,
                    memberId: this.fboProfileDetail.distributorId ? this.fboProfileDetail.distributorId : "",
                    distributorName: this.fboProfileDetail.name,
                    agentEmail: this.userInfo.email,
                    agentName: this.userInfo.firstName + ' ' + this.userInfo.lastName,
                    ticketLink: window.location.href,
                    countryId: this.fboProfileDetail.homeCountryId ? this.fboProfileDetail.homeCountryId : null,
                    memberType: this.getMemberType(),
                    userId: this.userInfo.userId,
                    firstName: this.userInfo.firstName,
                    lastName: this.userInfo.lastName,
                    sourceIdentifierValue: this.userInfo.email,
                    statusId: formValue.statusId,
                    copyToUsers: []
                }
            };
        }
        if (this.uploader.queue.length > 0) {
            this.uploadFile();
        } else {
            this.sentEmail(this.composeEmailRequest);
        }
    }

    /**
     * To Get member Type
     */
    getMemberType(): string {
        if (this.fboProfileDetail.memberType === MemberType.RETAIL || this.fboProfileDetail.memberType === 'R'
            || this.fboProfileDetail.memberType.toUpperCase() === MemberType.RETAILCUSTOMER) {
            return MemberType.RETAIL;
        } else if (this.fboProfileDetail.memberType === MemberType.GUEST || this.fboProfileDetail.memberType === 'G') {
            return MemberType.GUEST;
        } else if (this.fboProfileDetail.memberType === MemberType.FPC) {
            return MemberType.FPC;
        } else {
            return MemberType.FOB;
        }
    }

    /**
     * To Sent Email & Create Ticket
     */
    sentEmail(composeEmail: ComposeEmail): void {
        this.showEmailErrorMessage = false;
        this.showMaxFileSizeValidation = false;
        this.submitCompleted = true;
        composeEmail.messageModel.mailBody = composeEmail.messageModel.mailBody.replace(/[^\x00-\x7F]/g, '');
        composeEmail.messageModel.mailBody = composeEmail.messageModel.mailBody.replace(/<p><br data-cke-filler="true">(.*?)<\/p>/gi, '');
        composeEmail.messageModel.mailBody = composeEmail.messageModel.mailBody.replace(/<h4><br data-cke-filler="true">(.*?)<\/h4>/gi, '');
        let errorNotification: any = this._translatePipe.get('customer-service.Something went wrong, Please try again after sometime');
        this._customerservice.composeEmailAndCreateTicket(composeEmail)
            .subscribe((response: any) => {
                if (response && response.success) {
                    if (this.uploadResponse && this.uploadResponse.length > 0) {
                        this.saveAttachments(response.ticketModel.id);
                    } else {
                        this.successResponse();
                    }
                } else if (response && response.validations.length > 0) {
                    this.message = response.validations[0].message ? response.validations[0].message : errorNotification.value;
                    this.count = 0;
                    this.composeEmailRequest.messageModel.attachments = [];
                    this.uploadResponse = [];
                    this.showEmailErrorMessage = true;
                    this.isSendingEmail = false;
                } else {
                    let message: any = this._translatePipe.get('customer-service.One or More error occured, while sending email/creating ticket');
                    this.message = message.value;
                    this.count = 0;
                    this.composeEmailRequest.messageModel.attachments = [];
                    this.uploadResponse = [];
                    this.showEmailErrorMessage = true;
                    this.isSendingEmail = false;
                }
                this.submitCompleted = false;
            }, (error) => {
                this.message = errorNotification.value;
                this.count = 0;
                this.composeEmailRequest.messageModel.attachments = [];
                this.uploadResponse = [];
                this.showEmailErrorMessage = true;
                this.isSendingEmail = false;
                this.submitCompleted = false;
            });
    }

    /**
     * To Success Response
     */
    successResponse(isAttachmentUploadError?: boolean, ticketId?: number): void {
        this.isSendingEmail = false;
        this.composeEmailPopup.close();
        this.count = 0;
        let message: any = '';
        this.composeEmailRequest.messageModel.attachments = [];
        this.uploadResponse = [];
        if (isAttachmentUploadError) {
            message = 'Email sent & Ticket created sucessfully, Some error occured while uploading attachments, Please upload by editing the ticket (Ticket#: ' + ticketId + ')';
            this._commonService.createNotification('', this.message, NotificationType.WARN);
        } else {
            message = this._translatePipe.get('customer-service.Email sent & Ticket created sucessfully');
            this._commonService.createNotification('', message.value, NotificationType.SUCCESS);
        }
    }

    /**
     * To save the attachments
     */
    saveAttachments(ticketId: number) {
        if (ticketId) {
            this._customerservice.saveAttachments(this.uploadResponse, ticketId).subscribe(response => {
                if (response) {
                    this.successResponse();
                }
            }, (error) => {
                this.successResponse(true, ticketId);
            });
        }
    }

    /**
     * To Change the operating country
     */
    operatingCountryChange(id: any): void {
        this.composeEmailForm.controls['ticketType'].setValue('');
        this.composeEmailForm.controls['subType'].setValue('');
        this.changeSignatureByOperatingCountry(id);
        this.composeEmailForm.controls['fromAddress'].setValue('');
        this.departments = [];
        this.getDepartmentDetails(id);
        this.getTicketTypesAndSubTypes();
    }

    /**
     * To Get ticket types & sub types
     */
    getTicketTypesAndSubTypes() {
        this.ticketTypes = [];
        this.subTypes = [];
        this.composeEmailForm.controls['ticketType'].setValue('');
        this.composeEmailForm.controls['subType'].setValue('');
        let operatingCountry = this.composeEmailForm.controls['operatingCountry'].value;
        if (operatingCountry) {
            this._departmentService.getTicketTypesAndSubTypes(operatingCountry).subscribe(response => {
                if (response && response.length > 0) {
                    this.ticketTypes = response;
                    this.ticketTypes.forEach(type => {
                        if (type.value) {
                            type.sortValue = type.value.toLowerCase();
                        }
                    });
                }
            });
        }
    }

    /**
     * To Get subtypes
     */
    getSubTypes(event: any) {
        let ticketTypeId = +event;
        this.subTypes = [];
        this.composeEmailForm.controls['subType'].setValue('');
        if (ticketTypeId && this.ticketTypes && this.ticketTypes.length > 0) {
            let types: any[] = JSON.parse(JSON.stringify(this.ticketTypes))
            this.subTypes = types.find(item => item.id === ticketTypeId) ?
                types.find(item => item.id === ticketTypeId).subTypes : [];
        }
    }

    /**
     * Change signature by operating country in compose email screen
     */
    changeSignatureByOperatingCountry(id: number, isSmileTeamTicket?: boolean) {
        this.signatureValue = '';
        const operatingcountry = this.businessEntities.filter(item => item.id == id)[0];
        const operatingCountryCode = isSmileTeamTicket ? IsoCodeThree.USA : operatingcountry["value"];
        if (operatingCountryCode && this.emailSignatureResponse && this.emailSignatureResponse.length > 0) {
            this.signatureValue = this._customerService.getSignatureValue(operatingCountryCode, this.emailSignatureResponse);
        }
        const editorElement: any = document.querySelector('#ckeditor-js .ck-editor__editable');
        const emailElement = editorElement.querySelector('#emailsignature');
        if (this.signatureValue && this.signatureValue.length > 0) {
            if (emailElement) {
                emailElement.innerHTML = this.signatureValue;
                editorElement.ckeditorInstance.setData(editorElement.innerHTML);
                this.composeEmailForm.controls['body'].setValue(editorElement.innerHTML);
            } else {
                let editordata = editorElement.ckeditorInstance.getData();
                editordata = editordata + '<div id="emailsignature">' + this.signatureValue + '</div>';
                editorElement.ckeditorInstance.setData(editorElement.innerHTML);
                this.composeEmailForm.controls['body'].setValue(editorElement.innerHTML);
            }
        }
    }

    isBetaEnabledCountry(homeCountryCode: String): boolean {
        let betaCountries: Array<string> = [];
        let isBetaEnabledCountry = false;
        if (environment.betaEnabledCountries && environment.betaEnabledCountries.length) {
            betaCountries = environment.betaEnabledCountries.toLowerCase().split(',');
        }
        if (homeCountryCode && betaCountries) {
            if (betaCountries.includes(homeCountryCode.toLowerCase())) {
                isBetaEnabledCountry = true;
            }
        }
        return isBetaEnabledCountry;
    }


    displayErrorMessage(distributorId: string): void {
        const translatedContent: any = this._translatePipe.get('customer-service.Invalid FBO');
        const errorMessage = translatedContent.value + ' ' + '(' + distributorId + ')';
        this._commonService.createNotification('', errorMessage, NotificationType.ERROR);
    }

    getCustomBankTypeSelectOption(): void {
        this.customSelectSubscription = this._messageService.getBankTypeChange()
            .subscribe((bankCode: string) => {
                if (!this.memberBonusInfo || (this.memberBonusInfo && this.memberBonusInfo.bankCode && this.memberBonusInfo.bankCode.toLowerCase() !== bankCode.toLowerCase())) {
                    this.preloadMemberBonusInfo = null;
                }
            });
    }

    openUpdateBonusInfoModal() {
        this._personalMessageService.setValidBonusInfoForm(true);
        this._personalMessageService.setPreviousBonusInfo(this.memberBonusInfo);
        this._configurationService.setBonusInfoCountry(this.homeCountry);
        this._configurationService.setEnrollCountry(this.homeCountry);
        this.validBonusInfo = true;
        if (this.showSingleAndDirectDebitMenu) {
            this.fetchTermsConditionDocument();
            this.disableBonusInfoChecks = true;
            this.isCreditAssessmentEnabled = this.memberBonusInfo && this.memberBonusInfo.creditAssessmentEnabled ? this.memberBonusInfo.creditAssessmentEnabled : false;
            this.isSingleDebitEnabled = this.memberBonusInfo && this.memberBonusInfo.singleDebitEnabled ? this.memberBonusInfo.singleDebitEnabled : false;
            this.isDirectDebitEnabled = this.memberBonusInfo && this.memberBonusInfo.directDebitEnabled ? this.memberBonusInfo.directDebitEnabled : false;
            this.blxBonusInformationModalPopup.open();
        } else {
            this.bonusInformationPopup.open();
        }
        this.isDeleteBonusInfo = false;
        this.editBonusInfo = false;
        this.preloadMemberBonusInfo = this.memberBonusInfo;
        this.getMemberBonusInfo();
        setTimeout(() => {
            this.prepareBonusInfoSchemaForm();
        }, 300);
    }

    closeBonusInformationModal() {
        this.updateOnlyBonusInfoPaymentMethods = false;
        this._personalMessageService.setPreviousBonusInfo(null);
        this._configurationService.setBonusInfoCountry(null);
        this.bonusInfoChanged = false;
        if (this.showSingleAndDirectDebitMenu) {
            this.displayIBANAckError = false;
            this.blxBonusInformationModalPopup.close();
        } else {
            this.bonusInformationPopup.close();
        }
        this.editBonusInfo = false;
        this.isDeleteBonusInfo = false;
        this._personalMessageService.setDisableBonusInfoForm(true);
        this.disableBonusInfoChecks = true;
        this.getMemberBonusInfo();
    }

    deleteBonusInfoConfirmation(status: boolean) {
        if (status) {
            if (this.memberBonusInfo && this.memberBonusInfo.id) {
                this.closeDeleteBonusInfoConfirmation();
                this.isDeleteBonusInfo = true;
                this._personalMessageService.setDisableBonusInfoForm(true);
                this.disableBonusInfoChecks = true;
            }
        } else {
            if (this.memberBonusInfo && this.memberBonusInfo.id) {
                this.openDeleteBonusInfoConfirmation();
            }
        }
    }

    openDeleteBonusInfoConfirmation() {
        this.deleteBonusInfoConfirmationPopup.open();
    }

    closeDeleteBonusInfoConfirmation() {
        this.deleteBonusInfoConfirmationPopup.close();
    }

    deletedBonuInformation(memberId: number) {
        let singleDirectDebitEnabled = false;
        let options;
        const blxCountry = environment.beneluxCountries.split(',').find(countryCode=> countryCode && this.homeCountry && countryCode.toUpperCase() === this.homeCountry.toUpperCase());
        if(this.memberBonusInfo && (this.isCreditAssessmentEnabled || blxCountry)){
            singleDirectDebitEnabled = true;
        }
        if (this.storeInfo && this.userInfo) {
            options = {
                operatingCompany: this.storeInfo.homeIsocodeThree ? this.storeInfo.homeIsocodeThree : null,
                storeCountryId: this.storeInfo.id ? this.storeInfo.id : null,
                updatedBy: this.userInfo.userId ? this.userInfo.userId : null
            }
            if(this.fboProfileDetail){
                options.distributorId = this.fboProfileDetail.distributorId;
            }
        }
        if (memberId) {
            this._customerService.deleteMemberBankDetails(memberId,singleDirectDebitEnabled,FBOProfileUpdateEnum.BONUS_PAY_BANK_DETAILS_CHANGE, options)
                .subscribe((res) => {
                    if (res) {
                        this.memberBonusInfo = null;
                        this.preloadMemberBonusInfo = this.memberBonusInfo;
                        this._commonService.createNotification("", "Bonus information deleted successfully", NotificationType.SUCCESS);
                        this._messageService.setBlxBonusInformation(null);
                        this._personalMessageService.setPreviousBonusInfo(null);
                        this.closeBonusInformationModal();
                    } else {
                        this._commonService.createNotification("", "Bonus information delete failed, Please try again", NotificationType.ERROR);
                    }
                    this.disableBonusButton = true;
                });
        }
    }

    editBonusInformation(memberId: number, bonusId: number) {
        this.editBonusInfo = true;
        this._personalMessageService.setDisableBonusInfoForm(false);
        //this.disableBonusInfoChecks = false;
        this.disableBonusInfoChecks = (this.memberBonusInfo && this.memberBonusInfo.accountNumber) && this.editBonusInfo ? false : true;

    }

    addNewBonusInformation(memberId: number) {
        this.editBonusInfo = true;
    }

    getValidBonusInfoSubscription() {
        this.validBonusInfoSubscription = this._personalMessageService.getValidBonusInfoForm().subscribe(data => {
            this.validBonusInfo = data;
        });
    }
    private getValidIbanInfoSubscription() {
        this.validIbanInfoSubscription = this._personalMessageService.getValidateIbanInfo().subscribe(data => {
            this.invalidIban = data;
        });
    }

    saveBonusInformation(memberId: number, bonusInfo: BonusInfo, isNewAdded?:boolean) {
        let profileUpdateChangedValues = [];
        if (this.memberBonusInfo) {
            if ((bonusInfo.accountNumber ? bonusInfo.accountNumber : "") !== (this.memberBonusInfo.accountNumber ? this.memberBonusInfo.accountNumber : "") ||
                ((bonusInfo.bankName ? bonusInfo.bankName : "") !== (this.memberBonusInfo.bankName ? this.memberBonusInfo.bankName : "")) ||
                ((bonusInfo.checkDigit ? bonusInfo.checkDigit : "") !== (this.memberBonusInfo.checkDigit ? this.memberBonusInfo.checkDigit : "")) ||
                ((bonusInfo.clearingNumber ? bonusInfo.clearingNumber : "") !== (this.memberBonusInfo.clearingNumber ? this.memberBonusInfo.clearingNumber : "")) ||
                ((bonusInfo.accountName ? bonusInfo.accountName : "") !== (this.memberBonusInfo.accountName ? this.memberBonusInfo.accountName : "")) ||
                ((bonusInfo.accountReferenceNumber ? bonusInfo.accountReferenceNumber : "") !== (this.memberBonusInfo.accountReferenceNumber ? this.memberBonusInfo.accountReferenceNumber : "")) ||
                ((bonusInfo.sortCode ? bonusInfo.sortCode : "") !== (this.memberBonusInfo.sortCode ? this.memberBonusInfo.sortCode : ""))) {
                profileUpdateChangedValues.push(FBOProfileUpdateEnum.BONUS_PAY_BANK_DETAILS_CHANGE);
            }
        } else {
            profileUpdateChangedValues.push(FBOProfileUpdateEnum.BONUS_PAY_BANK_DETAILS_CHANGE);
        }
        bonusInfo.countryCode = this.homeCountry;
        bonusInfo.id = this.memberBonusInfo && this.memberBonusInfo.id ? this.memberBonusInfo.id : null;
        bonusInfo.creditAssessmentEnabled = this.isCreditAssessmentEnabled ? this.isCreditAssessmentEnabled : false;
        bonusInfo.singleDebitEnabled = this.isSingleDebitEnabled ? this.isSingleDebitEnabled : false;
        bonusInfo.directDebitEnabled = this.isDirectDebitEnabled ? this.isDirectDebitEnabled : false;
        bonusInfo.createdBy = isNewAdded || bonusInfo.id ? null : this.userInfo.userId;
        bonusInfo.updatedBy = isNewAdded || bonusInfo.id ? this.userInfo.userId : null;
        bonusInfo.changedValueType = profileUpdateChangedValues;
        bonusInfo.storeId = this.storeInfo && this.storeInfo.id ? this.storeInfo.id : null;
        if(this.fboProfileDetail){
            bonusInfo.distributorId = this.fboProfileDetail.distributorId;
        }
        if (this.showSingleAndDirectDebitMenu && !bonusInfo.accountNumber) {
            //bonusInfo.singleDebitEnabled = false;
            bonusInfo.directDebitEnabled = false;
        }
        // other than BLX need to pass NULL for Single and Direct debit
        if (!this.showSingleAndDirectDebitMenu) {
            bonusInfo.singleDebitEnabled = null;
            bonusInfo.directDebitEnabled = null;
        }
        if (this.showSingleAndDirectDebitMenu) {
            if (this.validBonusInfo || this.editSingleAndDirectDebitPayment) {
                this.saveMemberBankDetails(memberId, bonusInfo);
            }
        } else {
            this.saveMemberBankDetails(memberId, bonusInfo);
        }
    }

    saveMemberBankDetails(memberId, bonusInfo) {
        if(this.memberBonusInfo && !this.memberBonusInfo.accountNumber && this.personalInfoSettings && this.personalInfoSettings.enableSingleAndDirectDebit) {
            this.updateMemberBankDetails(memberId, bonusInfo);
        } else {
            this.postMemberBankDetails(memberId, bonusInfo);
        }
    }

    postMemberBankDetails(memberId, bonusInfo){
        this._customerService.saveMemberBankDetails(memberId, bonusInfo)
        .subscribe((res: BonusInfo) => {
            if (res) {
                this.memberBonusInfo = res;
                this.preloadMemberBonusInfo = this.memberBonusInfo;
                this.bonusInfoBankCode = res.bankCode;
                this.isCreditAssessmentEnabled = res.creditAssessmentEnabled;
                this.isDirectDebitEnabled = res.directDebitEnabled;
                this.isSingleDebitEnabled = res.singleDebitEnabled;
                if (this.showSingleAndDirectDebitMenu && this.memberBonusInfo && this.memberBonusInfo.accountNumber) {
                    if (this.bonusInfoAgreements && this.bonusInfoAgreements.length > 0) {
                        this.saveIBANAcknowledgement();
                    }
                }
                if (this.editSingleAndDirectDebitPayment) {
                    this._commonService.createNotification("", "Single and Direct debit information updated successfully", NotificationType.SUCCESS);
                    this.closeSingleAndDirectDebitModal();
                } else {
                    this._commonService.createNotification("", "Bonus information updated successfully", NotificationType.SUCCESS);
                    this.closeBonusInformationModal();
                }
                this.disableBonusButton = true;
            }
        },
            (error) => {
                if (this.editSingleAndDirectDebitPayment) {
                    this._commonService.createNotification("", "Single and Direct debit information update failed, Please try again", NotificationType.ERROR);
                } else {
                    this._commonService.createNotification("", "Bonus information update failed, Please try again", NotificationType.ERROR);
                }
                this.disableBonusButton = true;

            }
        );
    }

    updateMemberBankDetails(memberId, bonusInfo){
        this._customerService.updateMemberBankDetails(memberId, bonusInfo)
        .subscribe((res: BonusInfo) => {
            if (res) {
                this.memberBonusInfo = res;
                this.preloadMemberBonusInfo = this.memberBonusInfo;
                this.bonusInfoBankCode = res.bankCode;
                this.isCreditAssessmentEnabled = res.creditAssessmentEnabled;
                this.isDirectDebitEnabled = res.directDebitEnabled;
                this.isSingleDebitEnabled = res.singleDebitEnabled;
                if (this.showSingleAndDirectDebitMenu && this.memberBonusInfo && this.memberBonusInfo.accountNumber) {
                    if (this.bonusInfoAgreements && this.bonusInfoAgreements.length > 0) {
                        this.saveIBANAcknowledgement();
                    }
                }
                if (this.editSingleAndDirectDebitPayment) {
                    this._commonService.createNotification("", "Single and Direct debit information updated successfully", NotificationType.SUCCESS);
                    this.closeSingleAndDirectDebitModal();
                } else {
                    this._commonService.createNotification("", "Bonus information updated successfully", NotificationType.SUCCESS);
                    this.closeBonusInformationModal();
                }
            }
            this.disableBonusButton = true;
        },
            (error) => {
                if (this.editSingleAndDirectDebitPayment) {
                    this._commonService.createNotification("", "Single and Direct debit information update failed, Please try again", NotificationType.ERROR);
                } else {
                    this._commonService.createNotification("", "Bonus information update failed, Please try again", NotificationType.ERROR);
                }
                this.disableBonusButton = true;
            }
        );
    }

    updateBonusInformation(isNewAdded:boolean) {
        this.disableBonusButton = false;
        if (this.isDeleteBonusInfo) {
            this.deletedBonuInformation(this.fboProfileDetail.memberId);
        } else {
            if (this.showSingleAndDirectDebitMenu) {
                if (this.editSingleAndDirectDebitPayment) {
                    if (this.memberBonusInfo) {
                        this.memberBonusInfo.creditAssessmentEnabled = this.isCreditAssessmentEnabled;
                        this.memberBonusInfo.singleDebitEnabled = this.isSingleDebitEnabled;
                        this.memberBonusInfo.directDebitEnabled = this.isDirectDebitEnabled;
                        this.saveBonusInformation(this.fboProfileDetail.memberId, this.memberBonusInfo,isNewAdded);
                    } else {
                        const bonusInfo: any = {
                            singleDebitEnabled: this.isSingleDebitEnabled,
                            directDebitEnabled: this.isDirectDebitEnabled,
                            creditAssessmentEnabled: this.isCreditAssessmentEnabled
                        }
                        this.saveBonusInformation(this.fboProfileDetail.memberId, bonusInfo,isNewAdded);
                    }
                } else {
                    this.displayIBANAckError = this.validateTandC();
                    if (!this.displayIBANAckError) {
                        if (!this.bonusInfoChanged && this.memberBonusInfo) {
                            this.saveBonusInformation(this.fboProfileDetail.memberId, this.memberBonusInfo,isNewAdded);
                        } else {
                            this._personalMessageService.setSubmitBonusInfoForm(true);
                        }
                    }
                }
            } else {
                this._personalMessageService.setSubmitBonusInfoForm(true);
            }
        }
    }

    getBonusInfo(bonusInformation: BonusInfo) {
        this.liveBonusinformation = bonusInformation;
        if (this.showSingleAndDirectDebitMenu) {
            this.displayIBANAckError = this.validateTandC();
            if (!this.displayIBANAckError && bonusInformation != undefined) {
                this.saveBonusInformation(this.fboProfileDetail.memberId, this.liveBonusinformation);
            }
        } else {
            if (bonusInformation && JSON.stringify(bonusInformation) !== "{}") {
                if (this.liveBonusinformation && this.bonusInfoFormValidated) {
                    this.saveBonusInformation(this.fboProfileDetail.memberId, this.liveBonusinformation);
                }
            }
        }
    }

    validateTandC() {
        let bonusInformation;
        let accountNumber = '';
        this._messageService.accountNumber.subscribe(accountNumber => bonusInformation = accountNumber ? accountNumber : '');
        if (bonusInformation) {
            accountNumber = bonusInformation;
        }

        if (accountNumber !== '') {
            const agreementList = this.bonusInfoAgreements.filter(agreement => agreement.isSelected === false);
            this.displayIBANAckError = (agreementList && agreementList.length === 0) ? false : true;
        } else {
            this.displayIBANAckError = false;
        }
        return this.displayIBANAckError;
    }

    getBonusInfoOnInputChange(bonusInfoFormValidated: boolean) {
        this.bonusInfoFormValidated = bonusInfoFormValidated;
        this.bonusInfoChanged = true;
        let IBANNumber;
        this._messageService.accountNumber.subscribe(accountNumber => {
            IBANNumber = accountNumber ? accountNumber : '';
            this.disableBonusInfoChecks = IBANNumber ? false : true;
            if (IBANNumber) {
                this.displayIBANAckError = false;
            }
        });
    }

    openSingleAndDirectDebitModal() {
        this.getMemberBonusInfo();
        this.isCreditAssessmentEnabled = this.memberBonusInfo ? this.memberBonusInfo.creditAssessmentEnabled : false;
        this.isSingleDebitEnabled = this.memberBonusInfo ? this.memberBonusInfo.singleDebitEnabled : false;
        this.isDirectDebitEnabled = this.memberBonusInfo ? this.memberBonusInfo.directDebitEnabled : false;
        this.singleAndDirectDebitPaymentModal.open();
        this.editSingleAndDirectDebitPayment = true;
    }

    closeSingleAndDirectDebitModal() {
        this.editSingleAndDirectDebitPayment = false;
        this.singleAndDirectDebitPaymentModal.close();
    }
    /**
     *Edit Echeck payment form
     * @memberof FBOProfileComponent
     */
    editEcheck(eCheck: any) {
        if (eCheck) {
            this.editEcheckInfo = eCheck;
            this.isEditEcheck = true;
            this.addNewAchCard = true;
            this.achPaymentPopup.open();
        }
    }

    ngOnDestroy(): void {
        if (this.customSelectSubscription) {
            this.customSelectSubscription.unsubscribe();
        }
        if (this.validBonusInfoSubscription) {
            this.validBonusInfoSubscription.unsubscribe();
        }
        if (this.validIbanInfoSubscription) {
            this.validIbanInfoSubscription.unsubscribe();
        }
    }

    /**
     * Get store level permissions
     */
    getStoreLevelPermissions() {
        this.businessEditEntityPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[15] + ']'), AccessLevel.Store, this.homeStoreId);
        this.businessViewEntityPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[16] + ']'), AccessLevel.Store, this.homeStoreId);

    }

     /**
     * @description onChange Enable Credit Assessment
     * @param event
     */
    onCreditAssessmentChange(event) {
        this.isCreditAssessmentEnabled = event.target.checked;
        if( !this.isCreditAssessmentEnabled ){
            this.isDirectDebitEnabled = false;
            this.isSingleDebitEnabled = false;
        }
    }

    /**
     * @description onChange Enable Direct Debit payment
     * @param event
     */
    onDirectDebitChange(event) {
        this.isDirectDebitEnabled = event.target.checked;
    }

    /**
     * @description onChange Enable Single Debit payment
     * @param event
     */
    onSingleDebitChange(event) {
        this.isSingleDebitEnabled = event.target.checked;
    }


    /**
     * get terms and conditions for bonus information of BLX markets
     */
    fetchTermsConditionDocument(): void {
        let accountLevelId;
        if (this.fboProfileDetail && this.fboProfileDetail.memberRankLevels && this.fboProfileDetail.memberRankLevels.length > 0) {
            this.fboProfileDetail.memberRankLevels.forEach(x => {
                accountLevelId = x.accountLevelId ? x.accountLevelId : null;
            });
        }
        this._documentService.getDocuments(Portal.Csp,
            accountLevelId, DisplaySectionId.Member_Info, this.fboProfileDetail.homeCountryCode, this.languagecode)
            .subscribe((response) => {
                if (response && response.length > 0 && response[0].body && response[0].body.length > 0) {
                    this.bonusInfoAgreements = response[0].body;
                    this.bonusInfoAgreements.forEach((agreement: any) =>
                        agreement.isSelected = this.memberBonusInfo && this.memberBonusInfo.accountNumber ? true : false
                    );
                } else {
                    this.bonusInfoAgreements = [];
                }
            }, (error: any) => {
                const notification: any = this._translatePipe.get('order.Unable to fetch Agreement Details');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            });
    }

    selectedAgreements(agreement: DocumentLibrary) {
        const agreementObj = this.bonusInfoAgreements.find(agreement => agreement.documentLibraryId === agreement.documentLibraryId);
        if (agreementObj) {
            agreementObj.isSelected = !agreementObj.isSelected;
            if (agreementObj.isSelected) {
                this.displayIBANAckError = false;
            }
        }
    }

    saveIBANAcknowledgement() {
        this._documentService.updateAcknowledgedDocuments(
            this.bonusInfoAgreements[0], this.fboProfileDetail.memberTypeId, this.fboProfileDetail.memberId).subscribe();
    }

    getCountryDisableStatus(governmentIdentification: any): null | boolean {
        if (this.isEditGovId) {
            return null;
        } else {
            const countries = ['BEL', 'LUX', 'NLD'];
            if (governmentIdentification && governmentIdentification.id && governmentIdentification.country) {
                const index = countries.findIndex((el) => el && el == governmentIdentification.country);
                if (index > -1) {
                    return true;
                }
            }
            return null;
        }
    }

    /**
     * @description To get email siganture for operating countries
     * @returns void
    */

    getEmailSignature(): void {
        this._customerservice.getEmailSignatures().subscribe(res => {
            if (res && res.length > 0) {
                this.emailSignatureResponse = res;
            }
            else {
                this.emailSignatureResponse = [];
            }
        }, (error) => {
            this.emailSignatureResponse = [];
        });

    }

    openRetailSubscriptionModal(): void {
        if (this.languages.length === 0) {
            this.getChargeBeeLanguages();
        }
        this.getChargeBeeConfiguration();
        if (this.memberRetailSubscriptionDetail && this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel && this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.id) {

            this.getRetailSubscriptionsById(this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.id);
        }
        if (this.memberRetailSubscriptionId && this.memberRetailSubscriptionDetail) {

            this.getRetailSubscriptionPlan(this.memberRetailSubscriptionDetail.appPlanMapperId);
        }
        else {
            if (this.fboProfileDetail && this.fboProfileDetail.retailSubscriptionModel && this.fboProfileDetail.retailSubscriptionModel.chargeBeePlanId) {
                this.getRetailSubscriptionPlan(this.fboProfileDetail.retailSubscriptionModel.chargeBeePlanId);
            }
            else {
                this.prepareRetailSubscriptionForm();
                this.buildRetailSubscritionForm();
            }
        }
    }
    openCancelRenewalModal(): void {
        this.cancelRenewalPopup.open();
    }
    openCancelSubscriptionModal(): void {
        this.cancelSubscriptionPopup.open();
    }
    closeCancelRenewalSubscriptionModal(): void {
        this.cancelRenewalPopup.close();
    }

    closeCancelSubscriptionModal(): void {
        this.cancelSubscriptionPopup.close();
    }

    closePopUpforRetailSubscription(): void {
        this.retailSubscriptionPopup.close();
    }
    resubscription(): void {
        this.isResubscribe = true;
        this.isRetailSubscriptionLogin = false;
        this.prepareRetailSubscriptionForm();
        this.buildRetailSubscritionForm();

    }

    onSubmitRetailForm(isValidForm: boolean): void {
        this.isRetailFormSubmitted = true;
        if (isValidForm) {
            if (this.memberRetailSubscriptionId > 0 && this.isResubscribe === false) {
                const memberRetailProgramSubscriptionModel: MemberRetailProgramSubscriptionModel = this.prepareUpdateRetailSubscriptionModel();
                if (memberRetailProgramSubscriptionModel) {
                    this._retailSubscriptionService.updateRetailSubscription(memberRetailProgramSubscriptionModel).subscribe(
                        (response: any) => {
                            if (response && response.isSuccess) {
                                this.retailSubscriptionPopup.close();
                                if (this.memberRetailSubscriptionDetail && this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel) {
                                    this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.emailAddress = response.emailAddress;
                                    this.retailSubscriptionLanguageId = response.retailLanguagesConfigID;
                                }
                                const notification: any = this._translatePipe.get('customer-service.Subscription updated successfully');
                                this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                            }
                            else {
                                if (response && response.validations && response.validations.length) {
                                    let addedNotification: any = this._translatePipe.get('errorcodes.' + response.validations[0].message);
                                    if( response.validations[0].name.toLowerCase() == Constants.NOT_EXIST.toLowerCase()){
                                        addedNotification = this._translatePipe.get('errorcodes.Shared Retail subscription details are not available for distributor {{distributorID}}',{distributorID:  memberRetailProgramSubscriptionModel && memberRetailProgramSubscriptionModel.distributorId?memberRetailProgramSubscriptionModel.distributorId:''});
                                    }
                                    if( response.validations[0].name.toLowerCase() == Constants.CHARGEBEE_ERROR.toLowerCase()){
                                        addedNotification = this._translatePipe.get('errorcodes.Shared Retail subscription details are not updated in chargeebee for retail subscription with id {{retail_subscrp_id}}',{retail_subscrp_id:  memberRetailProgramSubscriptionModel && memberRetailProgramSubscriptionModel.id?memberRetailProgramSubscriptionModel.id:''});
                                    }

                                    this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                                }
                            }
                        }, () => {
                            const addedNotification: any = this._translatePipe.get('errorcodes.Error occurred while updating the record');
                            this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                        });
                }
            } else {
                let memberRetailSubscriptionDetail: MemberRetailSubscriptionDetail = this.prepareRetailSubscriptionDetailModel();
                memberRetailSubscriptionDetail = { ...memberRetailSubscriptionDetail, supplier: this.getSupplierDetails() }
                this._retailSubscriptionService.createRetailSubscription(memberRetailSubscriptionDetail).subscribe(
                    (response: any) => {
                        if (response && response.isSuccess) {
                            this.memberRetailSubscriptionId = response.id;
                            this.isRetailSubscriptionLogin = true;
                            this.retailSubscriptionPopup.close();
                            if (this.memberRetailSubscriptionDetail && this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel) {
                                this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.id = response.memberRetailProgramSubscriptionModel.id;
                                this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.emailAddress = response.memberRetailProgramSubscriptionModel.emailAddress;
                                this.retailSubscriptionLanguageId = response.memberRetailProgramSubscriptionModel.retailLanguagesConfigID;
                                this.memberRetailSubscriptionDetail.subscriptionStatus = response.subscriptionStatus;
                                if (this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.id) {
                                    this.getRetailSubscriptionsById(this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.id);
                                }
                            }
                            if (this.isResubscribe) {
                                const notification: any = this._translatePipe.get('customer-service.Subscription renewal initiated successfully Renewal email has been sent');
                                this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                            }
                            else {
                                const notification: any = this._translatePipe.get('customer-service.Subscription initiated successfully Email with payment and terms conditions links were sent');
                                this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                            }
                            this.isResubscribe = false;
                        }
                        else {
                            if (response && response.validations && response.validations.length) {
                                let addedNotification: any = this._translatePipe.get('errorcodes.' + response.validations[0].message);
                                if( response.validations[0].name.toLowerCase() == Constants.ALREADY_IN_USE.toLowerCase()){
                                    addedNotification = this._translatePipe.get('errorcodes.Member already subscribed to shared retail subscription program with plan {{plancode}}',{plancode:  memberRetailSubscriptionDetail && memberRetailSubscriptionDetail.planCode?memberRetailSubscriptionDetail.planCode:''});
                                }
                                this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);
                            }
                        }
                    }, () => {
                        const addedNotification: any = this._translatePipe.get('errorcodes.Error occurred while saving the record');
                        this._commonService.createNotification('', addedNotification.value, NotificationType.ERROR);

                    });
            }
            this.retailSubscriptionPopup.close();
        }
    }

    getSupplierDetails() {
        let supplierDetails = " ";
        if (this.chargeBeePlan && this.chargeBeePlan.supplier) {
            if (this.chargeBeePlan.supplier.name) {
                supplierDetails = this.chargeBeePlan.supplier.name;
            }
            if (this.chargeBeePlan.supplier.addressLine1) {
                supplierDetails = supplierDetails + ', ' + this.chargeBeePlan.supplier.addressLine1;
            }
            if (this.chargeBeePlan.supplier.addressLine2) {
                supplierDetails = supplierDetails + ',' + this.chargeBeePlan.supplier.addressLine2;
            }
            if (this.chargeBeePlan.supplier.zipcode) {
                supplierDetails = supplierDetails +', ' + this.chargeBeePlan.supplier.zipcode;
            }
            if (this.chargeBeePlan.supplier.stateCode) {
                supplierDetails = supplierDetails  + this.chargeBeePlan.supplier.stateCode;
            }
            if (this.chargeBeePlan.supplier.city) {
                supplierDetails = supplierDetails + ', ' + this.chargeBeePlan.supplier.city;
            }
            if (this.chargeBeePlan.supplier.country) {
                supplierDetails = supplierDetails + ', ' + this.chargeBeePlan.supplier.country;
            }
            if (this.chargeBeePlan.supplier.vatNumber) {
                supplierDetails = supplierDetails + ','+ Constants.VAT_NUMBER + this.chargeBeePlan.supplier.vatNumber;
            }
            if (this.chargeBeePlan.supplier.commerceNo) {
                supplierDetails = supplierDetails + ' ,'+ Constants.COMMERCE_NUMBER + this.chargeBeePlan.supplier.commerceNo;
            }
        }
        return supplierDetails;
    }

    getRetailSubscriptionPlan(planId: number): void {
        this._retailSubscriptionService.getRetailSubscriptionPlan(planId).subscribe((subscriptionPlan: any) => {
            if (subscriptionPlan) {
                this.chargeBeePlan = subscriptionPlan;
                this.prepareRetailSubscriptionForm();
                this.buildRetailSubscritionForm();
            }
            else {
                this.prepareRetailSubscriptionForm();
                this.buildRetailSubscritionForm();
            }
        },
            error => {
                if (error) {
                    this.prepareRetailSubscriptionForm();
                    this.buildRetailSubscritionForm();
                }
            });
    }

    getRetailSubscriptionsById(id: number) {
        this._retailSubscriptionService.getRetailSubscriptionsById(id).subscribe((memberRetailSubscriptionDetails: MemberRetailSubscriptionDetail[]) => {
            if (memberRetailSubscriptionDetails) {
                this.memberRetailSubscriptionDetails = memberRetailSubscriptionDetails;
                this.showBillingHistoryLink = this.memberRetailSubscriptionDetails.some(memberRetailSubscriptionDetail => {
                    return memberRetailSubscriptionDetail.paymentCaptured;
                });
                this.showSubscriptionHistoryLink = this.memberRetailSubscriptionDetails.some(memberRetailSubscriptionDetail => {
                    return (memberRetailSubscriptionDetail.subscriptionStatus === this.subscriptionStatusEnum.Active || memberRetailSubscriptionDetail.subscriptionStatus === this.subscriptionStatusEnum.Cancelled);
                });
            }
        });
    }

    getChargeBeeLanguages(): void {
        this._retailSubscriptionService.getChargeBeeLanguages().subscribe((languages: any[]) => {
            if (languages) {
                this.languages = languages;
            }
        });
    }
    private setChargeBeeDetails(): void {
        this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.retailLanguageLocale = this.getLanguage(this.retailSubscriptionLanguageId);
        this.retailSubscriptionForm.controls['language'].patchValue(this.configId);
        if (this.chargeBeePlan && this.chargeBeePlan.price) {
            let subscriptionFee = this.currenyFormatValue(this.chargeBeePlan.price);
            this.retailSubscriptionForm.controls['annualSubscriptionFee'].patchValue(this.prepareChargebeePlanPrice());
        }
        this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.firstName = this.fboProfileDetail ? this.fboProfileDetail.firstName : '';
        this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.lastName = this.fboProfileDetail ? this.fboProfileDetail.lastName : '';
    }

    private prepareRetailSubscriptionDetailModel(): MemberRetailSubscriptionDetail {
        const memberRetailSubscriptionDetail: MemberRetailSubscriptionDetail = {
            memberRetailProgramSubscriptionModel: {
                id: null,
                firstName: this.retailSubscriptionForm.value.firstName,
                lastName: this.retailSubscriptionForm.value.lastName,
                distributorId: this.retailSubscriptionForm.value.fboId,
                memberId: this.fboProfileDetail ? this.fboProfileDetail.memberId : null,
                emailAddress: this.retailSubscriptionForm.value.email,
                retailLanguagesConfigID: this.retailSubscriptionForm.value.language,
                retailLanguageLocale: this.getLanguage(this.retailSubscriptionForm.value.language),
                periodsPurchased: 1,
                enrollmentCreatedDate: "",
                enrollmentModifiedDate: "",
                createdDate: "",
                createdBy: 1,
                updatedDate: "",
                updatedBy: "",
                rowStatus: 1
            },
            storeId:this.storeInfo?this.storeInfo.id:null,
            appPlanMapperId: this.chargeBeePlan ? this.chargeBeePlan.id : '',
            planCode: this.chargeBeePlan ? this.chargeBeePlan.code + '-' + this.chargeBeePlan.name.replace(/\s/g, '-') : '',
            operatingCompanyId: this.memberRetailSubscriptionDetail ? this.memberRetailSubscriptionDetail.operatingCompanyId : null,
            isVatAvailable: this.retailSubscriptionForm.value.taxId ? true : false,
            subscriptionStatus: 157,//pending
            subscriptionId: "",
            subscriptionStartDate: "",
            subscriptionEndDate: "",
            paymentCaptured: false,
            tandCAccepted: false,
            createdDate: "",
            createdBy: 1,
            updatedDate: "",
            updatedBy: "",
            rowStatus: 1,
            businessEntityId: this.retailSubscriptionForm.get('businessEntityId').value ? this.retailSubscriptionForm.get('businessEntityId').value : null,
            addressDetailId: this.retailSubscriptionForm.get('addressId').value ? this.retailSubscriptionForm.get('addressId').value : null,
            vatId: this.retailSubscriptionForm.get('taxId').value ? this.retailSubscriptionForm.get('taxId').value : null

        }
        return memberRetailSubscriptionDetail;
    }

    private prepareUpdateRetailSubscriptionModel(): MemberRetailProgramSubscriptionModel {
        if (this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel) { }
        const memberRetailProgramSubscriptionModel: MemberRetailProgramSubscriptionModel = {
            id: this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.id,
            firstName: this.retailSubscriptionForm.value.firstName,
            lastName: this.retailSubscriptionForm.value.lastName,
            distributorId: this.retailSubscriptionForm.value.fboId,
            memberId: this.fboProfileDetail ? this.fboProfileDetail.memberId : null,
            emailAddress: this.retailSubscriptionForm.value.email,
            retailLanguagesConfigID: this.retailSubscriptionForm.value.language,
            retailLanguageLocale: this.getLanguage(this.retailSubscriptionForm.value.language),
            periodsPurchased: 1,
            enrollmentCreatedDate: "",
            enrollmentModifiedDate: "",
            createdDate: "",
            createdBy: 1,
            updatedDate: "",
            updatedBy: "",
            rowStatus: 1,
            businessEntityId: this.retailSubscriptionForm.get('businessEntityId').value ? this.retailSubscriptionForm.get('businessEntityId').value : null,
            addressDetailId: this.retailSubscriptionForm.get('addressId').value ? this.retailSubscriptionForm.get('addressId').value : null,
            vatId: this.retailSubscriptionForm.get('taxId').value ? this.retailSubscriptionForm.get('taxId').value : null

        };
        return memberRetailProgramSubscriptionModel;
    }
    private prepareRetailSubscriptionForm(): void {

        if (!this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel) {
            this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel = new MemberRetailProgramSubscriptionModel();
            this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.firstName = this.fboProfileDetail ? this.fboProfileDetail.firstName : '';
            this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.lastName = this.fboProfileDetail ? this.fboProfileDetail.lastName : '';
            this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.distributorId = this.fboProfileDetail ? this.fboProfileDetail.fboId : '';
            this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.emailAddress = this.fboProfileDetail ? this.fboProfileDetail.email : '';
            this.memberRetailSubscriptionDetail.storeId = this.storeInfo?this.storeInfo.id:null;
            this.memberRetailSubscriptionDetail.appPlanMapperId = this.chargeBeePlan ? this.chargeBeePlan.id : '';
            this.memberRetailSubscriptionDetail.planCode = this.chargeBeePlan ? this.chargeBeePlan.code : '';
            this.memberRetailSubscriptionDetail.operatingCompanyId = this.storeInfo? this.storeInfo.businessEntityId:null;
            this.memberRetailSubscriptionDetail.subscriptionStatus = 157;
        }
    }

    private getRetailSubscriptionDetail(id: number): void {
        this._retailSubscriptionService.getRetailSubscriptionBasedOnId(id).subscribe((detail: any) => {
            if (detail && detail.isSuccess) {
                if (detail && detail.validations && detail.validations.length && (detail.validations[0].name.toLowerCase() === RetailSubscriptionErrorMessages.CHARGEBEE_ERROR.toLowerCase())) {
                    const addedNotification: any = this._translatePipe.get('errorcodes.' + detail.validations[0].message);
                    this.isSubscriptionCreatedInChargebee = detail.isSuccess;
                    this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value);
                }
                this.memberRetailSubscriptionDetail = detail;
                this.retailSubscriptionLanguageId = detail.memberRetailProgramSubscriptionModel.retailLanguagesConfigID;
            }
        });
    }

    resendSignupEmail(distributorId: string): void {
        this._retailSubscriptionService.resendSignupEmail(distributorId).subscribe((response) => {
            if (response && response.isSuccess) {
                const notification: any = this._translatePipe.get('customer-service.Sign up email has been resent');
                this.addConfirmationMessage(RetailSubscriptionMessages.successMessage, notification.value);
            } else {
                if (response && response.validations && response.validations.length && (response.validations[0].name.toLowerCase() === RetailSubscriptionErrorMessages.CHARGEBEE_ERROR.toLowerCase())) {
                    const addedNotification: any = this._translatePipe.get('errorcodes.' + response.validations[0].message);
                    this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value);
                } else {
                    this.resendSignupErrMessage();
                }
            }
        }, () => {
            this.resendSignupErrMessage();
        });
    }

    resendSignupErrMessage(): void {
        const addedNotification: any = this._translatePipe.get('errorcodes.Error occurred while resending the signup email for distributor id {{distributorId}}',
            {
                distributorId: this.fboProfileDetail ? this.fboProfileDetail.distributorId : ""
            });
        this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value);
    }

    sendAcceptTermsEmail(distributorId: string): void {
        if(this.memberRetailSubscriptionDetail && (this.memberRetailSubscriptionDetail.subscriptionStatus != this.subscriptionStatusEnum.Cancelled)){
        this._retailSubscriptionService.resendTermsAndConditionsEmail(distributorId).subscribe((response) => {
            if (response && response.isSuccess) {
                const notification: any = this._translatePipe.get('customer-service.Accept terms email has been sent');
                this.addConfirmationMessage(RetailSubscriptionMessages.successMessage, notification.value);
            } else {
                if (response && response.validations && response.validations.length && response.validations.length && (response.validations[0].name.toLowerCase() === RetailSubscriptionErrorMessages.CHARGEBEE_ERROR.toLowerCase())) {
                    const addedNotification: any = this._translatePipe.get('errorcodes.' + response.validations[0].message);
                    this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value);
                }
                else {
                    this.sendAcceptTermsErrMessage();
                }
            }
        }, () => {
            this.sendAcceptTermsErrMessage();
        });
    }
    }

    sendAcceptTermsErrMessage(): void {
        const addedNotification: any = this._translatePipe.get('errorcodes.Error occurred while resending the terms and conditions for distributor id {{distributorId}}',
            {
                distributorId: this.fboProfileDetail ? this.fboProfileDetail.distributorId : ""
            });
        this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value);
    }

    sendChangePaymentLinkEmail(distributorId: string): void {
        if(this.memberRetailSubscriptionDetail && (this.memberRetailSubscriptionDetail.subscriptionStatus != this.subscriptionStatusEnum.Cancelled)){
        this._retailSubscriptionService.sendPaymentChangeLinkEmail(distributorId).subscribe((response) => {
            if (response && response.isSuccess) {
                const notification: any = this._translatePipe.get('customer-service.Change payment email has been sent');
                this.addConfirmationMessage(RetailSubscriptionMessages.successMessage, notification.value);
            } else {
                if (response && response.validations && response.validations.length && (response.validations[0].name.toLowerCase() === RetailSubscriptionErrorMessages.CHARGEBEE_ERROR.toLowerCase())) {
                    const addedNotification: any = this._translatePipe.get('errorcodes.' + response.validations[0].message);
                    this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value);
                } else {
                    this.sendChangePaymentLinkErrMessage();
                }
            }
        }, () => {
            this.sendChangePaymentLinkErrMessage();
        });
    }
    }

    sendChangePaymentLinkErrMessage(): void {
        const addedNotification: any = this._translatePipe.get('errorcodes.Error occurred while sending payment change link for distributor id {{distributorId}}',
            {
                distributorId: this.fboProfileDetail ? this.fboProfileDetail.distributorId : ""
            });
        this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value);
    }

    cancelRenewalSubscription(distributorId: string): void {
        this.cancelRenewalPopup.close();
        let updatedBy;
        const userId = localStorage.getItem('appadmin.UserId')
        if (userId) {
            updatedBy = +userId;
        }
        this._retailSubscriptionService.cancelRenewalRetailSubscription(distributorId, updatedBy).subscribe((response) => {
            if (response.isSuccess) {
                const notification: any = this._translatePipe.get('customer-service.Subscription renewal has been cancelled');
                this.addConfirmationMessage(RetailSubscriptionMessages.successMessage, notification.value);
            }
            else {
                if (response && response.validations && response.validations.length && (response.validations[0].name.toLowerCase() === RetailSubscriptionErrorMessages.CHARGEBEE_ERROR.toLowerCase())) {
                    const addedNotification: any = this._translatePipe.get('errorcodes.' + response.validations[0].message);
                    this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value);
                } else {
                    this.cancelRenewalSubscriptionErrMessage();
                }
            }
        }, () => {
            this.cancelRenewalSubscriptionErrMessage();
        });
    }

    cancelRenewalSubscriptionErrMessage(): void {
        const addedNotification: any = this._translatePipe.get('errorcodes.Error occurred while cancelling subscription renewal for distributor id {{distributorId}}',
            {
                distributorId: this.fboProfileDetail ? this.fboProfileDetail.distributorId : ""
            });
        this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value);
    }

    cancelSubscription(distributorId: string): void {
        this.cancelSubscriptionPopup.close();
        let updatedBy;
        if (localStorage.getItem('appadmin.UserId')) {
            updatedBy = +(localStorage.getItem('appadmin.UserId'));
        }
        this._retailSubscriptionService.cancelRetailSubscription(distributorId, updatedBy).subscribe((response) => {
            if (response.isSuccess) {
                const notification: any = this._translatePipe.get('customer-service.Subscription has been cancelled');
                this.addConfirmationMessage(RetailSubscriptionMessages.successMessage, notification.value);
                this.retailSubscriptionForm.controls['subscriptionStatus'].patchValue(SubscriptionStatusEnum[this.subscriptionStatusEnum.Cancelled]);
                this.memberRetailSubscriptionDetail.subscriptionStatus = this.subscriptionStatusEnum.Cancelled;
                this.showSubscriptionHistoryLink = false;
            }
            else {
                if (response && response.validations && response.validations.length && (response.validations[0].name.toLowerCase() === RetailSubscriptionErrorMessages.CHARGEBEE_ERROR.toLowerCase())) {
                    const addedNotification: any = this._translatePipe.get('errorcodes.' + response.validations[0].message);
                    this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value);
                } else {
                    this.cancelSubscriptionErrMessage();
                }
            }
        }, () => {
            this.cancelSubscriptionErrMessage();
        });
    }

    cancelSubscriptionErrMessage(): void {
        const addedNotification: any = this._translatePipe.get('errorcodes.Error occurred while cancelling the subscription for distributor id {{distributorId}}',
            {
                distributorId: this.fboProfileDetail ? this.fboProfileDetail.distributorId : ""
            });
        this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value);
    }

    private getVatId(): string {
        if(!this.memberGovernmentIdentifiations && !this.memberGovernmentIdentifiations.length  && this.fboProfileDetail && this.fboProfileDetail.memberId){
            this.getMembergovernmentIdentificationsInfo(this.fboProfileDetail.memberId);
         }
        if (this.memberGovernmentIdentifiations.length && this.fboProfileDetail.homeCountryId) {
            const memberGovernmentIdentifiation = this.memberGovernmentIdentifiations.find(x => x.governmentIdentificationType === 'VAT ID' && x.countryID === this.fboProfileDetail.homeCountryId);
            if (memberGovernmentIdentifiation && memberGovernmentIdentifiation.value) {
                this.vatId = memberGovernmentIdentifiation.value;
            }
        }
        else {
            if (this.fboBusinessEntity.incomeTaxID) {
                this.vatId = this.fboBusinessEntity.incomeTaxID;
            }
        }
        return this.vatId || null;
    }

    public getLanguage(languageId?: number): string {
        if (languageId) {
            const language = this.languages ? this.languages.find(x => x.id === languageId) : '';
            if (language && language.languageCulture) {
                this.configId = language.id;
                return this.languageLocale = language.languageCulture;
            }
        }
        else if (this.languagecode) {
            const language = this.languages ? this.languages.find(x => x.languageCulture.toUpperCase() === this.languagecode.toUpperCase()) : '';
            if (language && language.id) {
                this.configId = language.id;
                return this.languageLocale = language.languageCulture;
            }
            else {
                this.configId = '';
            }
        }
    }

    private getCountryById(countryId: number): string {
        if (countryId && this.countries && this.countries.length) {
            const countryInfo = this.countries.find((country: any) => country.countryId === countryId);
            return countryInfo && countryInfo.name ? countryInfo.name : '';
        }
    }

    private addConfirmationMessage(className: string, message: string) {
        if (className && message) {
            this.showConfirmationMessage = true;
            this.confirmationClass = className;
            this.confirmationMessage = message;
            $('.retail-subscription .modal.in').animate({ scrollTop: 0, scrollLeft: 0 }, 'slow');
            if(this.isSubscriptionCreatedInChargebee != null && !this.isSubscriptionCreatedInChargebee){
                setTimeout(() => {
                    this.showConfirmationMessage = false;
                    this.confirmationClass = null;
                    this.confirmationMessage = null;
                }, 10000);
            }
        }
    }
    getChargeBeeConfiguration() {
        const src = 'https://js.chargebee.com/v2/chargebee.js';
        const script = document.createElement('script');
        if (script) {
            script.setAttribute('src', src);
            document.head.appendChild(script);

        }
        script.onload = () => {
            Chargebee.init({
                site: environment.chargebeeSiteName,
                publishableKey: environment.chargebeePublishableKey
            });
        }
    }
    openBillingHistory() {
        this._cacheService.set(CacheKey.IsRefreshed, true);
        const customerId = this.fboProfileDetail.fboId;
        return this._retailSubscriptionService.createChargeBeeSession(customerId).subscribe((res) => {
            if (res) {
                this.openChageBeePopUp(res);
            } else {
                this._commonService.createNotification('', res.validations[0].message, NotificationType.ERROR);
            }
        }, error => {
            this._commonService.createNotification('', error.validations[0].message, NotificationType.ERROR);
        });
    }
    openChageBeePopUp(response) {
        const chargebeeInstance = Chargebee.getInstance();
        chargebeeInstance.setPortalSession(response);
        const cbPortal = chargebeeInstance.createChargebeePortal();
        cbPortal.openSection({
            sectionType: Chargebee.getPortalSections().BILLING_HISTORY
        });
    }

    openViewSubscriptionHistory() {
        if (this.showSubscriptionHistoryLink && this.memberRetailSubscriptionDetail && this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel
            && this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.id) {
            this.retailSubscriptionHistoryResponse = [];
            this.loadRetailSubscriptionHistory = [];
            const retailSubscriptionId: number = +this.memberRetailSubscriptionDetail.memberRetailProgramSubscriptionModel.id
            this._retailSubscriptionService.getRetailSubscriptionHistory(retailSubscriptionId).subscribe(response => {
                if (response.isSuccess && !!response.subscriptionHistoryModelList.length) {
                    this.retailSubscriptionHistoryResponse = [...response.subscriptionHistoryModelList]
                    this.loadMore();
                    this.viewSubscriptionHistoryPopup.open();
                }
                else {
                    if (!response.isSuccess && !!response.validations.length) {
                        const addedNotification: any = this._translatePipe.get('errorcodes.Error occurred while retrieving subscription history');
                        this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value);
                    }
                }
            }, error => {
                const addedNotification: any = error && error.validations && !!error.validations.length ? this._translatePipe.get('errorcodes.' + error.validations[0].message) : this._translatePipe.get('errorcodes.Error occurred while retrieving subscription history');
                this.addConfirmationMessage(RetailSubscriptionMessages.failureMessage, addedNotification.value ? addedNotification.value : RetailSubscriptionMessages.Error_while_retriving_data_from_Retail_Subscription_History);
            })
        }
    }

    closeViewSubscriptionHistory() {
        this.viewSubscriptionHistoryPopup.close();
    }

    loadMore() {
        if (!!this.retailSubscriptionHistoryResponse.length && (this.loadRetailSubscriptionHistory.length != this.retailSubscriptionHistoryResponse.length)) {
            let res = [];
            for (let i = this.loadRetailSubscriptionHistory.length; i < (this.loadRetailSubscriptionHistory.length + this.skipCount); i++) {
                if (!this.retailSubscriptionHistoryResponse[i]) break;
                res.push(this.retailSubscriptionHistoryResponse[i])
            }
            this.loadRetailSubscriptionHistory = [...this.loadRetailSubscriptionHistory, ...res];
            this.navigateToSubscriptionMessages((this.loadRetailSubscriptionHistory.length - 1).toString())
        }
    }

    navigateToSubscriptionMessages(idName: string) {
        setTimeout(() => {
            let el = document.getElementById(idName);
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 500)

    }

    /**
     * To Get Currency Value for the price
     */
     get currenyFormatValue() {
        return (value: any) => {
            if (this.storeInfo) {
                value = this._currencyPipe.getCurrencyFormat(this.storeInfo, this.storeInfo.currencyFormatCode, value);
                return value;
            }
            return value;
        };
    }

    showAccountRestrictionPopup(){
        const fboId = this.fboProfileDetail ? this.fboProfileDetail.fboId : null;
        this._retailSubscriptionService.getAccountStatus(fboId).subscribe(
            (response) => {
                if( response && response.status === AccountRestrictionStatus.RESTRICTED){
                    this.isAccountChecked = true;
                } else {
                    this.isAccountChecked = false;
                }
            })
        this.accountRestrictionModal.open();
    }

    submitAccountRestrictionPopup(event: any){
        if(event === 'Checked'){
            this.accountStatus = AccountRestrictionStatus.RESTRICTED;
        } else {
            this.accountStatus = AccountRestrictionStatus.UN_RESTRICTED;
        }
        const accountRestrictionData = {
            distributorID: this.fboProfileDetail ? this.fboProfileDetail.fboId : null,
            status: this.accountStatus,
            createdBy: this.userId,
            updatedBy: this.userId,
            rowStatusID: 1
        };
        this._retailSubscriptionService.accountRestriction(accountRestrictionData).subscribe(
            (response) => {
                    this._commonService.createNotification('', 'Account has been Updated Successfully', NotificationType.SUCCESS);
                    this.cancelAccountRestrictionPopup();
            });
    }

    cancelAccountRestrictionPopup(){
        this.accountRestrictionModal.close();
    }

    isFpcUser() {
        if (this.memberType && (this.memberType.toLowerCase() == MemberType.PREFERREDCUSTOMER.toLowerCase() || this.memberType.toLowerCase() == MemberType.FPC.toLowerCase() || this.memberType.toLowerCase() === MemberType.PREFERRED_CUSTOMER.toLowerCase())) {
            this.isPrefferedCustomer = true;
        }
    }
    openBondedWarehouseProjectModal() {
        this.bondedWarehouseProjectModal.open();
        this.bwpDisableMessage = true;
        this.checkVatIdAndBusinessEntityIdExist();
        this.bondedWarehouseProjectSelected = this.prevBondedWarehouseProjectSelected;
    }
    submitBondedWarehouseProject() {
        if (this.bondedWarehouseProjectSelected !== this.prevBondedWarehouseProjectSelected) {
            if (this.storeInfo && this.storeInfo.bwpEnabled) {
                const memberMedaDataModel: MemberMetaData[] = [];
                memberMedaDataModel.push({
                    id: null,
                    memberId: this.fboProfileDetail.memberId,
                    customKey: MemberMetaDataEnum.BWPENABLED,
                    customValue: this.bondedWarehouseProjectSelected ? BondedWarehouseProjectValue.SELECTED : BondedWarehouseProjectValue.UN_SELECTED,
                    keyValueDescription: null
                });
                this._enrollService.updateBondedWarehouseProject(this.fboProfileDetail.memberId, memberMedaDataModel).subscribe(
                    (response) => {
                        if (response && response.isSuccess) {
                            if (this.bwpDisableMessage) {
                                this._commonService.createNotification('', 'Bonded Warehouse Project Updated Successfully', NotificationType.SUCCESS);
                            }
                            this.closeBWPModal();
                            this.prevBondedWarehouseProjectSelected = this.bondedWarehouseProjectSelected;
                        }
                        else {
                            this._commonService.createNotification('', 'Updated Failed', NotificationType.ERROR);
                            this.closeBWPModal();
                        }
                    });
            }
        }
    }
    closeBWPModal() {
        this.bondedWarehouseProjectModal.close();
    }
    checkVatIdAndBusinessEntityIdExist() {
        if (((this.fboBusinessEntity && this.fboBusinessEntity.status === RowStatus.Active) && (this.fboBusinessEntity.countryCodeId === this.fboProfileDetail.homeCountryId) ||
            (this.memberGovernmentIdentifiations && this.memberGovernmentIdentifiations.find(element => (element.countryID === this.fboProfileDetail.homeCountryId))))) {
            this.disableBondedWarehouseProject = true;
            this.prevBondedWarehouseProjectSelected = false;
            this.bwpDisableMessage = false;
        }else{
            this.disableBondedWarehouseProject = false;
        }
    }
    checkBondedWarehouseProject(governmentIdForm?: any, isValid?: boolean) {
        if (this.vatIdBWP) {
            const governmentIdentificationForm: any = this.updateGovIDForm.get('govermentIdentification');
            const country = governmentIdentificationForm.value.find(elements => elements.country == this.homeCountry);
            if ((!this.disableBondedWarehouseProject && this.prevBondedWarehouseProjectSelected) && country) {
                this.bwpConfirmationModal.open();
            }
            else {
                this.checkGovernmentIdValue(governmentIdForm, isValid);
            }
        }
        else if (this.businessEntityBWP) {
            if (!this.disableBondedWarehouseProject && this.prevBondedWarehouseProjectSelected && ((this.businessEntityForm.value.countryCodeId === this.homeCountryId)) && this.businessEntityForm.value.status === RowStatus.Active.toString()) {
                this.bwpConfirmationModal.open();
            }
            else {
                this.checkBusinessEntitySubmit();
            }
        }
    }
    submitBWPConformation() {
        if (this.vatIdBWP) {
            this.checkGovernmentIdValue(this.updateGovIDForm.value, this.updateGovIDForm.valid);
            this.bwpConfirmationModal.close();
        }
        else if (this.businessEntityBWP) {
            this.checkBusinessEntitySubmit();
            this.bwpConfirmationModal.close();
        }
    }
    cancelBWPConformation() {
        this.bwpConfirmationModal.close();
    }

    checkMemberHomeCountryTitanEnabledcountry(homeCountry : any){
         if(this.titanEnabledCountries && this.titanEnabledCountries.find(country => country.isocodeThree == homeCountry)){
            this.updateAccessToTitanCounty = true;
        }else{
            this.updateAccessToTitanCounty = !(this.fboProfileDetail.memberTypeId === this.memberTypeEnum.FPC || this.fboProfileDetail.memberTypeId ===this.memberTypeEnum.DISTRIBUTOR );
        }
    }

    populateTransliterateObj(){
            const languageCode = this._commonService.getMemberPrefferedLanguage(this.fboProfileDetail, this.storeInfo);
            return {...this._commonService.mapTransliterateProperties(this.storeInfo, languageCode)};
    }

    getMembergovernmentIdentificationsInfo(memberId: number) {
        if(memberId){
            this._customerservice.getMembergovernment_identifications(this.fboProfileDetail.memberId).subscribe(response=>{
              if(response && response.memberGovernmentIdentificationModel){
                this.memberGovernmentIdentifiations = response.memberGovernmentIdentificationModel;
              }else{
                this.memberGovernmentIdentifiations = [];
              }
            });
        }

    }

    getMemberBusinessEntityInfo(memberId: number,countryCode : string, prefferedLanguageId:number ):any{
        this._customerService.getMemberbusinessEntity(memberId,countryCode,prefferedLanguageId).subscribe(res=>{
            if(res){
                if(res.startDate){
                    res.startDate =  moment(res.startDate, 'DD-MM-YYYY').format('DD-MMM-YYYY');
                }
                this.fboBusinessEntity = res;
            }
            return res;
        });
    }

  downloadImageFromUrl(url: any) {
    let hostname :string = new URL(url).hostname;
    if (hostname !== CommonConstant.AS400ProfileImageURL ) {
      let path = new URL(url).pathname.slice(1);
      let s3Path = path.slice(0, path.lastIndexOf("/") + 1);
      let fileName = url.substring(url.lastIndexOf('/') + 1);
      let folderName: string = s3Path + fileName;
      let cdnURL = JSON.parse(this._cacheService.get(CacheKey.CDNurlForProfileImage)) != null ? new Map(JSON.parse(this._cacheService.get(CacheKey.CDNurlForProfileImage))) : new Map();
      let isProfileImageAvailable = this.checkValidityForSignedURL(cdnURL, this.fboid);
      if (isProfileImageAvailable === true) {
        this.profileImage = new Map(JSON.parse(this._cacheService.get(CacheKey.CDNurlForProfileImage))).get(this.fboid).toString();
      }
      else {
        this._customerService.generateProfileImageSignedCDNURL(folderName)
          .subscribe((response) => {
            if (response.isSuccess === true && response.validations.length === 0 && response.data != null) {
              this.profileImage = response.data[folderName];
              cdnURL.set(this.fboid, this.profileImage);
              this._cacheService.set(CacheKey.CDNurlForProfileImage, JSON.stringify(Array.from(cdnURL.entries())));
            }
            else {
              this.profileImage = this.getStaticImageUrl();
              const notificationMessage = 'Could not load profile picture, Please try after some time';
              this._commonService.createNotification('', notificationMessage, NotificationType.ERROR);
            }
          }, error => {
            this.profileImage = this.getStaticImageUrl();
            const notificationMessage = 'Could not load profile picture, Please try after some time';
            this._commonService.createNotification('', notificationMessage, NotificationType.ERROR);
          });
      }
    }
  }

    checkValidityForSignedURL(cdnURL:any,folderName:string):boolean{
      let result :boolean = false;

      if(cdnURL !=null && cdnURL.has(folderName) === true ){
        let expirytimeFromParam :any =  new URL(cdnURL.get(folderName)).searchParams.get("Expires");
        let expiryTime :Date= new Date(expirytimeFromParam * 1000);
        result = (expiryTime.getTime() > new Date().getTime()) ;
      }
      return result;
    }

    createUserDetailsInFlp360Realm() {
      this._customerService.createUserInFlp360Realm(this.fboid).subscribe((response) => {
        if(response && response.isSuccess) {
          this.isUserCreatedInKeycloak = true;
        }
      }, error => {

      });
    }

}




// WEBPACK FOOTER //
// ./src/app/customerservice/components/fboprofile.component.ts